import { extractCantripScaling } from '../../../shared/rules/cantripScaling.mjs';
import { withCatalogDice } from '../utils/legacySpellDice';
import { BREATH_WEAPON_SAVE, BREATH_WEAPON_SHAPE_TEXT, breathWeaponDefinition } from '../../../shared/rules/dragonbornBreath.mjs';
import { mergeSpeciesResources } from '../../../shared/rules/speciesResources.mjs';
import { GIANT_ANCESTRY_ID } from '../../../shared/rules/speciesTraits.mjs';
import { claimGiantAncestry, spendCloudsJaunt } from '../utils/speciesUseService';
import {canOfferOpenHand,openHandDecision,canOfferQuiveringPalm,quiveringPalmDecision,activeQuiveringPalm,QUIVERING_PALM} from '../../../shared/rules/monkOpenHand.mjs';
import {UNARMED_OPTIONS,grappleBlocksWeaponHands,canOfferPunchAndGrab,punchAndGrabDecision} from '../../../shared/rules/unarmedOptions.mjs';
import {canOfferStunningStrike,stunningStrikeDecision} from '../../../shared/rules/monkStunningStrike.mjs';
import UncannyMetabolismPrompt from '../components/UncannyMetabolismPrompt';
import PersistentRagePrompt from '../components/PersistentRagePrompt';
import HeroicInitiativePrompt from '../components/HeroicInitiativePrompt';
import RelentlessRagePrompt from '../components/RelentlessRagePrompt';
import IntimidatingPresenceControls from '../components/IntimidatingPresenceControls';
import MonkActionControls, { submitMonkAction, monkAttackCacheKey, readMonkAttack, saveMonkAttack, setMonkAttackRunning } from '../components/MonkActionControls';
import { getMonkLevel, canUseMartialArts, isMonkWeapon, monkDamage, mergeMonkFocus, hasMonkFeature } from '../../../shared/rules/monk.mjs';
import { captureMultiattackRoll, multiattackRequest } from '../utils/enemyMultiattackService';
import { confirmedDirectSpellAttackCount, directSpellAttackResolutionId, reconcileNativeMultiattackCast } from '../utils/directSpellCastIdentity';
import { useCombatantName } from '../components/CombatantNamesContext';
import { hasBerserkerFrenzy } from '../../../shared/rules/berserkerFrenzy.mjs';
import { recklessWindow, resolveRecklessActorId } from '../../../shared/rules/recklessAttack.mjs';
import { getClassLevel } from '../../../shared/rules/classIdentity.mjs';
import { FORGO_ALL_ADVANTAGE } from '../utils/advantageSuppression';
import { FAVORED_ENEMY_GRANT_ID, HUNTERS_MARK_SPELL_ID, hasRangerFeature } from '../../../shared/rules/ranger.mjs';
import { claimBerserkerFrenzy, commitRecklessAttack, readPendingBarbarianAttack, savePendingBarbarianAttack } from '../utils/recklessAttackService';
import { rageSpellcastingBlockReason } from '../../../shared/rules/barbarianRage.mjs';
import RageControls from '../components/RageControls';
import ChampionMovementTrigger from '../components/ChampionMovementTrigger';
import {hasRemarkableAthlete, isCriticalAttackRoll} from '../../../shared/rules/champion.mjs';
import TacticalMindControls from '../components/TacticalMindControls';
import ActionSurgeControls from '../components/ActionSurgeControls';
import SecondWindControls from '../components/SecondWindControls';
import WholenessOfBodyControls from '../components/WholenessOfBodyControls';
import LayOnHandsControls from '../components/LayOnHandsControls';
import ChannelDivinityControls from '../components/ChannelDivinityControls';
import ClericChannelDivinityControls from '../components/ClericChannelDivinityControls';
import DivineInterventionControls from '../components/DivineInterventionControls';
import SculptSpellsPrompt from '../components/SculptSpellsPrompt';
import { areHostile } from '../../../shared/creatureDisposition';
import WizardPassiveTiles from '../components/WizardPassiveTiles';
import { canOverchannel, overchannelDice, sculptSpellsLimit } from '../../../shared/rules/wizard.mjs';
import { maximizedDamageDice } from '../../../shared/rules/effects/saveDamageResolution.mjs';
import AlwaysPreparedSpellControls, { spellsWithPreparedTile } from '../components/AlwaysPreparedSpellControls';
import useSpellRecallNotice from '../hooks/useSpellRecallNotice';
import ClericPassiveTiles from '../components/ClericPassiveTiles';
import { domainSpellGrantId, getLifeDomainSpells } from '../../../shared/rules/subclasses/cleric/life.mjs';
import HolyNimbusControls from '../components/HolyNimbusControls';
import PaladinPassiveTiles from '../components/PaladinPassiveTiles';
import FighterPassiveTiles from '../components/FighterPassiveTiles';
import MonkPassiveTiles from '../components/MonkPassiveTiles';
import RoguePassiveTiles from '../components/RoguePassiveTiles';
import RangerPassiveTiles from '../components/RangerPassiveTiles';
import RangerActionControls from '../components/RangerActionControls';
import { applySuperiorHuntersPrey, createSuperiorHuntersPreyDecision, superiorHuntersPreyTargets } from '../classFeatures/ranger/superiorHuntersPrey';
import { huntersMarkDieSides } from '../../../shared/rules/ranger.mjs';
import useDivineSenseNotice from '../hooks/useDivineSenseNotice';
import { getDevotionOathSpells, oathSpellGrantId, getSacredWeaponEffect, sacredWeaponAttackBonus, sacredWeaponDamage } from '../../../shared/rules/subclasses/paladin/devotion.mjs';
import FavoredEnemyControls from '../components/FavoredEnemyControls';
import ClassCantripControls from '../components/ClassCantripControls';
import ActiveSpellTiles from '../components/ActiveSpellTiles';
import ChainTargetPrompt from '../components/ChainTargetPrompt';
import { passTargetingBlock } from '../components/WardSavePrompt';
import MagicInitiateSpellControls from '../components/MagicInitiateSpellControls';
import { activeRecipientBuff, getBuffSkillDiceModifiers, magicWeaponBonus } from '../../../shared/rules/effects/buffModifiers.mjs';
import FiendishLegacySpellControls from '../components/FiendishLegacySpellControls';
import RollLogTab from '../components/RollLogTab';
import { describeAttackResolution, describeDamagePart, describeHealing } from '../utils/rollLogFormat';
import HuntersMarkMovePrompt from '../components/HuntersMarkMovePrompt';
import useExtraAttackNotice from '../hooks/useExtraAttackNotice';
import useHuntersLoreNotice from '../hooks/useHuntersLoreNotice';
import { archeryAttackBonus, greatWeaponFightingApplies, fightingStyleDamageDie, hasFightingStyle, hasTacticalMaster, tacticalMasteryChoice, TACTICAL_MASTER_PROPERTIES } from '../../../shared/rules/fighter.mjs';
import { getStyleCantripGrants } from '../../../shared/rules/fightingStyle.mjs';
import { MAGIC_INITIATE_LISTS, getMagicInitiateGrants } from '../../../shared/rules/magicInitiate.mjs';
import { PEERLESS_AIM_FEATURE_ID, canUseFate, canUsePeerlessAim, fateDecision, peerlessAimDecision } from '../../../shared/rules/epicBoons.mjs';
import EpicBoonTiles from '../components/EpicBoonTiles';
import { spendBlinkSteps } from '../utils/epicBoonService';
import { hasShillelagh, isShillelaghWeapon, shillelaghDamage } from '../../../shared/rules/effects/shillelagh.mjs';
import FastHandsControls from '../components/FastHandsControls';
import { formatResistanceReduction } from '../../../shared/rules/effects/resistanceDamage.mjs';
import { getRollDiceModifiers, modifierDiceTotal, modifierDiceBreakdown, modifierDiceRecords } from '../../../shared/rules/effects/rollDiceModifiers.mjs';
import BuffSpellControls from '../components/BuffSpellControls';
import { getBuffSpellDefinition } from '../../../shared/rules/effects/buffSpellDefinitions.mjs';
import PotionControls from '../components/PotionControls';
import QuickAttackControls from '../components/QuickAttackControls';
import useQuickAttacks, { canPinAttack, isAutoTile, shownAttackIds } from '../hooks/useQuickAttacks';
import HealingSpellControls from '../components/HealingSpellControls';
import { describeHealingAmount, getHealingSpellDefinition } from '../../../shared/rules/effects/healingSpellDefinitions.mjs';
import { getDirectSpellDefinition, directSpellDamage, directSpellAttackCount } from '../../../shared/rules/effects/directSpellDefinitions.mjs';
import { minimumFootprintDistanceFeet } from '../utils/pushGeometryCore.mjs';
import { resolveWeaponAttackRange } from '../../../shared/rules/weaponRange.mjs';
import { effectSize } from '../../../shared/rules/speciesTraits.mjs';
import { AMMUNITION_TYPES, weaponAmmunitionType, remainingAmmunition, recoverableAmmunition } from '../../../shared/rules/ammunition.mjs';
import { applyDamageTypeTraits } from '../../../shared/rules/damage/damageTypeTraits.mjs';
import { initialAreaDamage } from '../utils/initialAreaDamage';
import { SPELL_DAMAGE_FEEDBACK_EVENT, SPELL_DAMAGE_LOG_EVENT, SPELL_DAMAGE_ROLLED_EVENT } from '../hooks/useSpellDamageFeedback';
import { FLAMING_SPHERE_DEFINITION, WEB_DEFINITION, MOONBEAM_DEFINITION, CLOUDKILL_DEFINITION, INSECT_PLAGUE_DEFINITION, CALL_LIGHTNING_DEFINITION, SPIRIT_GUARDIANS_DEFINITION, CONJURE_WOODLAND_BEINGS_DEFINITION, INCENDIARY_CLOUD_DEFINITION } from '../../../shared/rules/effects/persistentSpellDefinitions.mjs';
import { getClassCastingProfile } from '../../../shared/rules/classSpellcasting.mjs';
import React, {
  useState,
  useEffect,
  useImperativeHandle,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import { createPortal } from 'react-dom';
import { Button, Modal, Card, Form } from "react-bootstrap";
import { Activity, ArrowDownToLine, ArrowRightToLine, Crosshair, EyeOff, Footprints, Gauge, Hand, HandGrab, Sword } from 'lucide-react';
import { actionIcon } from '../utils/actionIcons';
import spellsData from '../../../data/spells';
import { getExecutableSaveDamageDefinitionForSpell, damageForCastLevel } from '../../../shared/rules/effects/saveDamageDefinitions.mjs';
import { formatCastLevelDamage, formatSaveDamageTargeting } from '../../../shared/rules/effects/saveDamagePresentation.mjs';
import { isAuthoritativeSaveDamageAccess, rollSaveDamageEvidence } from '../utils/saveDamageActivation';
import UpcastModal from './UpcastModal';
import SpellControlsBar from '../components/SpellControlsBar';
import spellControlStyles from '../components/SpellAreaPreview.module.scss';
import proficiencyBonus from '../../../utils/proficiencyBonus';
import { normalizeEquipmentMap } from './equipmentNormalization';
import { normalizeWeapons } from './inventoryNormalization';
import weaponPropertyDefinitions from '../../../data/weaponProperties';
import weaponMasteryDefinitions from '../../../data/weaponMasteries';
import { hasWeaponMastery, normalizeWeaponKey } from '../utils/weaponMastery';
import { consumeVexAttackRoll, createVexOnHit } from '../utils/vexStateService';
import { consumeStudiedAttackRoll, markStudiedOnMiss } from '../utils/studiedAttacksService';
import { createSlowOnHit } from '../utils/slowStateService';
import { consumeSapAttackRoll, createSapOnHit } from '../utils/sapStateService';
import { applyPushOnHit } from '../utils/pushStateService';
import { resolveTargetedSave as resolveTargetedSaveResult } from '../utils/combatSavingThrows';
import { commitTargetedCombatSave } from '../utils/combatSaveStateService';
import { commitDirectSpellHit, spendTurnResource, commitCunningAction, commitSteadyAim, commitWeaponAttack, consumeSteadyAimAttack, resolveCunningActionHide } from '../utils/actionEconomyService';
import { abilityDamageModifier, getLightExtraAttackEligibility, getWeaponAttackModeAvailability, getWeaponInstanceId, lightDamageAbilityModifier } from '../utils/lightExtraAttack';
import { CLEAVE_DAMAGE_POLICY, createCleaveDecision, getCleaveCandidateIds, qualifiesForCleave } from '../utils/weaponMasteryCleave';
import { createHordeBreakerDecision, getHordeBreakerCandidateIds, qualifiesForHordeBreaker } from '../utils/hordeBreaker';
import weaponTypeMasteries from '../../../data/weaponTypeMasteries';
import { rollSkillWithDiceBox, resolveAbilityCheckRollMode } from './Skills';
import { getSkillTraining, resolveAbilityCheckDie } from '../../../shared/rules/abilityChecks.mjs';
import { withIndomitableMight } from '../../../shared/indomitableMight';
import DamageDiceCanvas from './DamageDiceCanvas';
import DiceRollerModal from '../common/DiceRollerModal';
import {
  clearDiceBoxResults,
  DICE_BOX_ROLL_SURFACE_EVENT,
  rollDiceWithBox,
  setDiceBoxThemeColor,
} from '../../../utils/diceBoxManager';
import { ROLL_DISPLAY_MS } from '../../../utils/rollDisplay';
import {
  collectRollValues,
  normalizeRollValue,
  sanitizeRollGroup,
} from '../../../utils/diceResults';
import {
  applyDiceFaceColor,
  DEFAULT_DICE_COLOR,
  normalizeDiceColor,
  resolveDamageTypeColor,
  DIE_COLOR_BY_CATEGORY,
} from '../../../utils/diceColors';
import { brutalStrikeDiceCount, brutalStrikeUsedThisTurn, getBrutalStrikePendingEffect, getFrenzyDamageDice, getRageDamageBonus, isBrutalStrikeEligibleAttack, markBarbarianAttackRoll, resolveAttackRollMode } from '../utils/barbarian';
import { getAttackRollMode, resolveAttack } from '../utils/attackResolution';
import { attackThroughDoor, getAttackCover } from '../utils/weaponRangeAttack';
import { describeTarget, spellRangeFeet, targetTone, weaponRangeRings } from '../utils/targetingPreview';
import {
  buildDamageComponentDiceRequests,
  rollDamageComponents,
} from '../utils/attackFeatureContracts';
import { createPlayerAttackFeatureIntegration } from '../classFeatures/playerAttackIntegration';
import { claimFeatureUsage, claimDivineSmite } from '../classFeatures/featureUsageService';
import { SAVAGE_ATTACKER_FEATURE_ID } from '../classFeatures/feats/savageAttacker';
import { DIVINE_SMITE_FEATURE_ID, FAITHFUL_STEED_GRANT_ID } from '../../../shared/rules/paladin.mjs';
import FaithfulSteedControls from '../components/FaithfulSteedControls';
import FeatureDecisionModal from '../classFeatures/FeatureDecisionModal';
import { getResolvedAttackDisplayValue } from '../utils/attackDisplay';
import { notify } from '../../../utils/notification';
import apiFetch from '../../../utils/apiFetch';
import { resolveCombatantArmorClass } from '../utils/characterMetrics';
import { cachedOpportunityRoll } from '../utils/opportunityRollCache';
import OpportunityAttackPrompt from '../components/OpportunityAttackPrompt';
import GeneralMovementActions from '../components/GeneralMovementActions';
import { getStealthCheckBonus, hasCunningAction } from '../classFeatures/rogue/cunningAction';
import { getSteadyAimAdvantage, hasMovedThisTurn, hasSteadyAim } from '../classFeatures/rogue/steadyAim';
import { CUNNING_STRIKE_EFFECTS } from '../classFeatures/rogue/cunningStrike';
import { CUNNING_STRIKE_FAILURE_TEXT } from '../../../shared/rules/cunningStrike.mjs';
import SpeciesActionControls from '../components/SpeciesActionControls';
import { canUseStrokeOfLuck, strokeOfLuckDecision } from '../../../shared/rules/rogue.mjs';
import { offerSaveRescue } from '../utils/strokeOfLuckPrompt';
import { claimStrokeOfLuck, withStrokeOfLuck } from '../utils/strokeOfLuckService';
import { offerHeroicDieReroll, rerollWithHeroicInspiration } from '../utils/heroicInspirationService';
import { spendFateOnRoll } from '../utils/boonOfFateService';
import { spendBardicDieOnRoll, spendPeerlessSkillOnRoll } from '../utils/bardicInspirationService';
import { bardicDieDecision, getBardicInspirationProfile, getWordsOfCreationSpells, heldBardicDie, wordsGrantId } from '../../../shared/rules/bard.mjs';
import { canUsePeerlessSkill, discoveryGrantId, getMagicalDiscoveries, hasLoreFeature, peerlessSkillDecision, peerlessSkillResultDecision } from '../../../shared/rules/subclasses/bard/lore.mjs';
import CuttingWordsTile from '../components/CuttingWordsTile';
import BardicInspirationControls from '../components/BardicInspirationControls';
import BardPassiveTiles from '../components/BardPassiveTiles';
import DruidPassiveTiles from '../components/DruidPassiveTiles';
import WildShapeControls from '../components/WildShapeControls';
import LandsAidControls, { NaturesSanctuaryTile } from '../components/LandsAidControls';
import { SANCTUARY_AREA, SANCTUARY_RANGE_FEET } from '../../../shared/rules/sanctuary';
import { getLandSpells, landSpellGrantId } from '../../../shared/rules/subclasses/druid/land.mjs';
import { applyWildShapeUpdate, druidCantripRangeFeet, isDruidSpellSource, potentSpellcastingBonus as druidPotentBonus } from '../../../shared/rules/druid.mjs';
import { activeBeastForm, beastWeapon } from '../../../shared/rules/beastForm';
import { hasHeroicInspiration, heroicInspirationDecision } from '../../../shared/rules/heroicInspiration.mjs';
import { commitCunningStrikeResolution } from '../utils/cunningStrikeStateService';

// The acting character's footprint: a size from a combat effect (Large Form) first, then a temporary or record size.
export const ownCreatureSize = (form, combatState, characterId) => effectSize(combatState, characterId)
  || effectSize(combatState, form?._id) || form?.temporarySize || form?.size;
// Free rolls the log can turn into a 20 with Stroke of Luck: skill, tool and ability checks and saving throws made on the
// sheet, whose DC is the DM's. Attack rolls and server-scored checks offer it when they fail instead.
// Rolls made on the sheet that Stroke of Luck or Heroic Inspiration can change afterwards from the roll log.
const STROKE_OF_LUCK_ROLLS = new Set(['Skill Roll', 'Tool Check', 'Stat Roll', 'Saving Throw']);

const readWeaponAbilityPreferences = (storageKey) => {
  if (!storageKey || typeof window === 'undefined') return {};
  try {
    const saved = JSON.parse(window.localStorage.getItem(storageKey));
    if (!saved || typeof saved !== 'object' || Array.isArray(saved)) return {};
    return Object.fromEntries(Object.entries(saved).filter(([, ability]) => ability === 'str' || ability === 'dex'));
  } catch { return {}; }
};

// Dice rolling helper used by calculateDamage and component actions
function rollDice(numberOfDiceValue, sidesOfDiceValue) {
  if (numberOfDiceValue <= 0 || sidesOfDiceValue <= 0) {
    return "Both the number of dice and sides must be greater than zero.";
  }

  const results = [];
  for (let i = 0; i < numberOfDiceValue; i++) {
    // Generate a random number between 1 and sidesOfDiceValue (inclusive)
    const result = Math.floor(Math.random() * sidesOfDiceValue) + 1;
    results.push(result);
  }

  return results;
}

function formatDamageRolls(rolls) {
  return rolls
    .map(({ value, type }) => `${value}${type ? ` ${type}` : ''}`)
    .join(' + ');
}


const DEFAULT_DAMAGE_TYPE_KEY = '__default__';
const ROLL_LOG_LIMIT = 80;

export function createCriticalDamageFormula(damageString) {
  if (typeof damageString !== 'string') return '';
  return damageString.replace(/\b(\d+)d(\d+)\b/gi, (_match, count, sides) => {
    const doubled = Math.max(0, parseInt(count, 10) * 2);
    return `${doubled}d${sides}`;
  });
}

const getWeaponAttackRollId = (slot, weapon) => `weapon:${slot || 'unknown'}:${weapon?.id || weapon?._id || weapon?.name || 'unnamed'}`;
const getSpellAttackRollId = (spell) => `spell:${spell?.id || spell?._id || spell?.name || 'unnamed'}:${spell?.casterType || spell?.caster || ''}`;

export const formatToppleSaveNotification = (save, targetName = 'Target') => {
  const saved = save?.success === true;
  return `Topple\n${targetName}: CON Save ${save?.total} vs DC ${save?.dc} — ${saved ? 'Succeeded' : 'Failed'}${saved ? '' : '\nProne'}`;
};

const DAMAGE_TYPE_CLASS_TOKEN_IGNORE = new Set([
  '',
  'and',
  'bonus',
  'damage',
  'damages',
  'extra',
  'plus',
]);

const parseDamageBreakdownSegments = (breakdown, normalizer) => {
  if (typeof breakdown !== 'string' || !breakdown.trim()) {
    return [];
  }

  const safeNormalizer =
    typeof normalizer === 'function'
      ? normalizer
      : (value = '') => value.trim().toLowerCase().replace(/\s+/g, '-');

  return breakdown
    .split(';')
    .map((section) => section.trim())
    .filter(Boolean)
    .flatMap((section) =>
      section
        .split(/\s+\+\s+/)
        .map((segment) => segment.trim())
        .filter(Boolean),
    )
    .map((segment) => {
      const [valueToken, ...typeParts] = segment.split(/\s+/);
      const value = valueToken || segment;
      const type = typeParts.join(' ');
      const normalizedType = safeNormalizer(type);

      return {
        value,
        type,
        normalizedType,
        text: type ? `${value} ${type}` : value,
        className: normalizedType ? `damage-${normalizedType}` : '',
      };
    });
};

const groupDiceRollsByType = (diceRolls, normalizer) => {
  const results = new Map();
  if (!Array.isArray(diceRolls)) {
    return results;
  }

  const safeNormalizer =
    typeof normalizer === 'function'
      ? normalizer
      : (value = '') => value.trim().toLowerCase().replace(/\s+/g, '-');

  diceRolls.forEach((detail) => {
    if (!detail) {
      return;
    }

    const normalizedType = safeNormalizer(detail.type || '');
    const key = normalizedType || DEFAULT_DAMAGE_TYPE_KEY;
    if (!results.has(key)) {
      results.set(key, []);
    }
    results.get(key).push(detail);
  });

  return results;
};

const WEAPON_SLOT_KEYS = ['mainHand', 'offHand', 'ranged'];
const HAND_SELECTIONS = {
  ONE_HANDED: 'one-handed',
  TWO_HANDED: 'two-handed',
};

const versatileRegex = /versatile\s*\(([^)]+)\)/i;
const firstDamageDiceRegex = /^(\s*)(\d+d\d+(?:[+-]\d+)?)/;
const anyDamageDiceRegex = /\d+d\d+(?:[+-]\d+)?/;

const spellsCatalog = spellsData || {};

export { isAuthoritativeSaveDamageAccess } from '../utils/saveDamageActivation';

// Delayed Blast Fireball with nobody around it: no save to make, so the bead just goes.
const clearLoneBead = async ({ campaignId, characterId, onCombatStateReconciled }) => {
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/buffs/clear-bead`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: `clear-bead:${characterId}:${Date.now()}`, sourceCombatantId: String(characterId) }) });
  const result = await response.json();
  if (response.ok) { onCombatStateReconciled?.(result.combat); notify('The bead explodes, and nothing is in reach.', 'info'); }
  else notify(result.message || 'The bead could not be cleared.', 'danger');
};
const FOLLOWING_AURAS = ['spell:spirit-guardians', 'spell:conjure-woodland-beings'];
const isPersistentAreaAccess = spell => Boolean(['web', 'moonbeam', 'cloudkill', 'incendiary-cloud', 'insect-plague', 'call-lightning', 'spirit-guardians', 'conjure-woodland-beings', 'flaming-sphere'].includes(spell?.spellId) && spell.spellInstanceId && (spell.source?.sourceType === 'monster' || (spell.source?.sourceType === 'class' && getClassCastingProfile(spell.source.sourceId))
  // A class feature's always-prepared spell (Circle of the Land's Web), cast with that class's slots and ability.
  || (spell.source?.sourceType === 'class-feature' && getClassCastingProfile(spell.source.classId))));
const SMITE_PROMPT_SPELLS = Object.freeze(['divine-smite', 'searing-smite', 'shining-smite']);
const isCastAccess = spell => isPersistentAreaAccess(spell) || isAuthoritativeSaveDamageAccess(spell);
const persistentDefinitions = { 'conjure-woodland-beings': CONJURE_WOODLAND_BEINGS_DEFINITION, 'flaming-sphere': FLAMING_SPHERE_DEFINITION, web: WEB_DEFINITION, moonbeam: MOONBEAM_DEFINITION, cloudkill: CLOUDKILL_DEFINITION, 'incendiary-cloud': INCENDIARY_CLOUD_DEFINITION, 'insect-plague': INSECT_PLAGUE_DEFINITION, 'call-lightning': CALL_LIGHTNING_DEFINITION, 'spirit-guardians': SPIRIT_GUARDIANS_DEFINITION };
const castDefinition = id => persistentDefinitions[id] ? { ...persistentDefinitions[id], targeting: { ...persistentDefinitions[id].targeting, allowEmpty: true } } : getExecutableSaveDamageDefinitionForSpell(id);

// A direct spell's range, with Improved Elemental Fury on a Druid cantrip.
const directSpellRangeFeet = (form, spell, definition) => (definition && !definition.level && isDruidSpellSource(spell?.source) ? druidCantripRangeFeet(form, definition.rangeFeet) : definition?.rangeFeet);

// `cantripBonus` is what a feature adds to a cantrip attack's damage (a Druid's Potent Spellcasting).
const canonicalSpellPresentation = (spell, characterLevel = 1, cantripBonus = 0) => {
  // Name lookup supplies display metadata only; casting still requires persisted access.
  const catalogueId = spell?.spellId || Object.keys(spellsCatalog).find((id) => spellsCatalog[id]?.name === spell?.name);
  // A spell with a buff and an attack (Produce Flame: conjure, then hurl) gets a separate attack-mode entry.
  const buffDefinition = spell?.castMode === 'attack' ? null : getBuffSpellDefinition(spell?.spellId);
  if (buffDefinition) return { ...spell, name: buffDefinition.name, level: buffDefinition.level, range: buffDefinition.rangeFeet === 5 ? 'Touch' : `${buffDefinition.rangeFeet} feet`, castingTime: buffDefinition.castingTime || (buffDefinition.resource === 'bonusAction' ? 'Bonus Action' : 'Action'), damage: '', duration: `${buffDefinition.concentration ? 'Concentration, ' : ''}${buffDefinition.rounds / 10} minute(s)` };
  const healingDefinition = getHealingSpellDefinition(spell?.spellId);
  if (healingDefinition) return { ...spell, name: healingDefinition.name, level: healingDefinition.level, school: 'Abjuration',
    range: healingDefinition.rangeFeet === 5 ? 'Touch' : `${healingDefinition.rangeFeet} feet`,
    castingTime: healingDefinition.castingTime || (healingDefinition.resource === 'bonusAction' ? 'Bonus Action' : 'Action'),
    damage: describeHealingAmount(healingDefinition) };
  const directDefinition = getDirectSpellDefinition(spell?.spellId);
  if (directDefinition) return { ...spell, name: spell?.castMode === 'attack' && directDefinition.attackLabel ? directDefinition.attackLabel : directDefinition.name, level: directDefinition.level, range: directDefinition.delivery === 'melee-spell-attack' ? 'Touch' : `${directDefinition.rangeFeet} feet`, castingTime: 'Action',
    rangedSpellAttack: directDefinition.delivery === 'ranged-spell-attack', damage: cantripBonus > 0 && !directDefinition.level ? directSpellDamage(directDefinition, characterLevel).replace(' ', `+${cantripBonus} `) : directSpellDamage(directDefinition, characterLevel), directDefinition };
  const definition = catalogueId ? castDefinition(catalogueId) : null;
  const cantripDamage = definition?.level === 0 ? damageForCastLevel(definition, 0, Math.min(20, Math.max(1, Math.floor(characterLevel) || 1))).components.map(({ formula, type }) => `${formula} ${type}`).join(' + ') : '';
  // Stored dice on older records are 2014 copies, so definitions and the 2024 catalog win over them.
  const definitionDamage = definition?.damage?.components?.map(({ formula, type }) => `${formula}${type ? ` ${type}` : ''}`).join(' + ') || '';
  const damage = cantripDamage || definitionDamage || withCatalogDice(spell, SPELLS_BY_NAME)?.damage || '';
  return { ...spell, name: spell?.name || definition?.name, level: spell?.level ?? definition?.level, school: spell?.school || definition?.school, damage, saveDamageDefinition: definition };
};

const spellSourceLabel = (spell) => spell?.source?.sourceType === 'monster' ? 'Monster Spellcasting' : spell?.source?.sourceType === 'class'
  ? String(spell.source.sourceId || '').toUpperCase()
  : (spell?.casterType || spell?.caster || 'Unknown / unresolved');

const diceExpressionPattern = /\d+d\d+(?:\s*[+-]\s*\d+)?/gi;
const rangedSpellAttackPattern = /ranged\s+(?:spell\s+)?attack(?:\s+roll)?/i;

function detectRangedSpellAttack(text = '') {
  if (typeof text !== 'string') {
    return false;
  }
  return rangedSpellAttackPattern.test(text);
}

const ABILITY_LABELS = {
  str: 'Strength',
  dex: 'Dexterity',
  con: 'Constitution',
  int: 'Intelligence',
  wis: 'Wisdom',
  cha: 'Charisma',
};

const waitForNextAnimationFrame = () => {
  if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
    return new Promise((resolve) => {
      window.requestAnimationFrame(() => resolve());
    });
  }

  if (typeof setTimeout === 'function') {
    return new Promise((resolve) => {
      setTimeout(resolve, 0);
    });
  }

  return Promise.resolve();
};

function extractDiceExpression(description = '') {
  diceExpressionPattern.lastIndex = 0;
  let match;
  while ((match = diceExpressionPattern.exec(description))) {
    const raw = match[0];
    const sanitized = raw.replace(/\s+/g, '');
    const start = Math.max(0, match.index - 80);
    const end = Math.min(description.length, match.index + raw.length + 80);
    const contextWindow = description.slice(start, end).toLowerCase();

    if (contextWindow.includes('damage')) {
      return sanitized;
    }

    if (/(regains|heals|gains)[\s\S]{0,100}hit points/.test(contextWindow)) {
      return sanitized;
    }
  }
  return '';
}

function extractHigherLevels(description = '') {
  const match = description.match(/At Higher Levels?[:.]\s*([^]*)/i);
  return match ? match[1].trim() : undefined;
}

function augmentSpell(spell = {}) {
  const enhanced = { ...spell };
  if (!enhanced.damage) {
    const dmg = extractDiceExpression(enhanced.description);
    if (dmg) enhanced.damage = dmg;
  }
  if (!enhanced.higherLevels) {
    const upcast = extractHigherLevels(enhanced.description);
    if (upcast) enhanced.higherLevels = upcast;
  }
  if (enhanced.level === 0 && !enhanced.scaling) {
    const scaling = extractCantripScaling(enhanced);
    if (scaling) enhanced.scaling = scaling;
  }
  if (enhanced.rangedSpellAttack === undefined) {
    enhanced.rangedSpellAttack = detectRangedSpellAttack(enhanced.description);
  } else {
    enhanced.rangedSpellAttack = Boolean(enhanced.rangedSpellAttack);
  }
  return enhanced;
}

const SPELLS_BY_NAME = Object.values(spellsCatalog).reduce((acc, spell) => {
  if (!spell || typeof spell.name !== 'string') return acc;
  acc[spell.name.toLowerCase()] = augmentSpell(spell);
  return acc;
}, {});

function parseSpellLevel(spellLevel) {
  if (typeof spellLevel !== 'string') return 0;
  const normalized = spellLevel.trim().toLowerCase();
  if (!normalized) return 0;
  if (normalized === 'cantrip') return 0;
  const match = normalized.match(/(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
}

const getVersatileDamageDice = (weapon) => {
  if (!Array.isArray(weapon?.properties)) return null;

  for (const property of weapon.properties) {
    if (typeof property !== 'string') continue;
    const match = property.match(versatileRegex);
    if (match) {
      const dice = match[1]?.trim();
      if (dice) {
        return dice;
      }
    }
  }

  return null;
};

function toTitleCase(str) {
  const small = new Set(['of', 'the']);
  return str
    .toLowerCase()
    .split(/\s+/)
    .map((word, i) =>
      i !== 0 && small.has(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');
}

export function calculateDamage(
  damageString,
  ability = 0,
  crit = false,
  roll = rollDice,
  extraDice,
  levelsAbove = 0,
  options = {}
) {
  const greatWeaponFighting = greatWeaponFightingApplies(options?.character, options?.attack);
  const effectiveDie = value => fightingStyleDamageDie(value, greatWeaponFighting);
  let fightingStyleBonus = 0;
  let savageAttackerGain = null;
  const sumDice = values => values.reduce((sum,value) => { fightingStyleBonus += effectiveDie(value) - value; return sum + effectiveDie(value); },0);
  const parts = damageString.split(/\s+\+\s+/);
  const results = [];
  const diceRolls = [];
  // What the log shows: each damage source with its own dice and flat additions, so the total can be rebuilt.
  const logParts = [];
  const logDice = (rollArray, sides, critical = false) => rollArray.map((value) => ({ sides, value, ...(effectiveDie(value) !== value ? { effectiveValue: effectiveDie(value) } : {}), ...(critical ? { critical: true } : {}) }));

  const normalizeRollArray = (value, count) => {
    if (Array.isArray(value)) {
      return value.map((rollValue) =>
        typeof rollValue === 'number' ? rollValue : Number(rollValue) || 0
      );
    }
    if (typeof value === 'number') {
      return Array(count).fill(value);
    }
    return Array(count).fill(0);
  };

  const recordDiceRolls = (rollArray, sides, type, category) => {
    rollArray.forEach((value) => {
      diceRolls.push({ sides, value, type, category, ...(effectiveDie(value) !== value ? { effectiveValue: effectiveDie(value) } : {}) });
    });
  };

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i].trim();
    const [token, ...rest] = part.split(' ');
    const match = token.match(/^(\d+)(?:d(\d+)([+-]\d+)?)?$/);
    if (!match) {
      // eslint-disable-next-line no-console
      console.error('Invalid damage string');
      return null;
    }

    const type = rest.join(' ').trim();

    const abilityBonus = i === 0 ? ability : 0;
    // Why the weapon's damage leaves out an ability bonus its attack roll had (the Light extra attack).
    const abilityNote = i === 0 && options?.abilityNote ? { abilityNote: options.abilityNote } : {};

    if (!match[2]) {
      const baseValue = parseInt(match[1], 10) + abilityBonus;
      results.push({ value: baseValue, type });
      logParts.push({ type, dice: [], flat: parseInt(match[1], 10), ability: abilityBonus, ...(abilityBonus && options?.attack?.ability ? { abilityLabel: String(options.attack.ability).toUpperCase() } : {}), ...abilityNote, value: baseValue });
      continue;
    }

    const numberOfDiceValue = parseInt(match[1], 10);
    const sidesOfDiceValue = parseInt(match[2], 10);
    const modifier = parseInt(match[3] || 0, 10);

    let baseRolls = normalizeRollArray(
      roll(numberOfDiceValue, sidesOfDiceValue),
      numberOfDiceValue
    );
    const firstRolls = baseRolls;
    // Savage Attacker (2024): roll the weapon's damage dice twice and use the better roll.
    let savageDiscarded = null;
    let secondRolls = null;
    if (options?.savageAttacker && i === 0) {
      secondRolls = normalizeRollArray(roll(numberOfDiceValue, sidesOfDiceValue, { category: 'savage-attacker' }), numberOfDiceValue);
      const effectiveSum = values => values.reduce((sum, value) => sum + effectiveDie(value), 0);
      if (effectiveSum(secondRolls) > effectiveSum(baseRolls)) { savageDiscarded = baseRolls; baseRolls = secondRolls; }
      else savageDiscarded = secondRolls;
      savageAttackerGain = effectiveSum(baseRolls) - effectiveSum(savageDiscarded);
    }
    let damageSum = sumDice(baseRolls);
    // The shown dice follow the throw: the weapon's roll, then Savage Attacker's extra roll (whichever was kept).
    recordDiceRolls(firstRolls, sidesOfDiceValue, type, 'base');
    if (secondRolls) recordDiceRolls(secondRolls, sidesOfDiceValue, type, 'savage-attacker');
    const partDice = logDice(baseRolls, sidesOfDiceValue);

    if (extraDice && levelsAbove > 0 && i === 0) {
      const totalExtra = extraDice.count * levelsAbove;
      if (totalExtra > 0) {
        const extraRolls = normalizeRollArray(
          roll(totalExtra, extraDice.sides),
          totalExtra
        );
        damageSum += sumDice(extraRolls);
        recordDiceRolls(extraRolls, extraDice.sides, type, 'bonus');
        partDice.push(...logDice(extraRolls, extraDice.sides));
      }
    }

    if (crit) {
      const critRolls = normalizeRollArray(
        roll(numberOfDiceValue, sidesOfDiceValue),
        numberOfDiceValue
      );
      damageSum += sumDice(critRolls);
      recordDiceRolls(critRolls, sidesOfDiceValue, type, 'critical');
      partDice.push(...logDice(critRolls, sidesOfDiceValue, true));
      if (extraDice && levelsAbove > 0 && i === 0) {
        const totalExtra = extraDice.count * levelsAbove;
        if (totalExtra > 0) {
          const critExtra = normalizeRollArray(
            roll(totalExtra, extraDice.sides),
            totalExtra
          );
          damageSum += sumDice(critExtra);
          recordDiceRolls(critExtra, extraDice.sides, type, 'critical-bonus');
          partDice.push(...logDice(critExtra, extraDice.sides, true));
        }
      }
    }

    results.push({ value: damageSum + modifier + abilityBonus, type });
    logParts.push({ type, dice: partDice, flat: modifier, ability: abilityBonus, ...(abilityBonus && options?.attack?.ability ? { abilityLabel: String(options.attack.ability).toUpperCase() } : {}), ...abilityNote, ...(savageDiscarded ? { savageAttacker: { discarded: savageDiscarded } } : {}), value: damageSum + modifier + abilityBonus });
  }

  const rageBonus = getRageDamageBonus(options?.character, options?.attack, options?.combatState);
  if (rageBonus > 0) {
    results.push({ value: rageBonus, type: 'Rage' });
    logParts.push({ label: 'Rage', dice: [], flat: rageBonus, ability: 0, value: rageBonus });
  }

  const frenzyDice = Object.prototype.hasOwnProperty.call(options || {}, 'frenzyDice')
    ? options.frenzyDice : getFrenzyDamageDice(options?.character, options?.attack);
  let frenzyApplied = false;
  if (frenzyDice?.count > 0) {
    const inheritedType = results.find((entry) => entry.type && entry.type !== 'Rage')?.type || options?.attack?.damageType || '';
    const baseFrenzyRolls = normalizeRollArray(roll(frenzyDice.count, frenzyDice.sides, { category: 'frenzy' }), frenzyDice.count);
    let frenzyValue = sumDice(baseFrenzyRolls);
    recordDiceRolls(baseFrenzyRolls, frenzyDice.sides, inheritedType, 'frenzy');
    const frenzyLogDice = logDice(baseFrenzyRolls, frenzyDice.sides);
    if (crit) {
      const critFrenzyRolls = normalizeRollArray(roll(frenzyDice.count, frenzyDice.sides, { category: 'frenzy' }), frenzyDice.count);
      frenzyValue += sumDice(critFrenzyRolls);
      recordDiceRolls(critFrenzyRolls, frenzyDice.sides, inheritedType, 'critical-frenzy');
      frenzyLogDice.push(...logDice(critFrenzyRolls, frenzyDice.sides, true));
    }
    results.push({ value: frenzyValue, type: `${frenzyDice.label}${inheritedType ? ` ${inheritedType}` : ''}` });
    logParts.push({ label: frenzyDice.label, type: inheritedType, dice: frenzyLogDice, flat: 0, ability: 0, value: frenzyValue });
    frenzyApplied = true;
  }

  let brutalStrikeApplied = false;
  if (options?.brutalStrike) {
    const inheritedType = results.find((entry) => entry.type && entry.type !== 'Rage' && !entry.type.startsWith('Frenzy'))?.type || options?.attack?.damageType || '';
    // 1d10 (2d10 from Barbarian 17), doubled on a Critical Hit like any damage dice.
    const brutalCount = brutalStrikeDiceCount(options?.character);
    const brutalRolls = normalizeRollArray(roll(brutalCount, 10), brutalCount);
    let brutalValue = sumDice(brutalRolls);
    recordDiceRolls(brutalRolls, 10, inheritedType, 'brutal-strike');
    const brutalLogDice = logDice(brutalRolls, 10);
    if (crit) {
      const critBrutalRolls = normalizeRollArray(roll(brutalCount, 10), brutalCount);
      brutalValue += sumDice(critBrutalRolls);
      recordDiceRolls(critBrutalRolls, 10, inheritedType, 'critical');
      brutalLogDice.push(...logDice(critBrutalRolls, 10, true));
    }
    results.push({ value: brutalValue, type: `Brutal Strike${inheritedType ? ` ${inheritedType}` : ''}` });
    logParts.push({ label: 'Brutal Strike', type: inheritedType, dice: brutalLogDice, flat: 0, ability: 0, value: brutalValue });
    brutalStrikeApplied = true;
  }

  const total = results.reduce((sum, r) => sum + r.value, 0);
  return {
    total,
    breakdown: formatDamageRolls(results),
    diceRolls,
    parts: logParts,
    critical: Boolean(crit),
    modifiers: [
      ...(fightingStyleBonus ? [{ label: 'Great Weapon Fighting', value: fightingStyleBonus }] : []),
      ...(savageAttackerGain !== null ? [{ label: 'Savage Attacker', value: savageAttackerGain }] : []),
      ...(rageBonus > 0 ? [{ label: 'Rage', value: rageBonus }] : []),
      ...(frenzyApplied ? [{ label: 'Frenzy', value: results[results.length - 1].value }] : []),
      ...(brutalStrikeApplied ? [{ label: 'Brutal Strike', value: results.find((entry) => entry.type.startsWith('Brutal Strike'))?.value || 0 }] : []),
    ],
    frenzyApplied,
    brutalStrikeApplied,
    brutalStrikeDamage: brutalStrikeApplied ? (results.find((entry) => entry.type.startsWith('Brutal Strike'))?.value || 0) : 0,
  };
}

const PlayerTurnActions = React.forwardRef(
  (
    {
      form,
      strMod,
      dexMod,
      conMod = 0,
      intMod = null,
      wisMod = null,
      chaMod = null,
      spellAbilityMod = null,
      spellAbilityKey = '',
      onCastSpell,
      onDamageSummaryChange = () => {},
      externalDiceSurface = null, externalDiceResults = null, resolveDefenderReaction = null, resolveCastWindow = null, resolveFateWindow = null, resolveCuttingWords = null,
      onCharacterChange,
      availableSlots = { regular: {}, warlock: {} },
      longRestCount = 0,
      shortRestCount = 0,
      characterId = null,
      campaignId = null,
      isActiveTurn = false,
      onBeginTargeting = () => {},
      onApplyTargetDamage = async () => {},
      onCancelTargeting = () => {},
      combatState = null,
      onAttackResolved = async () => {},
      onDamageResolved = async () => {},
      onActionEconomyReconciled = () => {},
      onCombatStateReconciled = () => {},
      spatialContext = null,
          onMapReconciled = () => {},
      featureActionTarget = null,
      renderStandaloneFeatureActions = true,
      logAsTab = false,
      combatants = [],
      quickPotionKeys = [],
      onSpellSlotReconciled = () => {},
      onSpellCastProgress = () => {},
      onSaveDamageStateChanged = () => {},
    },
    ref
  ) => {
  const combatantName = useCombatantName();
  const pendingBarbarianAttack = useRef(null);
  const multiattackClientId=useRef(window.crypto?.randomUUID?.() || `dm-${Date.now()}-${Math.random()}`);
  const recklessScope = useRef(''); recklessScope.current = `${campaignId}:${characterId}`;
  const spellCastBlockReason = rageSpellcastingBlockReason(form);
  const rollSharedDiceWithBox = useCallback(async groups => {
    const result = await rollDiceWithBox(groups);
    externalDiceResults?.((result?.rolls || []).flatMap((dice,index) => (Array.isArray(dice) ? dice : [dice]).map(value => ({sides:groups[index]?.sides,value,type:'Spell dice'}))));
    return result;
  }, [externalDiceResults]);
  // -----------------------------------------------------------Modal for attacks------------------------------------------------------------------------
  const potionControlsRef = useRef(null);
  const { pinnedIds: quickAttackIds, togglePin: toggleQuickAttack } = useQuickAttacks(characterId);
  // Weapons and taken spells have tiles by default, so for them the toggle works the other way round: it records the ones taken off.
  const { pinnedIds: hiddenTileIds, togglePin: toggleHiddenTile } = useQuickAttacks(characterId ? `${characterId}:hidden-tiles` : null);
  const [showAttack, setShowAttack] = useState(false);
  const [attackSearch, setAttackSearch] = useState('');
  const [activeAttackCategory, setActiveAttackCategory] = useState('all');
  const [activeAttackFilters, setActiveAttackFilters] = useState(() => new Set());
  const [attackSort, setAttackSort] = useState('favorites');
  const [selectedAttackId, setSelectedAttackId] = useState('');
  const [favoriteAttackIds, setFavoriteAttackIds] = useState(() => new Set());
  const [recentAttackIds, setRecentAttackIds] = useState([]);
  const [showDiceRoller, setShowDiceRoller] = useState(false);
  const [featureDecision, setFeatureDecision] = useState(null);
  const [saveDamageCast, setSaveDamageCast] = useState(null);
  const saveDamageCastIntentRef = useRef(null);
  const enemySaveRecoveryKey = form?.entityType === 'enemy' ? `enemy-save-cast:${campaignId}:${characterId}` : null;
  useEffect(() => {
    if (!enemySaveRecoveryKey) return;
    try {
      const saved = JSON.parse(sessionStorage.getItem(enemySaveRecoveryKey));
      if (saved?.resolutionId && saved.sourceCombatantId === String(characterId)) {
        const recovered = {...saved,status:saved.prepared ? 'finalize-failed' : 'failed',error:'Cast interrupted. Retry the original cast to recover its paid action and captured dice.'};
        saveDamageCastIntentRef.current = recovered;setSaveDamageCast(recovered);
      }
    } catch { /* Optional recovery storage. */ }
  }, [enemySaveRecoveryKey, characterId]);

  const [legacySpellResolution, setLegacySpellResolution] = useState(null);
  const saveDamageCastLock = useRef(false);
  useEffect(() => {
    const pending = saveDamageCastIntentRef.current;
    const revision = pending?.prepared?.combatRevision ?? pending?.combatRevision;
    if (Number.isInteger(revision) && Number.isInteger(combatState?.turnSequence) && revision !== combatState.turnSequence) {
      saveDamageCastIntentRef.current = null;
      setSaveDamageCast(null);
      if(enemySaveRecoveryKey)try{sessionStorage.removeItem(enemySaveRecoveryKey);}catch{}
    }
  }, [combatState?.turnSequence, enemySaveRecoveryKey]);
  const [showHideConfirmation, setShowHideConfirmation] = useState(false);
  const [cunningActionPending, setCunningActionPending] = useState(false);
  const featureDecisionResolveRef = useRef(null);
  const resolveFeatureDecision = useCallback((decision) => new Promise((resolve) => {
    featureDecisionResolveRef.current = resolve;
    setFeatureDecision(decision);
  }), []);
  // The dice display, for rerolls that start outside a normal roll (the surface callback is defined further down).
  const prepareRerollRef = useRef(null);
  const prepareReroll = useCallback((label) => prepareRerollRef.current?.(label), []);
  // Heroic Inspiration on this sheet's damage and healing dice: one die in its lower half, before anything adds them up.
  const rerollDiceWithHeroicInspiration = useCallback((groups, kind, what) => offerHeroicDieReroll({ character: form, prepareRoll: prepareReroll,
    characterId: String(form?._id || characterId), requestId: `${kind}:${window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`}`,
    kind, what, groups, choose: resolveFeatureDecision, onCharacterChange }), [form, characterId, resolveFeatureDecision, onCharacterChange, prepareReroll]);
  // The shared dice roller with that offer, for rollers that take one (save damage evidence, healing).
  const rollDiceWithHeroicReroll = useCallback((kind, what) => async (groups) => {
    const result = await rollSharedDiceWithBox(groups);
    const rolled = (result?.rolls || []).map((values, index) => ({ sides: Number(groups[index]?.sides), values: Array.isArray(values) ? values : [values] }));
    const rerolled = await rerollDiceWithHeroicInspiration(rolled, kind, what);
    return { ...result, rolls: (result?.rolls || []).map((values, index) => (Array.isArray(values) ? rerolled[index].values : rerolled[index].values[0])) };
  }, [rollSharedDiceWithBox, rerollDiceWithHeroicInspiration]);
  const finishFeatureDecision = useCallback((result) => {
    const resolve = featureDecisionResolveRef.current;
    featureDecisionResolveRef.current = null;
    setFeatureDecision(null);
    resolve?.(result);
  }, []);
  const handleCloseAttack = () => { setShowAttack(false); onCancelTargeting(); };
  const handleShowAttack = useCallback(() => setShowAttack(true), []);
  const handleCloseDiceRoller = () => setShowDiceRoller(false);
  const handleShowDiceRoller = useCallback(() => setShowDiceRoller(true), []);

  const handleDiceRollComplete = ({ total, count, sides, values, usedFallback } = {}) => {
    if (!Number.isFinite(total)) {
      setShowDiceRoller(false);
      return;
    }

    const sanitizedCount = Number.isInteger(count) ? count : 0;
    const sanitizedSides = Number.isInteger(sides) ? sides : 0;
    const expression =
      sanitizedCount > 0 && sanitizedSides > 0
        ? `${sanitizedCount}d${sanitizedSides}`
        : 'Dice Roll';

    const diceRolls = Array.isArray(values)
      ? values.map((value) => ({
          value: Number(value) || 0,
          sides: sanitizedSides || undefined,
          type: '',
          category: 'custom',
        }))
      : [];

    updateDamageValueWithAnimation(total, '', 'custom', {
      sourceLabel: 'Dice Roll',
      expression,
      diceRolls,
      rollValues: Array.isArray(values)
        ? values.map((value) => `${Number(value) || 0}`)
        : undefined,
      modifierValues: undefined,
      usedFallback,
      rollLabel: 'Roll',
    });

    setShowDiceRoller(false);
  };

  const [, setFooterHeight] = useState(0);
  // -----------------------------------------Dice roller for damage-------------------------------------------------------------------
  const [damageValue, setDamageValue] = useState(0);
  const [hasDamageRoll, setHasDamageRoll] = useState(false);
  const [damageRollLabel, setDamageRollLabel] = useState('Damage');
  const [damageLog, setDamageLog] = useState([]);
  // Every writer adds its entries at the top as one group; the log keeps the most recent items.
  // Stroke of Luck (Rogue 20) on a roll made on the sheet: the player turns its d20 into a 20 from the log.
  const spendStrokeOfLuckOn = useCallback(async (entry) => {
    try {
      const kind = entry.rollLabel === 'Saving Throw' ? 'save' : 'check';
      const claimed = await claimStrokeOfLuck(String(characterId), { requestId: entry.id, kind });
      onCharacterChange?.(previous => withStrokeOfLuck(previous, claimed.strokeOfLuck));
      const total = Number(entry.total) + 20 - entry.luckD20;
      setDamageLog((previous) => previous.map((item) => (item.id === entry.id ? { ...item, total, strokeOfLuck: true } : item)));
      notify(`Stroke of Luck\n${entry.source || 'Roll'}: the d20 (${entry.luckD20}) became a 20 — total ${total}.`, 'success');
    } catch (error) { notify(error.message, 'warning'); }
  }, [characterId, onCharacterChange]);
  // Heroic Inspiration on a roll made on the sheet: rerolls its (lower) d20 from the log; the new roll is used.
  const spendHeroicInspirationOn = useCallback(async (entry) => {
    const roll = entry.heroicReroll;
    try {
      const reroll = await rerollWithHeroicInspiration({ character: form, characterId: String(characterId), requestId: `${entry.id}:heroic-inspiration`,
        kind: entry.rollLabel === 'Saving Throw' ? 'save' : 'check', rollMode: roll.rollMode, kept: roll.d20, dice: roll.dice, onCharacterChange, prepareRoll: prepareReroll });
      const effective = d20 => resolveAbilityCheckDie(d20, { character: form, rollContext: roll.rollContext, proficient: roll.proficient }).effectiveD20;
      const total = withIndomitableMight(form, roll.ability, Number(roll.rawTotal) + effective(reroll.d20) - effective(roll.d20), roll.strengthScore);
      setDamageLog((previous) => previous.map((item) => (item.id === entry.id ? { ...item, total, heroicInspiration: { from: roll.d20, to: reroll.d20 },
        ...(Number.isInteger(item.luckD20) ? { luckD20: effective(reroll.d20) } : {}) } : item)));
      notify(`Heroic Inspiration\n${entry.source || 'Roll'}: rerolled a d20 (${reroll.newDie}) — total ${total}.`, 'success');
    } catch (error) { notify(error.message, 'warning'); }
  }, [characterId, form, onCharacterChange, prepareReroll]);
  // Boon of Fate on a roll made on the sheet: 2d4 added to its total from the log.
  const spendFateOn = useCallback(async (entry) => {
    try {
      const fate = await spendFateOnRoll({ characterId: String(characterId), requestId: `${entry.id}:fate`,
        kind: entry.rollLabel === 'Saving Throw' ? 'save' : 'check', onCharacterChange });
      const total = Number(entry.total) + fate.bonus;
      setDamageLog((previous) => previous.map((item) => (item.id === entry.id ? { ...item, total, fate } : item)));
      notify(`Boon of Fate\n${entry.source || 'Roll'}: +${fate.bonus} (2d4: ${fate.rolls.join(', ')}) — total ${total}.`, 'success');
    } catch (error) { notify(error.message, 'warning'); }
  }, [characterId, onCharacterChange]);
  // A held Bardic Inspiration die on a roll made on the sheet: added to its total from the log.
  const spendBardicDieOn = useCallback(async (entry) => {
    try {
      const die = await spendBardicDieOnRoll({ character: form, characterId: String(characterId), requestId: `${entry.id}:bardic-inspiration`,
        kind: entry.rollLabel === 'Saving Throw' ? 'save' : 'check', onCharacterChange });
      const total = Number(entry.total) + die.bonus;
      setDamageLog((previous) => previous.map((item) => (item.id === entry.id ? { ...item, total, bardicDie: die } : item)));
      notify(`Bardic Inspiration\n${entry.source || 'Roll'}: +${die.bonus} (d${die.sides}) — total ${total}.`, 'success');
    } catch (error) { notify(error.message, 'warning'); }
  }, [characterId, form, onCharacterChange]);
  const addLogEntries = useCallback((entries) => {
    const list = (Array.isArray(entries) ? entries : [entries]).filter(Boolean);
    if (list.length) setDamageLog((previous) => [...list, { divider: true }, ...previous].slice(0, ROLL_LOG_LIMIT));
  }, []);
  const healingControlsRef = useRef(null);
  const layOnHandsRef = useRef(null);
  const buffControlsRef = useRef(null);
  useExtraAttackNotice({ combatState, characterId, isActiveTurn });
  useHuntersLoreNotice({ form, characterId, combatState, spatialContext });
  useDivineSenseNotice({ form, characterId, combatState, spatialContext });
  useSpellRecallNotice({ form });
  const [buffPending, setBuffPending] = useState(false);
  const championMovementRef = useRef(null);
  const rageControlsRef = useRef(null);
  const healingLoggedRef = useRef(new Set());
  const [showLog, setShowLog] = useState(false);
  useEffect(() => {
    const rolled = event => {
      const roll = event.detail;
      if (roll?.campaignId !== campaignId || String(roll.sourceCombatantId) !== String(characterId)) return;
      setDamageValue(roll.value); setHasDamageRoll(true); setDamageRollLabel(roll.label || 'Spell Damage');
      setIsDiceRollPending(false); setLastRollTimestamp(Date.now());
      setActiveDice((roll.dice || []).map((die, index) => ({ ...die, id: `${Date.now()}-${index}` })));
    };
    window.addEventListener(SPELL_DAMAGE_ROLLED_EVENT, rolled);
    return () => window.removeEventListener(SPELL_DAMAGE_ROLLED_EVENT, rolled);
  }, [campaignId, characterId]);
  const completedSpellLog = useRef(new Set());
  useEffect(() => {
    completedSpellLog.current.clear();
    const completed = event => {
      const entry = event.detail;
      if (entry?.campaignId !== campaignId || String(entry.sourceCombatantId) !== String(characterId) || completedSpellLog.current.has(entry.id)) return;
      completedSpellLog.current.add(entry.id);
      if (completedSpellLog.current.size > 200) completedSpellLog.current.delete(completedSpellLog.current.values().next().value);
      const name = combatantName(entry.targetCombatantId, entry.targetName || entry.targetCombatantId);
      addLogEntries({ type: 'spell-save-resolution', total: entry.finalDamage, source: entry.label, targetName: name, success: entry.success, damageType: entry.damageType,
        ...(Array.isArray(entry.logLines) ? { lines: entry.logLines } : {}) });
    };
    window.addEventListener(SPELL_DAMAGE_LOG_EVENT, completed);
    return () => window.removeEventListener(SPELL_DAMAGE_LOG_EVENT, completed);
  }, [addLogEntries, campaignId, characterId, combatantName]);

  const [activeDice, setActiveDice] = useState([]);
  const [lastRollTimestamp, setLastRollTimestamp] = useState(0);
  const [isDiceRollPending, setIsDiceRollPending] = useState(false);

  const showDiceRollSurface = useCallback((label = 'Roll') => {
    setDamageRollLabel(label);
    setIsDiceRollPending(true);
  }, []);

  const prepareDiceRollSurface = useCallback(async (label = 'Roll') => {
    if (externalDiceSurface) return externalDiceSurface(label);
    showDiceRollSurface(label);
    await waitForNextAnimationFrame();
  }, [showDiceRollSurface, externalDiceSurface]);
  prepareRerollRef.current = prepareDiceRollSurface;

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handleDiceRollSurfaceRequest = (event) => {
      const requestedLabel =
        typeof event?.detail?.label === 'string' && event.detail.label.trim()
          ? event.detail.label.trim()
          : 'Roll';
      showDiceRollSurface(requestedLabel);
    };

    window.addEventListener(DICE_BOX_ROLL_SURFACE_EVENT, handleDiceRollSurfaceRequest);
    return () => {
      window.removeEventListener(DICE_BOX_ROLL_SURFACE_EVENT, handleDiceRollSurfaceRequest);
    };
  }, [showDiceRollSurface, externalDiceSurface]);


  useEffect(() => {
    const observed = new Map();
    let safeAreaProbe = null;

    const parseSize = (value) => {
      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? 0 : parsed;
    };

    const ensureSafeAreaProbe = () => {
      if (typeof document === 'undefined') {
        return null;
      }
      if (!safeAreaProbe) {
        safeAreaProbe = document.createElement('div');
        safeAreaProbe.setAttribute('data-safe-area-probe', 'true');
        safeAreaProbe.style.cssText =
          'position:fixed;bottom:0;left:0;height:0;pointer-events:none;visibility:hidden;padding-bottom:env(safe-area-inset-bottom, 0);';
        document.body.appendChild(safeAreaProbe);
      }
      return safeAreaProbe;
    };

    const getSafeAreaInsetBottom = () => {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return 0;
      }
      const probe = ensureSafeAreaProbe();
      if (!probe) {
        return 0;
      }
      return parseSize(getComputedStyle(probe).paddingBottom || '0');
    };

    const updateFooterHeight = () => {
      const slots = observed.get('slots')?.element;
      const navbar = observed.get('navbar')?.element;
      const slotsHeight = slots ? slots.getBoundingClientRect().height : 0;
      const navbarHeight = navbar ? navbar.getBoundingClientRect().height : 0;
      const slotsBottomOffset =
        slots && typeof window !== 'undefined'
          ? parseSize(getComputedStyle(slots).bottom || '0')
          : 0;
      const safeAreaInset = getSafeAreaInsetBottom();
      setFooterHeight(
        slotsHeight + navbarHeight + slotsBottomOffset + safeAreaInset
      );
    };

    const observeElement = (key, element) => {
      const current = observed.get(key);
      if (current?.element === element) {
        return;
      }

      current?.cleanup?.();

      if (!element) {
        observed.delete(key);
        updateFooterHeight();
        return;
      }

      const onChange = () => updateFooterHeight();
      let cleanup = () => {};

      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(onChange);
        resizeObserver.observe(element);
        cleanup = () => resizeObserver.disconnect();
      } else if (typeof MutationObserver !== 'undefined') {
        const mutationObserver = new MutationObserver(onChange);
        mutationObserver.observe(element, {
          attributes: true,
          childList: true,
          subtree: true,
        });
        cleanup = () => mutationObserver.disconnect();
      }

      observed.set(key, { element, cleanup });
      updateFooterHeight();
    };

    const refreshElements = () => {
      observeElement('slots', document.querySelector('.spell-slot-container'));
      observeElement('navbar', document.querySelector('.navbar.fixed-bottom'));
    };

    refreshElements();

    let documentObserver;
    if (typeof MutationObserver !== 'undefined') {
      documentObserver = new MutationObserver(refreshElements);
      documentObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener('resize', updateFooterHeight);

    return () => {
      observed.forEach(({ cleanup }) => cleanup());
      observed.clear();
      window.removeEventListener('resize', updateFooterHeight);
      documentObserver?.disconnect();
      safeAreaProbe?.remove();
      safeAreaProbe = null;
    };
  }, []);

//--------------------------------------------Critical status------------------------------------------------
const [isCritical, setIsCritical] = useState(false);
const [isFumble, setIsFumble] = useState(false);
const [pendingCriticalAttack, setPendingCriticalAttack] = useState(null);
const manualCriticalRef = useRef(false);
  const equipmentProvided = useMemo(
    () => typeof form?.equipment === 'object' && form.equipment !== null,
    [form.equipment]
  );
  const normalizedEquipment = useMemo(
    () => normalizeEquipmentMap(form.equipment),
    [form.equipment]
  );

  const monkLevel = useMemo(() => getMonkLevel(form), [form]);
  const hasMonkLevels = monkLevel > 0;
  const pendingMonkAttack = useRef(null);
  const monkAttackLock = useRef(false);
  const unarmedStrikeDamage = '1 Bludgeoning';
  const beastForm = activeBeastForm(form);
  const equippedWeapons = useMemo(() => {
    // Wild Shape: the Beast's attacks replace the character's, whose gear has merged into the form.
    if (beastForm) {
      const level = (form.occupation || []).reduce((sum, entry) => sum + (Number(entry.Level ?? entry.level) || 0), 0);
      const numbers = { proficiencyBonus: Number(form.proficiencyBonus ?? proficiencyBonus(level)) || 0, strengthModifier: Number(strMod) || 0, dexterityModifier: Number(dexMod) || 0 };
      return beastForm.attacks.map((attack, index) => ({ slot: `beast-${index}`, weapon: beastWeapon(attack, numbers) }));
    }

    let weapons = [];

    if (equipmentProvided) {
      weapons = WEAPON_SLOT_KEYS.map((slot) => {
        const weapon = normalizedEquipment[slot];
        if (!weapon) return null;
        if (weapon.source && weapon.source !== 'weapon') return null;
        const damage =
          typeof weapon.damage === 'string' ? weapon.damage.trim() : '';
        if (!damage) return null;
        return { slot, weapon };
      }).filter(Boolean);
    } else {
      const legacyWeapons = normalizeWeapons(form.weapon || [], {
        includeUnowned: true,
      });
      weapons = legacyWeapons.map((weapon, index) => ({
        slot: `legacy-${index}`,
        weapon,
      }));
    }

    const hasUnarmedStrike = weapons.some(({ weapon }) => {
      const name = typeof weapon?.name === 'string' ? weapon.name.trim() : '';
      return name.toLowerCase() === 'unarmed strike';
    });

    if (hasUnarmedStrike) {
      return weapons;
    }

    return [
      ...weapons,
      {
        slot: 'unarmed-strike',
        weapon: {
          name: 'Unarmed Strike',
          damage: unarmedStrikeDamage,
          type: 'Unarmed',
          category: 'Melee Weapon',
          properties: [],
          source: 'weapon',
        },
      },
    ];
  }, [
    beastForm,
    form.occupation,
    form.proficiencyBonus,
    strMod,
    dexMod,
    equipmentProvided,
    normalizedEquipment,
    form.weapon,
    unarmedStrikeDamage,
  ]);

  const abilityCharacterId = characterId || form?._id;
  const weaponAbilityStorageKey = abilityCharacterId ? `realmtracker:weaponAbilities:${abilityCharacterId}` : null;
  const [weaponAbilityPreferences, setWeaponAbilityPreferences] = useState(() => ({
    storageKey: weaponAbilityStorageKey,
    selections: readWeaponAbilityPreferences(weaponAbilityStorageKey),
  }));
  // Resolve a changed character identity immediately, before effects run.
  // Tactical Master (Fighter 9): the mastery property chosen for each weapon's attacks (null keeps the weapon's own).
  const [tacticalMasteryChoices, setTacticalMasteryChoices] = useState({});
  const weaponAbilitySelections = weaponAbilityPreferences.storageKey === weaponAbilityStorageKey
    ? weaponAbilityPreferences.selections : readWeaponAbilityPreferences(weaponAbilityStorageKey);
  const selectWeaponAbility = (slot, ability) => {
    const selections = { ...weaponAbilitySelections, [slot]: ability === 'dex' ? 'dex' : 'str' };
    if (weaponAbilityStorageKey && typeof window !== 'undefined') {
      try { window.localStorage.setItem(weaponAbilityStorageKey, JSON.stringify(selections)); }
      catch { /* Storage restrictions must not prevent choosing an attack ability. */ }
    }
    setWeaponAbilityPreferences({ storageKey: weaponAbilityStorageKey, selections });
  };
  const [weaponHandSelections, setWeaponHandSelections] = useState({});

  const numericStrMod = Number(strMod) || 0;
  const numericDexMod = Number(dexMod) || 0;
  const numericSpellAbilityMod = (() => {
    const parsed = Number(spellAbilityMod);
    return Number.isFinite(parsed) ? parsed : null;
  })();

  const spellAbilityLabel = useMemo(() => {
    if (!spellAbilityKey) {
      return 'Spellcasting Ability Modifier';
    }
    const normalizedKey = String(spellAbilityKey).toLowerCase();
    const abilityLabel = ABILITY_LABELS[normalizedKey];
    return `${abilityLabel || normalizedKey.toUpperCase()} Modifier`;
  }, [spellAbilityKey]);

  const formatModifier = useCallback(
    (value) => (value >= 0 ? `+${value}` : `${value}`),
    [],
  );

  const isFinesseWeapon = useCallback(
    (weapon) =>
      Array.isArray(weapon?.properties) &&
      weapon.properties.some(
        (prop) => typeof prop === 'string' && prop.toLowerCase().includes('finesse')
      ),
    []
  );

  const getWeaponCategoryString = useCallback((weapon) => {
    if (!weapon || typeof weapon !== 'object') {
      return '';
    }
    const candidates = [
      weapon.category,
      weapon.weaponCategory,
      weapon.weaponType,
      weapon.type,
    ];
    for (const candidate of candidates) {
      if (typeof candidate !== 'string') continue;
      const normalized = candidate.trim().toLowerCase();
      if (normalized) {
        return normalized;
      }
    }
    return '';
  }, []);

  const isRangedWeapon = useCallback(
    (weapon) => getWeaponCategoryString(weapon).includes('ranged'),
    [getWeaponCategoryString],
  );

  const isMeleeWeapon = useCallback(
    (weapon) => getWeaponCategoryString(weapon).includes('melee'),
    [getWeaponCategoryString],
  );

  const isUnarmedAttack = useCallback((weapon) => {
    if (!weapon || typeof weapon !== 'object') {
      return false;
    }
    const nameCandidates = [
      weapon.name,
      weapon.label,
      weapon.title,
      weapon.displayName,
    ];
    for (const candidate of nameCandidates) {
      if (typeof candidate !== 'string') continue;
      if (candidate.trim().toLowerCase() === 'unarmed strike') {
        return true;
      }
    }
    const typeString = getWeaponCategoryString(weapon);
    if (typeString.includes('unarmed')) {
      return true;
    }
    const rawType = String(weapon?.type || '').toLowerCase();
    return rawType.includes('unarmed');
  }, [getWeaponCategoryString]);

  const qualifiesForMonkDexterity = useCallback(
    (weapon) => {
      if (!hasMonkLevels || !canUseMartialArts(form)) {
        return false;
      }
      if (isUnarmedAttack(weapon)) {
        return true;
      }
      return isMonkWeapon(weapon);
    },
    [
      hasMonkLevels,
      form,
      isUnarmedAttack,
    ],
  );

  const getAbilityKeyForWeapon = (slot, weapon) => {
    if (qualifiesForMonkDexterity(weapon) || isFinesseWeapon(weapon)) {
      const stored = weaponAbilitySelections[slot];
      if (stored === 'str' || stored === 'dex') {
        return stored;
      }
      // A tie keeps Strength, so Strength-only features (Rage Damage, Reckless Attack) still apply.
      return numericDexMod > numericStrMod ? 'dex' : 'str';
    }
    if (isRangedWeapon(weapon)) {
      return 'dex';
    }
    return 'str';
  };

  useEffect(() => {
    setWeaponHandSelections({});
  }, [equippedWeapons]);
  // --------------------------------Breaks down weapon damage into useable numbers--------------------------------
  // Shillelagh: melee attacks with the held Club or Quarterstaff can use Wisdom (the Druid list's ability).
  const shillelaghApplies = (weapon) => hasShillelagh(combatState?.activeEffects, characterId) && isShillelaghWeapon(weapon);
  const trueStrikeEffect = activeRecipientBuff(combatState, characterId, 'true-strike');
  const abilityForWeapon = (weapon, slot) => {
    // True Strike's attack uses the spellcasting ability in place of Strength or Dexterity.
    if (trueStrikeEffect) return Number(trueStrikeEffect.spellMod) + magicWeaponBonus(combatState, characterId, slot, weapon);
    const key = getAbilityKeyForWeapon(slot, weapon);
    const base = key === 'dex' ? numericDexMod : numericStrMod;
    const wisdom = Number(wisMod);
    // Magic Weapon's bonus counts for attack and damage rolls alike, the two things this value feeds.
    return (shillelaghApplies(weapon) && Number.isFinite(wisdom) ? Math.max(base, wisdom) : base) + magicWeaponBonus(combatState, characterId, slot, weapon);
  };
  // The ability the attack actually uses: Wisdom when Shillelagh's Wisdom beats the weapon's own ability, so
  // Strength-only features (Rage Damage, Reckless Attack, Brutal Strike) don't apply to it.
  const attackAbilityKeyForWeapon = (slot, weapon) => {
    if (trueStrikeEffect) return 'spell';
    const key = getAbilityKeyForWeapon(slot, weapon);
    const base = key === 'dex' ? numericDexMod : numericStrMod;
    return shillelaghApplies(weapon) && Number(wisMod) > base ? 'wis' : key;
  };

  const formatWeaponLabel = (value) => {
    if (typeof value !== 'string') return 'Unknown';
    const normalized = value.replace(/[_-]+/g, ' ').trim();
    if (!normalized) return 'Unknown';
    return toTitleCase(normalized);
  };

  const getWeaponTypeLabel = (weapon) => {
    const raw = weapon?.type || weapon?.category;
    return formatWeaponLabel(raw || 'Unknown');
  };

  const getHandSelectionForWeapon = (slot, weapon) => {
    if (!getVersatileDamageDice(weapon)) {
      return HAND_SELECTIONS.ONE_HANDED;
    }
    const stored = weaponHandSelections[slot];
    if (stored === HAND_SELECTIONS.TWO_HANDED) {
      return HAND_SELECTIONS.TWO_HANDED;
    }
    return HAND_SELECTIONS.ONE_HANDED;
  };

  const getWeaponDamageForHandSelection = (
    slot,
    weapon,
    overrideHandSelection
  ) => {
    const baseDamage =
      typeof weapon?.damage === 'string' ? weapon.damage.trim() : '';
    if (!baseDamage) return '';

    const versatileDice = getVersatileDamageDice(weapon);
    if (!versatileDice) {
      return baseDamage;
    }

    const handSelection =
      overrideHandSelection ?? getHandSelectionForWeapon(slot, weapon);
    if (handSelection !== HAND_SELECTIONS.TWO_HANDED) {
      return baseDamage;
    }

    const match = baseDamage.match(firstDamageDiceRegex);
    if (!match) {
      const replaced = baseDamage.replace(anyDamageDiceRegex, versatileDice);
      if (replaced !== baseDamage) {
        return replaced;
      }
      return versatileDice;
    }

    const [, leading = ''] = match;
    return `${leading}${versatileDice}${baseDamage.slice(match[0].length)}`;
  };

  // Sacred Weapon (Oath of Devotion): the imbued weapon adds Charisma (minimum +1) to hit and can deal Radiant damage.
  const sacredWeaponFor = (weapon, slot) => {
    const effect = getSacredWeaponEffect(combatState?.activeEffects, characterId);
    return effect && effect.weaponInstanceId === getWeaponInstanceId(weapon, slot) ? effect : null;
  };
  const charismaModifier = Number.isFinite(Number(chaMod)) && chaMod !== null ? Number(chaMod) : Math.floor(((Number(form?.cha) || 10) - 10) / 2);
  // Peerless Skill on a roll made on the sheet: no DC is known here, so the player says whether the new total worked.
  const spendPeerlessSkillOn = useCallback(async (entry) => {
    const { sides } = getBardicInspirationProfile(form, charismaModifier);
    try {
      const die = await spendPeerlessSkillOnRoll({ characterId: String(characterId), requestId: entry.id, kind: 'check', sides, onCharacterChange,
        worked: async (rolled) => (await resolveFeatureDecision(peerlessSkillResultDecision(entry.id, Number(entry.total) + rolled, rolled, sides)))?.choiceId === 'use' });
      const total = Number(entry.total) + die.bonus;
      setDamageLog((previous) => previous.map((item) => (item.id === entry.id ? { ...item, total, peerlessSkill: die } : item)));
      notify(`Peerless Skill\n${entry.source || 'Roll'}: +${die.bonus} (d${die.sides}) — total ${total}.${die.spent ? '' : ' The use is kept.'}`, 'success');
    } catch (error) { notify(error.message, 'warning'); }
  }, [characterId, charismaModifier, form, onCharacterChange, resolveFeatureDecision]);
  const getDamageStringForHandSelection = (slot, weapon, overrideHandSelection) => {
    const damage = monkDamage(form, weapon, getWeaponDamageForHandSelection(slot, weapon, overrideHandSelection));
    const shaped = shillelaghApplies(weapon) ? shillelaghDamage(damage, totalLevel) : damage;
    return sacredWeaponFor(weapon, slot)?.radiant ? sacredWeaponDamage(shaped) : shaped;
  };

  const getWeaponPropertyDefinitionKeys = (prop) => {
    if (typeof prop !== 'string') return [];

    const base = prop
      .replace(/\s*[\(\[\{][^\)\]\}]*[\)\]\}]\s*/g, ' ')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!base) return [];

    const titleCase = toTitleCase(base);
    const candidates = new Set([titleCase]);

    if (titleCase.includes(' ')) {
      candidates.add(titleCase.replace(/\s+/g, '-'));
    }

    if (!titleCase.endsWith(':')) {
      candidates.add(`${titleCase}:`);
    }

    return Array.from(candidates);
  };

  const getWeaponPropertyDetails = (weapon) => {
    if (!Array.isArray(weapon?.properties)) return [];
    return weapon.properties
      .filter((prop) => typeof prop === 'string' && prop.trim())
      .map((prop) => {
        const label = formatWeaponLabel(prop);
        const definitionKey = getWeaponPropertyDefinitionKeys(prop).find(
          (key) => weaponPropertyDefinitions[key]
        );
        const description = definitionKey
          ? weaponPropertyDefinitions[definitionKey]
          : 'Definition not available.';
        return { label, description };
      });
  };

  const getWeaponMasteryDetails = (weapon) => {
    if (!weapon || typeof weapon !== 'object') return null;

    const rawMastery =
      typeof weapon.mastery === 'string' ? weapon.mastery.trim() : '';
    const masteryKey = rawMastery.toLowerCase();

    if (masteryKey) {
      const explicit = weaponMasteryDefinitions[masteryKey];
      if (explicit) {
        return { ...explicit };
      }
    }

    const typeCandidates = [weapon.type, weapon.weaponType, weapon.itemType];
    for (const typeCandidate of typeCandidates) {
      if (typeof typeCandidate !== 'string') continue;
      const normalizedType = typeCandidate.trim().toLowerCase();
      if (!normalizedType) continue;
      const inferredKey = weaponTypeMasteries[normalizedType];
      if (!inferredKey) continue;
      const inferredDetail = weaponMasteryDefinitions[inferredKey];
      if (inferredDetail) {
        return { ...inferredDetail };
      }
      return {
        label: formatWeaponLabel(inferredKey),
        description: 'Definition not available.',
      };
    }

    if (masteryKey) {
      return {
        label: formatWeaponLabel(rawMastery),
        description: 'Definition not available.',
      };
    }

    return null;
  };

  const totalLevel = useMemo(
    () =>
      Array.isArray(form.occupation)
        ? form.occupation.reduce((total, el) => total + Number(el.Level), 0)
        : 0,
    [form.occupation]
  );

  const { tieflingLegacy, tieflingLegacyKey } = useMemo(() => {
    const race = form?.race || {};
    const legacyFromForm =
      typeof form?.tieflingLegacy === 'object' ? form.tieflingLegacy : null;
    const legacyKeyFromForm =
      typeof form?.tieflingLegacyKey === 'string' ? form.tieflingLegacyKey : '';

    let legacy = legacyFromForm;
    let legacyKey = legacyKeyFromForm;

    if (!legacy) {
      if (legacyKey && race?.fiendishLegacies?.[legacyKey]) {
        legacy = race.fiendishLegacies[legacyKey];
      } else if (race?.selectedAncestry && race?.fiendishLegacies) {
        legacy = race.selectedAncestry;
        legacyKey =
          typeof race?.selectedAncestryKey === 'string'
            ? race.selectedAncestryKey
            : '';
      } else if (
        typeof race?.selectedAncestryKey === 'string' &&
        race?.fiendishLegacies?.[race.selectedAncestryKey]
      ) {
        legacy = race.fiendishLegacies[race.selectedAncestryKey];
        legacyKey = race.selectedAncestryKey;
      }
    }

    return { tieflingLegacy: legacy, tieflingLegacyKey: legacyKey };
  }, [form?.race, form?.tieflingLegacy, form?.tieflingLegacyKey]);

  const tieflingLegacyLabel = useMemo(() => {
    if (typeof tieflingLegacy?.label === 'string') {
      return tieflingLegacy.label;
    }
    if (typeof tieflingLegacy?.name === 'string') {
      return tieflingLegacy.name;
    }
    if (tieflingLegacyKey) {
      return toTitleCase(tieflingLegacyKey.replace(/[-_]/g, ' '));
    }
    return 'Fiendish Legacy';
  }, [tieflingLegacy, tieflingLegacyKey]);

  // Favored Enemy: Hunter's Mark is always prepared for a Ranger. Free level 1 casts come from the Favored Enemy
  // tile; the spell list entry casts it with a slot (and can upcast for a longer duration).
  const favoredEnemySpell = useMemo(() => (hasRangerFeature(form, 'favoredEnemy') ? {
    spellId: HUNTERS_MARK_SPELL_ID, name: "Hunter's Mark", level: 1, featureGrantId: FAVORED_ENEMY_GRANT_ID,
    source: { sourceType: 'class-feature', sourceId: FAVORED_ENEMY_GRANT_ID, classId: 'ranger' },
  } : null), [form]);
  // Cantrip Fighting Style spells (Druidic Warrior, Blessed Warrior) that a rules engine resolves (spell
  // attacks such as Starry Wisp, save damage such as Sacred Flame, buffs such as Guidance) join the spell list
  // as class feature spells; the server resolves `class-feature:<grantId>`.
  const styleCantripSpells = useMemo(() => getStyleCantripGrants(form)
    .map(({ spellId, grantId, classId, styleName }) => ({ spellId, name: spellsCatalog[spellId]?.name || spellId, level: 0, spellInstanceId: `class-feature:${grantId}`,
      featureGrantId: grantId, styleName, source: { sourceType: 'class-feature', sourceId: grantId, classId } }))
    .filter((entry) => getDirectSpellDefinition(entry.spellId) || getBuffSpellDefinition(entry.spellId) || isAuthoritativeSaveDamageAccess(entry))
    .flatMap((entry) => (getBuffSpellDefinition(entry.spellId) && getDirectSpellDefinition(entry.spellId) ? [entry, { ...entry, castMode: 'attack' }] : [entry])), [form]);
  // Magic Initiate (feat) spells with an engine join the spell list the same way, using the feat's ability. Cantrips
  // also get an action-bar tile; the level 1 spell casts with a slot here and free from its own tile.
  const magicInitiateSpells = useMemo(() => getMagicInitiateGrants(form)
    .map(({ spellId, grantId, list, level }) => ({ spellId, name: spellsCatalog[spellId]?.name || spellId, level, spellInstanceId: `class-feature:${grantId}`,
      featureGrantId: grantId, styleName: `Magic Initiate (${MAGIC_INITIATE_LISTS[list]})`, source: { sourceType: 'class-feature', sourceId: grantId } }))
    .filter((entry) => getDirectSpellDefinition(entry.spellId) || getBuffSpellDefinition(entry.spellId) || getHealingSpellDefinition(entry.spellId) || isCastAccess(entry))
    .flatMap((entry) => (getBuffSpellDefinition(entry.spellId) && getDirectSpellDefinition(entry.spellId) ? [entry, { ...entry, castMode: 'attack' }] : [entry])), [form]);
  // Oath of Devotion and Life Domain spells are always prepared and cast with that class's slots through their grant.
  // Those with an engine (Shield of Faith, Cure Wounds) join the spell list; the others cast from their Features card.
  const oathSpells = useMemo(() => [
    ...getDevotionOathSpells(form).map((spellId) => ({ spellId, grantId: oathSpellGrantId(spellId), classId: 'paladin' })),
    ...getLifeDomainSpells(form).filter((spellId) => !(form.spells || []).some((spell) => spell?.spellId === spellId)).map((spellId) => ({ spellId, grantId: domainSpellGrantId(spellId), classId: 'cleric' })),
  ].map(({ spellId, grantId, classId }) => ({ spellId, name: spellsCatalog[spellId]?.name || spellId, level: Number(spellsCatalog[spellId]?.level) || 1, featureGrantId: grantId,
      spellInstanceId: `class-feature:${grantId}`, source: { sourceType: 'class-feature', sourceId: grantId, classId } }))
    .filter((entry) => getDirectSpellDefinition(entry.spellId) || getBuffSpellDefinition(entry.spellId) || getHealingSpellDefinition(entry.spellId) || isCastAccess(entry)), [form]);
  // Magical Discoveries (College of Lore 6) and Words of Creation (Bard 20) with an engine join the spell list the same way,
  // with the Bard's slots and Charisma.
  const discoverySpells = useMemo(() => [
    ...(hasLoreFeature(form, 'magicalDiscoveries') ? getMagicalDiscoveries(form) : []).map((spellId) => ({ spellId, grantId: discoveryGrantId(spellId), styleName: 'Magical Discovery' })),
    ...getWordsOfCreationSpells(form).map((spellId) => ({ spellId, grantId: wordsGrantId(spellId), styleName: 'Words of Creation' })),
    ...getLandSpells(form).map((spellId) => ({ spellId, grantId: landSpellGrantId(spellId), styleName: 'Circle Spell', classId: 'druid' })),
  ].filter(({ spellId }) => !(form.spells || []).some((spell) => spell?.spellId === spellId))
    .map(({ spellId, grantId, styleName, classId = 'bard' }) => ({ spellId, name: spellsCatalog[spellId]?.name || spellId, level: Number(spellsCatalog[spellId]?.level) || 0, spellInstanceId: `class-feature:${grantId}`,
      featureGrantId: grantId, styleName, source: { sourceType: 'class-feature', sourceId: grantId, classId } }))
    .filter((entry) => getDirectSpellDefinition(entry.spellId) || getBuffSpellDefinition(entry.spellId) || getHealingSpellDefinition(entry.spellId) || isCastAccess(entry))
    .flatMap((entry) => (getBuffSpellDefinition(entry.spellId) && getDirectSpellDefinition(entry.spellId) ? [entry, { ...entry, castMode: 'attack' }] : [entry])), [form]);
  const fiendishLegacySpells = useMemo(() => {
    if (!tieflingLegacy) return [];
    const spells = Array.isArray(tieflingLegacy?.spells)
      ? tieflingLegacy.spells
      : [];

    return spells
      .map((legacySpell) => {
        const requiredLevelRaw = Number(legacySpell?.unlockedAtLevel);
        const requiredLevel = Number.isFinite(requiredLevelRaw)
          ? requiredLevelRaw
          : 1;
        if (totalLevel < Math.max(1, requiredLevel)) {
          return null;
        }

        const name =
          typeof legacySpell?.name === 'string' ? legacySpell.name.trim() : '';
        if (!name) return null;

        const catalogSpell = SPELLS_BY_NAME[name.toLowerCase()] || null;

        let damage = '';
        if (typeof legacySpell?.damage === 'string' && legacySpell.damage.trim()) {
          damage = legacySpell.damage.trim();
        } else if (catalogSpell?.damage) {
          damage = catalogSpell.damage;
        }

        if (!damage) return null;

        const level = Number.isFinite(catalogSpell?.level)
          ? catalogSpell.level
          : parseSpellLevel(legacySpell?.spellLevel);

        return {
          name: catalogSpell?.name || name,
          level: Number.isFinite(level) ? level : 0,
          damage,
          castingTime: catalogSpell?.castingTime || '',
          range: catalogSpell?.range || '',
          duration: catalogSpell?.duration || '',
          higherLevels: catalogSpell?.higherLevels,
          scaling: catalogSpell?.scaling,
          casterType: tieflingLegacyLabel,
        };
      })
      .filter(Boolean);
  }, [tieflingLegacy, tieflingLegacyLabel, totalLevel]);

  const profBonus =
    form.proficiencyBonus ?? proficiencyBonus(totalLevel);

  const cunningActionEntitled = hasCunningAction(form);
  const steadyAimEntitled = hasSteadyAim(form);
  const currentCunningLedger = combatState?.turnActionLedger?.combatantId === String(characterId) &&
    combatState?.turnActionLedger?.turnSequence === combatState?.turnSequence ? combatState.turnActionLedger : null;
  const cunningActionAvailable = cunningActionEntitled && isActiveTurn && campaignId && !currentCunningLedger?.bonusActionSpent;
  const cunningActionUnavailableReason = !isActiveTurn
    ? 'Available on your turn in structured combat.'
    : currentCunningLedger?.bonusActionSpent
      ? 'Bonus Action already spent this turn.'
      : 'Cunning Action is unavailable.';
  const movedThisTurn = hasMovedThisTurn(combatState, characterId);
  const steadyAimActive = Boolean(getSteadyAimAdvantage(combatState, characterId));
  const steadyAimAvailable = steadyAimEntitled && isActiveTurn && campaignId && !currentCunningLedger?.bonusActionSpent && !movedThisTurn && !steadyAimActive;
  const steadyAimUnavailableReason = movedThisTurn ? 'Unavailable after moving this turn.'
    : currentCunningLedger?.bonusActionSpent ? 'Bonus Action already spent this turn.' : 'Available on your turn in structured combat.';
  const executeSteadyAim = useCallback(async () => {
    if (!steadyAimAvailable) return;
    const resolutionId = `steady-aim:${characterId}:${combatState.turnSequence}:${Date.now()}`;
    try {
      const committed = await commitSteadyAim(campaignId, { combatantId: String(characterId), turnSequence: combatState.turnSequence, resolutionId });
      if (committed.ledger) onActionEconomyReconciled(committed.ledger);
      if (committed.combat) onCombatStateReconciled(committed.combat);
      notify('Steady Aim\nAdvantage · Next Attack\nSpeed 0 until end of turn', 'success');
    } catch (error) { notify(error?.payload?.reason || error.message || 'Steady Aim could not be completed.', 'warning'); }
  }, [campaignId, characterId, combatState, onActionEconomyReconciled, onCombatStateReconciled, steadyAimAvailable]);

  const executeCunningAction = useCallback(async (action) => {
    if (!cunningActionAvailable || cunningActionPending) return;
    setCunningActionPending(true);
    const resolutionId = `cunning-action:${action}:${characterId}:${combatState.turnSequence}:${Date.now()}`;
    try {
      const committed = await commitCunningAction(campaignId, {
        combatantId: String(characterId), turnSequence: combatState.turnSequence, resolutionId, action,
      });
      if (!['spent', 'replayed'].includes(committed?.status)) throw new Error(committed?.reason || 'The Bonus Action is no longer available.');
      if (committed.ledger) onActionEconomyReconciled(committed.ledger);
      if (committed.combat) onCombatStateReconciled(committed.combat);
      if (action === 'dash') {
        const grant = committed.ledger?.movementGrants?.find((item) => item.resolutionId === resolutionId);
        notify(`Cunning Action: Dash\n+${grant?.amount ?? 0} ft. movement this turn .`, 'success');
      } else if (action === 'disengage') {
        notify('Cunning Action: Disengage\nDisengaged for this turn. Your movement does not provoke Opportunity Attacks.', 'success');
      } else {
        await prepareDiceRollSurface('Dexterity (Stealth)');
        const bonus = getStealthCheckBonus(form, dexMod, profBonus);
        const rolled = await rollSkillWithDiceBox(bonus, {
          diceColor: normalizeDiceColor(form?.diceColor) || DEFAULT_DICE_COLOR, rollContext: 'skill-check', character: form, source: 'Cunning Action: Hide',
          proficient: getSkillTraining(form, 'stealth').proficient,
          rollMode: resolveAbilityCheckRollMode(form, 'dex', { combatState, skillKey: 'stealth', targetCombatantId: String(characterId) }).mode,
          diceModifiers: getBuffSkillDiceModifiers(combatState, String(characterId), 'stealth'),
        });
        let total = rolled.result;
        const usedD20 = rolled.effectiveD20 ?? rolled.keptD20 ?? rolled.d20;
        // Stroke of Luck (Rogue 20) makes the d20 a 20; Heroic Inspiration rerolls the (lower) d20.
        const rescue = total < 15 ? await offerSaveRescue(form, { id: resolutionId, what: 'Stealth check to Hide', outcome: `${total + 20 - usedD20} vs DC 15`, save: false }) : {};
        if (rescue.strokeOfLuck) {
          const claimed = await claimStrokeOfLuck(String(characterId), { requestId: resolutionId, kind: 'check' });
          onCharacterChange?.(previous => withStrokeOfLuck(previous, claimed.strokeOfLuck));
          total += 20 - usedD20;
        } else if (rescue.fate) {
          const fate = await spendFateOnRoll({ characterId: String(characterId), requestId: resolutionId, kind: 'check', onCharacterChange });
          total += fate.bonus;
          notify(`Boon of Fate
Stealth: +${fate.bonus} (2d4: ${fate.rolls.join(', ')}) — total ${total}.`, 'info');
        } else if (rescue.peerlessSkill) {
          const { sides } = getBardicInspirationProfile(form, charismaModifier);
          const die = await spendPeerlessSkillOnRoll({ characterId: String(characterId), requestId: resolutionId, kind: 'check', sides, onCharacterChange, worked: async (rolled) => total + rolled >= 15 });
          total += die.bonus;
          notify(`Peerless Skill\nStealth: +${die.bonus} (d${die.sides}) — total ${total}.${die.spent ? '' : ' The use is kept.'}`, 'info');
        } else if (rescue.bardicInspiration) {
          const die = await spendBardicDieOnRoll({ character: form, characterId: String(characterId), requestId: resolutionId, kind: 'check', onCharacterChange });
          total += die.bonus;
          notify(`Bardic Inspiration\nStealth: +${die.bonus} (d${die.sides}) — total ${total}.`, 'info');
        } else if (rescue.heroicInspiration) {
          const reroll = await rerollWithHeroicInspiration({ character: form, characterId: String(characterId), requestId: resolutionId, kind: 'check',
            rollMode: rolled.rollMode, kept: rolled.keptD20 ?? rolled.d20, dice: rolled.rolledD20s, onCharacterChange, prepareRoll: prepareReroll });
          total += resolveAbilityCheckDie(reroll.d20, { character: form, rollContext: 'skill-check', proficient: getSkillTraining(form, 'stealth').proficient }).effectiveD20 - usedD20;
          notify(`Heroic Inspiration\nStealth: rerolled a d20 (${reroll.newDie}) — total ${total}.`, 'info');
        }
        const resolved = await resolveCunningActionHide(campaignId, {
          combatantId: String(characterId), turnSequence: combatState.turnSequence, resolutionId, total,
        });
        if (!['resolved', 'replayed'].includes(resolved?.status)) throw new Error(resolved?.reason || 'The Hide result could not be recorded.');
        if (resolved.combat) onCombatStateReconciled(resolved.combat);
        notify(`Hide\nStealth ${total} vs DC 15 — ${resolved.success ? `Success\nHidden · Detection DC ${total}` : 'Failed'}`,
          resolved.success ? 'success' : 'warning');
      }
    } catch (error) {
      notify(error?.payload?.reason || error.message || 'Cunning Action could not be completed.', 'warning');
    } finally {
      setCunningActionPending(false);
    }
  }, [campaignId, characterId, combatState, cunningActionAvailable, cunningActionPending, dexMod, form, onActionEconomyReconciled, onCombatStateReconciled, prepareDiceRollSurface, profBonus]);

  const cunningActionTiles = cunningActionEntitled ? (
    <div
      className={`combat-hud-feature-actions${featureActionTarget ? '' : ' combat-hud-feature-actions--standalone'}`}
      data-testid="feature-action-area"
      aria-label="Cunning Action"
    >
      {[
        { action: 'dash', label: 'Dash', Icon: Gauge },
        { action: 'disengage', label: 'Disengage', Icon: Footprints },
        { action: 'hide', label: 'Hide', Icon: EyeOff },
      ].map(({ action, label, Icon }) => (
        <button
          key={action}
          type="button"
          data-action-tile={`cunning:${action}`}
          className="combat-hud-resource-tile combat-hud-feature-action-tile"
          style={{ '--hud-resource-accent': '#77bdfb' }}
          aria-label={`Cunning Action: ${label}`}
          title={cunningActionAvailable ? `Cunning Action: ${label}` : cunningActionUnavailableReason}
          disabled={!cunningActionAvailable || cunningActionPending}
          onClick={() => action === 'hide' ? setShowHideConfirmation(true) : executeCunningAction(action)}
        >
          <span className="combat-hud-resource-tile__icon" aria-hidden="true"><Icon size={20} /></span>
          <span className="combat-hud-resource-tile__name">{label}</span>
        </button>
      ))}
      {steadyAimEntitled && <button type="button" data-action-tile="steady-aim" className="combat-hud-resource-tile combat-hud-feature-action-tile"
        style={{ '--hud-resource-accent': '#77bdfb' }} aria-label="Steady Aim"
        title={steadyAimAvailable ? 'Steady Aim: Advantage on your next attack; Speed 0 this turn.' : steadyAimUnavailableReason}
        disabled={!steadyAimAvailable} onClick={executeSteadyAim}>
        <span className="combat-hud-resource-tile__icon" aria-hidden="true"><Crosshair size={20} /></span>
        <span className="combat-hud-resource-tile__name">Steady Aim{steadyAimActive ? ' · Advantage · Next Attack' : ''}</span>
      </button>}
    </div>
  ) : null;

  const dragonbornAncestry = useMemo(() => {
    const race = form?.race;
    if (!race) return null;
    const raceName = typeof race?.name === 'string' ? race.name.toLowerCase() : '';
    if (raceName !== 'dragonborn') return null;

    if (race.selectedAncestry) return race.selectedAncestry;

    if (race.selectedAncestryKey && race.dragonAncestries) {
      const selected = race.dragonAncestries[race.selectedAncestryKey];
      if (selected) return selected;
    }

    if (form?.dragonAncestry) return form.dragonAncestry;

    if (form?.dragonAncestryKey && race.dragonAncestries) {
      return race.dragonAncestries[form.dragonAncestryKey] || null;
    }

    return null;
  }, [form?.race, form?.dragonAncestry, form?.dragonAncestryKey]);

  const breathWeaponDetails = useMemo(() => {
    if (!dragonbornAncestry) return null;

    const diceCount =
      totalLevel >= 17 ? 4 : totalLevel >= 11 ? 3 : totalLevel >= 5 ? 2 : 1;
    const damageType = dragonbornAncestry.damageType || '';
    const damageString = `${diceCount}d10${damageType ? ` ${damageType}` : ''}`;
    const numericConMod = Number(conMod) || 0;

    // 2024: the player picks Cone or Line each use and the save is always Dexterity, whatever an older
    // ancestry snapshot says.
    return {
      label: dragonbornAncestry.label || 'Breath Weapon',
      damageString,
      damageType,
      diceCount,
      saveDC: 8 + numericConMod + profBonus,
      shape: BREATH_WEAPON_SHAPE_TEXT,
      save: BREATH_WEAPON_SAVE,
    };
  }, [dragonbornAncestry, conMod, profBonus, totalLevel]);

  const getCatalogSpell = useCallback((spell) => {
    const rawName = typeof spell?.name === 'string' ? spell.name : '';
    const normalized = rawName.trim().toLowerCase();
    if (!normalized) {
      return null;
    }
    return SPELLS_BY_NAME[normalized] || null;
  }, []);

  const isRangedSpellAttack = useCallback(
    (spell) => {
      if (!spell) return false;
      if (getDirectSpellDefinition(spell.spellId)) return true;
      if (spell.rangedSpellAttack !== undefined) {
        return Boolean(spell.rangedSpellAttack);
      }
      const catalogSpell = getCatalogSpell(spell);
      if (catalogSpell?.rangedSpellAttack !== undefined) {
        return Boolean(catalogSpell.rangedSpellAttack);
      }
      const description =
        typeof spell?.description === 'string'
          ? spell.description
          : typeof catalogSpell?.description === 'string'
          ? catalogSpell.description
          : '';
      return detectRangedSpellAttack(description);
    },
    [getCatalogSpell],
  );

  const getSpellAttackDetails = useCallback(
    (spell) => {
      if (spell?.attackDetails) return spell.attackDetails;
      const direct = getDirectSpellDefinition(spell?.spellId);
      const profile = !direct ? null : spell.source?.sourceType === 'class' ? getClassCastingProfile(spell.source.sourceId)
        : spell.source?.sourceType === 'class-feature' && spell.source.classId ? getClassCastingProfile(spell.source.classId) : null;
      const sourceModifier = { intelligence: intMod, wisdom: wisMod, charisma: chaMod }[profile?.spellcasting?.ability];
      const resolvedModifier = profile ? Number(sourceModifier) : numericSpellAbilityMod;
      if (resolvedModifier === null || !Number.isFinite(resolvedModifier)) {
        return null;
      }
      if (!direct && !isRangedSpellAttack(spell)) {
        return null;
      }
      const abilityBonus = resolvedModifier;
      const proficiencyBonusValue = Number.isFinite(profBonus)
        ? profBonus
        : 0;
      const catalogSpell = getCatalogSpell(spell);
      const extraRaw = Number(
        spell?.attackBonus ??
          spell?.bonus ??
          catalogSpell?.attackBonus ??
          catalogSpell?.bonus ??
          0,
      );
      const extraBonus = Number.isFinite(extraRaw) ? extraRaw : 0;
      return {
        total: abilityBonus + proficiencyBonusValue + extraBonus,
        abilityBonus,
        proficiencyBonus: proficiencyBonusValue,
        extraBonus,
      };
    },
    [getCatalogSpell, isRangedSpellAttack, numericSpellAbilityMod, profBonus, intMod, wisMod, chaMod],
  );

  const getAttackBonus = (slot, weapon) =>
    profBonus +
    abilityForWeapon(weapon, slot) +
    Number(weapon?.attackBonus ?? weapon?.bonus ?? 0) +
    archeryAttackBonus(form, weapon) +
    (sacredWeaponFor(weapon, slot) ? sacredWeaponAttackBonus(charismaModifier) : 0);
    
  const normalizeDamageTypeForClass = (type) => {
    const trimmed = (type || '').trim();
    if (!trimmed) {
      return '';
    }

    const tokens = trimmed
      .toLowerCase()
      .split(/[^a-z]+/)
      .map((token) => token.trim())
      .filter((token) => !DAMAGE_TYPE_CLASS_TOKEN_IGNORE.has(token));

    if (tokens.length === 0) {
      return '';
    }

    return tokens.join('-');
  };

  const formatDamageSegments = (damage, ability) =>
    damage
      .split(/\s+\+\s+/)
      .map((part, i, arr) => {
        const [token, ...rest] = part.trim().split(' ');
        const type = rest.join(' ').trim();
        const normalizedType = normalizeDamageTypeForClass(type);
        const displayType = type ? toTitleCase(type) : '';
        const showAbility = ability !== undefined && ability !== null && i === 0;
        return (
          <React.Fragment key={i}>
            <span className={normalizedType ? `damage-${normalizedType}` : ''}>
              {token}
              {showAbility ? `+${ability}` : ''}
              {displayType ? ` ${displayType}` : ''}
            </span>
            {i < arr.length - 1 ? ' + ' : ''}
          </React.Fragment>
        );
      });

  const getDamageString = (slot, weapon) => {
    const ability = abilityForWeapon(weapon, slot);
    const damageString = getDamageStringForHandSelection(slot, weapon);
    if (!damageString) return 'Unknown';
    return formatDamageSegments(damageString, ability);
  };

  const getWeaponDisplayName = (slot, weapon) => {
    if (weapon?.name && typeof weapon.name === 'string') {
      const trimmed = weapon.name.trim();
      if (trimmed) {
        return trimmed;
      }
    }

    if (typeof slot === 'string') {
      const normalized = slot
        .replace(/([A-Z])/g, ' $1')
        .replace(/[_-]+/g, ' ')
        .trim();
      if (normalized) {
        return toTitleCase(normalized);
      }
    }

    return 'Attack';
  };


  // Line icons in the class feature tiles' style (utils/actionIcons.js).
  const getAttackIcon = useCallback((attack = {}) => actionIcon(attack), []);

  const extractDamageTypeText = useCallback((damage = '') => {
    if (typeof damage !== 'string') return '';
    const types = damage.match(/\b(acid|bludgeoning|cold|fire|force|lightning|necrotic|piercing|poison|psychic|radiant|slashing|thunder)\b/gi);
    return types ? [...new Set(types.map(toTitleCase))].join(', ') : '';
  }, []);

  const makeRecent = useCallback((id) => {
    setRecentAttackIds((prev) => [id, ...prev.filter((value) => value !== id)].slice(0, 5));
  }, []);

  const toggleAttackFavorite = useCallback((id) => {
    setFavoriteAttackIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);


  const diceFaceColor = useMemo(
    () => normalizeDiceColor(form?.diceColor) || DEFAULT_DICE_COLOR,
    [form?.diceColor],
  );

  const diceBoxThemeRef = useRef(null);

  useEffect(() => {
    applyDiceFaceColor(diceFaceColor);
    setDiceBoxThemeColor(diceFaceColor);
    diceBoxThemeRef.current = diceFaceColor;
  }, [diceFaceColor]);

  const rollDamageExpression = useCallback(
    async ({
      damageString,
      ability = 0,
      crit = false,
      extraDice,
      levelsAbove = 0,
      options,
      damageComponents = [],
      inheritedDamageType = null,
    }) => {
      if (typeof damageString !== 'string') return null;
      const trimmed = damageString.trim();
      if (!trimmed) return null;

      const requests = [];
      const validation = calculateDamage(
        trimmed,
        ability,
        crit,
        (count, sides, meta) => {
          requests.push({ count, sides, ...(meta?.category ? { category: meta.category } : {}) });
          return Array(count).fill(1);
        },
        extraDice,
        levelsAbove,
        options,
      );

      if (!validation) {
        return null;
      }

      const weaponRequestCount = requests.length;
      const componentRequests = buildDamageComponentDiceRequests(damageComponents, {
        critical: crit,
        inheritedDamageType,
      });
      requests.push(...componentRequests);

      const diceRolls = Array.isArray(validation?.diceRolls)
        ? validation.diceRolls
        : [];

      const classifyTypeColor = (typeValue) => {
        const normalizedType = normalizeDamageTypeForClass(typeValue || '');
        if (!normalizedType) {
          return { normalizedType: '', color: null, isColorless: true, isMixed: false };
        }

        const tokens = normalizedType.split('-').filter(Boolean);
        const isMixed = tokens.length > 1;
        if (isMixed) {
          return {
            normalizedType,
            color: null,
            isColorless: true,
            isMixed: true,
          };
        }

        const color = resolveDamageTypeColor(normalizedType) || null;
        return {
          normalizedType,
          color,
          isColorless: !color,
          isMixed: false,
        };
      };

      const requestDetails = (() => {
        if (!Array.isArray(requests) || requests.length === 0) {
          return [];
        }

        let placeholderIndex = 0;
        return requests.map((request = {}) => {
          const rawCount = Number(request?.count);
          const rawSides = Number(request?.sides);
          const count = Number.isFinite(rawCount) ? Math.max(0, Math.floor(rawCount)) : 0;
          const sides =
            Number.isFinite(rawSides) && rawSides > 0 ? Math.round(rawSides) : null;

          const sliceEnd = placeholderIndex + count;
          const subset = diceRolls.slice(placeholderIndex, sliceEnd);
          placeholderIndex = sliceEnd;

          if (!Array.isArray(subset) || subset.length === 0) {
            const classification = classifyTypeColor(request.damageType);
            return { count, sides, color: classification.color, ...request };
          }

          const analysis = subset.reduce(
            (acc, detail) => {
              const classification = classifyTypeColor(detail?.type);
              if (classification.color && !classification.isMixed) {
                acc.colors.add(classification.color);
              } else {
                acc.hasColorless = true;
              }
              return acc;
            },
            { colors: new Set(), hasColorless: false },
          );

          const uniqueColors = Array.from(analysis.colors);
          const color =
            uniqueColors.length === 1 && !analysis.hasColorless ? uniqueColors[0] : null;

          return { ...request, count, sides, color };
        });
      })();

      const resolveRollThemeColor = () => {
        const diceTheme = (() => {
          if (!Array.isArray(diceRolls) || diceRolls.length === 0) {
            return null;
          }

          const uniqueColors = new Set();
          let hasColorless = false;

          diceRolls.forEach((die) => {
            const classification = classifyTypeColor(die?.type);
            if (classification.color && !classification.isMixed) {
              uniqueColors.add(classification.color);
            } else {
              hasColorless = true;
            }
          });

          if (uniqueColors.size === 1 && !hasColorless) {
            return Array.from(uniqueColors)[0];
          }

          return null;
        })();

        if (diceTheme) {
          return diceTheme;
        }

        if (!Array.isArray(requestDetails) || requestDetails.length === 0) {
          return diceFaceColor;
        }

        const uniqueColors = new Set();

        requestDetails.forEach((detail) => {
          if (!detail || detail.count <= 0) {
            return;
          }

          if (detail.color) {
            uniqueColors.add(detail.color);
          }
        });

        if (uniqueColors.size === 1) {
          return Array.from(uniqueColors)[0];
        }

        return diceFaceColor;
      };

      const rollThemeColor = resolveRollThemeColor();

      if (requests.length === 0) {
        const themeHasChanged = rollThemeColor !== diceBoxThemeRef.current;
        if (themeHasChanged) {
          setDiceBoxThemeColor(rollThemeColor);
          diceBoxThemeRef.current = rollThemeColor;
          await waitForNextAnimationFrame();
        }
        const staticResult = calculateDamage(
          trimmed,
          ability,
          crit,
          rollDice,
          extraDice,
          levelsAbove,
          options,
        );
        return staticResult ? { ...staticResult, rollValues: undefined } : null;
      }

      await prepareDiceRollSurface('Damage');

      const rollPlan = (() => {
        if (!Array.isArray(requests) || requests.length === 0) {
          return [];
        }

        const groups = [];
        let currentGroup = null;

        requests.forEach((request, index) => {
          const rawCount = Number(request?.count);
          const rawSides = Number(request?.sides);
          const count = Number.isFinite(rawCount) ? Math.max(0, Math.floor(rawCount)) : 0;
          const sides =
            Number.isFinite(rawSides) && rawSides > 0 ? Math.round(rawSides) : null;

          if (!count || !sides) {
            currentGroup = null;
            return;
          }

          const detail = Array.isArray(requestDetails) ? requestDetails[index] : null;
          const color = detail?.color || null;

          if (!currentGroup || currentGroup.color !== color) {
            currentGroup = { color, items: [] };
            groups.push(currentGroup);
          }

          const themeColor = DIE_COLOR_BY_CATEGORY[request?.category];
          currentGroup.items.push({ count, sides, requestIndex: index, ...(themeColor ? { themeColor } : {}) });
        });

        return groups.filter((group) => group.items.length > 0);
      })();

      const executeRollPlan = async () => {
        const collected = Array.from({ length: requests.length }, () => null);

        if (!Array.isArray(rollPlan) || rollPlan.length === 0) {
          const themeHasChanged = diceFaceColor !== diceBoxThemeRef.current;
          if (themeHasChanged) {
            setDiceBoxThemeColor(diceFaceColor);
            diceBoxThemeRef.current = diceFaceColor;
            await waitForNextAnimationFrame();
          }
          return collected;
        }

        // eslint-disable-next-line no-await-in-loop
        for (const group of rollPlan) {
          if (!group || !Array.isArray(group.items) || group.items.length === 0) {
            continue;
          }

          const targetColor = group.color || diceFaceColor;
          if (targetColor !== diceBoxThemeRef.current) {
            setDiceBoxThemeColor(targetColor);
            diceBoxThemeRef.current = targetColor;
            await waitForNextAnimationFrame();
          }

          const groupRequests = group.items.map(({ count, sides, themeColor }) => ({
            count: Math.max(1, Math.round(count || 0)),
            sides: Math.max(1, Math.round(sides || 0)),
            ...(themeColor ? { themeColor } : {}),
          }));

          const { rolls } = await rollSharedDiceWithBox(groupRequests);
          group.items.forEach(({ requestIndex }, idx) => {
            if (typeof requestIndex !== 'number' || requestIndex < 0) {
              return;
            }
            const raw = Array.isArray(rolls) ? rolls[idx] : undefined;
            collected[requestIndex] = raw;
          });
        }

        return collected;
      };

      try {
        const themeHasChanged = rollThemeColor !== diceBoxThemeRef.current;
        if (themeHasChanged) {
          setDiceBoxThemeColor(rollThemeColor);
          diceBoxThemeRef.current = rollThemeColor;
          await waitForNextAnimationFrame();
        }

        let collected;
        if (Array.isArray(rollPlan) && rollPlan.length > 0) {
          collected = await executeRollPlan();
        } else {
          const fallbackCollected = Array.from({ length: requests.length }, () => null);
          const rollRequests = [];
          const rollIndexMap = [];

          requests.forEach((request, index) => {
            const rawCount = Number(request?.count);
            const rawSides = Number(request?.sides);
            const count = Number.isFinite(rawCount) ? Math.max(0, Math.floor(rawCount)) : 0;
            const sides =
              Number.isFinite(rawSides) && rawSides > 0 ? Math.round(rawSides) : null;

            if (!count || !sides) {
              fallbackCollected[index] = null;
              return;
            }

            rollRequests.push({ count, sides });
            rollIndexMap.push(index);
          });

          if (rollRequests.length > 0) {
            const { rolls } = await rollSharedDiceWithBox(rollRequests);
            rollIndexMap.forEach((originalIndex, idx) => {
              const raw = Array.isArray(rolls) ? rolls[idx] : undefined;
              fallbackCollected[originalIndex] = raw;
            });
          }

          collected = fallbackCollected;
        }

        if (!Array.isArray(collected)) {
          collected = Array.from({ length: requests.length }, () => null);
        }
        // Heroic Inspiration: one die in its lower half can be rerolled before the damage is added up.
        const rerolledGroups = await rerollDiceWithHeroicInspiration(collected.map((values, index) => ({
          sides: Number(requests[index]?.sides), values: Array.isArray(values) ? values : [] })), 'damage', 'damage');
        collected = collected.map((values, index) => (Array.isArray(values) ? rerolledGroups[index].values : values));

        let requestIndex = 0;
        const appliedRollGroups = [];
        const applyRolls = (count, sides) => {
          const current = Array.isArray(collected)
            ? collected[requestIndex]
            : undefined;
          requestIndex += 1;
          const normalizedGroup = sanitizeRollGroup(current, count, sides);
          if (normalizedGroup) {
            appliedRollGroups.push(normalizedGroup);
            return normalizedGroup;
          }
          const fallbackRolls = rollDice(count, sides);
          const resolvedSides =
            Number.isFinite(sides) && sides > 1 ? Math.floor(sides) : 6;
          let numericFallback;
          if (Array.isArray(fallbackRolls)) {
            numericFallback = fallbackRolls
              .map((value) => normalizeRollValue(value))
              .filter((value) => value !== null);
            if (numericFallback.length > count) {
              numericFallback = numericFallback.slice(0, count);
            }
            while (numericFallback.length < count) {
              numericFallback.push(
                Math.max(
                  1,
                  Math.floor(Math.random() * resolvedSides) + 1,
                ),
              );
            }
          } else {
            numericFallback = Array.from({ length: count }, () =>
              Math.max(1, Math.floor(Math.random() * resolvedSides) + 1),
            );
          }
          appliedRollGroups.push(numericFallback);
          return numericFallback;
        };

        const finalResult = calculateDamage(
          trimmed,
          ability,
          crit,
          applyRolls,
          extraDice,
          levelsAbove,
          options,
        );

        const componentValues = collected
          .slice(weaponRequestCount)
          .flatMap((values) => Array.isArray(values) ? values : []);
        let componentValueIndex = 0;
        const rolledDamageComponents = rollDamageComponents(damageComponents, {
          critical: crit,
          inheritedDamageType,
          rollDie: () => componentValues[componentValueIndex++],
          damageDieFloor: greatWeaponFightingApplies(options?.character, options?.attack) ? 3 : 1,
        });

        const appliedValues = collectRollValues(appliedRollGroups);
        const rollValues = appliedValues.length > 0 ? appliedValues : undefined;

        return finalResult ? {
          ...finalResult,
          rollValues,
          damageComponents: rolledDamageComponents,
          visualDiceRequests: requests,
        } : null;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Damage roll failed', error);
        const fallbackResult = calculateDamage(
          trimmed,
          ability,
          crit,
          rollDice,
          extraDice,
          levelsAbove,
          options,
        );
        return fallbackResult ? { ...fallbackResult, rollValues: undefined } : null;
      }
    },
    [
      diceFaceColor,
      normalizeDamageTypeForClass,
      prepareDiceRollSurface,
      resolveDamageTypeColor,
      rollSharedDiceWithBox,
      rerollDiceWithHeroicInspiration,
      setDiceBoxThemeColor,
    ],
  );

  const handleWeaponAttack = useCallback(
    async (slot, weapon) => {
      const ability = abilityForWeapon(weapon, slot);
      const abilityKey = attackAbilityKeyForWeapon(slot, weapon);
      const damageString = getDamageStringForHandSelection(slot, weapon);
      if (typeof damageString !== 'string' || !damageString.trim()) return;

      const attackRollId = getWeaponAttackRollId(slot, weapon);
      const isCriticalDamage = Boolean(pendingCriticalAttack?.isCriticalHit && pendingCriticalAttack?.attackId === attackRollId) || isCritical;
      const result = await rollDamageExpression({
        damageString,
        ability,
        crit: isCriticalDamage,
        options: {
          character: form,
          combatState,
          frenzyDice: null,
          attack: {
            weapon, hands: getHandSelectionForWeapon(slot, weapon),
            ability: abilityKey,
            kind: isUnarmedAttack(weapon) ? 'unarmed' : 'weapon',
            isWeaponAttack: !isUnarmedAttack(weapon),
            isUnarmedStrike: isUnarmedAttack(weapon),
            dealsDamage: true,
          },
        },
      });
      if (!result) return;

      const weaponLabel = getWeaponDisplayName(slot, weapon);
      const expression = damageString
        .replace(/([+-])/g, ' $1 ')
        .replace(/\s+/g, ' ')
        .trim();


      // Each damage source (weapon dice with its modifier, Rage, Brutal Strike) is one labelled line in the log.
      const extraDetails = {
        diceRolls: result.diceRolls,
        sourceLabel: weaponLabel,
        actionLabel: isCriticalDamage ? 'Critical Damage' : 'Damage',
        expression: isCriticalDamage ? createCriticalDamageFormula(expression || damageString) : (expression || undefined),
        parts: result.parts,
        critical: isCriticalDamage,
      };

      updateDamageValueWithAnimation(
        result.total,
        result.breakdown,
        isCriticalDamage ? `${weapon.name} Critical Damage` : weapon.name,
        extraDetails,
      );
      if (pendingCriticalAttack?.attackId === attackRollId) {
        setPendingCriticalAttack(null);
      }
      return result.total;
    },
    [
      abilityForWeapon,
      attackAbilityKeyForWeapon,
      combatState,
      getDamageStringForHandSelection,
      getWeaponDisplayName,
      form,
      isCritical,
      pendingCriticalAttack,
      isUnarmedAttack,
      onCharacterChange,
      rollDamageExpression,
    ],
  );

  const handleWeaponAttackRoll = async (slot, weapon, targetRollMode = {}) => {
    const rawBonus = Number(getAttackBonus(slot, weapon));
    // A bonus from the target's state (Sundering Blow), added to the shown total and reported back.
    const situational = Number(targetRollMode.situationalBonus?.value) || 0;
    const bonus = (Number.isFinite(rawBonus) ? rawBonus : 0) + situational;
    const abilityKey = attackAbilityKeyForWeapon(slot, weapon);
    const attackContext = {
      attackAbility: abilityKey,
      isMeleeAttack: isUnarmedAttack(weapon) || isMeleeWeapon(weapon),
      kind: isUnarmedAttack(weapon) ? 'unarmed' : 'weapon',
      isWeaponAttack: !isUnarmedAttack(weapon),
      isUnarmedStrike: isUnarmedAttack(weapon),
    };
    const rollModeResult = resolveAttackRollMode(form, attackContext, { ...targetRollMode, combatState: targetRollMode.combatState || combatState, actorId: characterId });
    if (targetRollMode.brutalStrike && !isBrutalStrikeEligibleAttack({
      attack: attackContext,
      ability: abilityKey,
      rollMode: rollModeResult.mode,
    })) {
      throw new Error('Brutal Strike requires a Strength-based attack that does not have Disadvantage.');
    }
    await prepareDiceRollSurface('Roll');
    const diceModifiers = getRollDiceModifiers(combatState, characterId, 'attack', targetRollMode.targetCombatantId);
    const { result, d20, rolledD20s, keptD20, rollMode, modifierDice } = await rollSkillWithDiceBox(bonus, {
      diceColor: diceFaceColor,
      rollMode: rollModeResult.mode,
      diceModifiers,
      rollContext: 'attack',
      character: form,
    });
    onCharacterChange?.((previous) => markBarbarianAttackRoll(previous || form));
    diceBoxThemeRef.current = diceFaceColor;
    const weaponLabel = getWeaponDisplayName(slot, weapon);
    const actualRollMode = rollMode || rollModeResult.mode;
    const d20Segment = actualRollMode === 'advantage' || actualRollMode === 'disadvantage'
      ? `${keptD20 ?? d20} (d20) (Rolled ${(rolledD20s || [d20]).join(' and ')})`
      : `${d20} (d20)`;
    const segments = [d20Segment];
    if (bonus - situational) {
      const sign = bonus - situational >= 0 ? '+' : '-';
      segments.push(`${sign} ${Math.abs(bonus - situational)} Attack Bonus`);
    }
    if (situational) segments.push(`+ ${situational} ${targetRollMode.situationalBonus.label}`);

    const naturalRoll = keptD20 ?? d20;
    const isCriticalHit = isCriticalAttackRoll(form, attackContext, naturalRoll);

    window.dispatchEvent(
      new CustomEvent('damage-roll', {
        detail: {
          value: result,
          breakdown: [segments.join(' '), modifierDiceBreakdown(diceModifiers, modifierDice)].filter(Boolean).join(' '),
          source: `${weaponLabel}${actualRollMode === 'normal' ? '' : ` with ${actualRollMode === 'advantage' ? 'Advantage' : 'Disadvantage'}`} Attack Roll`,
          critical: isCriticalHit,
          fumble: naturalRoll === 1,
          rollLabel: 'Attack Roll',
          rollMode: actualRollMode,
          advantageSources: rollModeResult.advantageSources,
          disadvantageSources: rollModeResult.disadvantageSources,
          diceRolls: [
            ...modifierDiceRecords(diceModifiers, modifierDice),
            {
              sides: 20,
              value: naturalRoll,
              rolled: rolledD20s,
              type: 'Attack Roll',
              category: 'base',
            },
          ],
        },
      })
    );
    setPendingCriticalAttack({
      attackId: getWeaponAttackRollId(slot, weapon),
      naturalRoll,
      total: result,
      isCriticalHit,
      isNaturalOne: naturalRoll === 1,
      sourceLabel: weaponLabel,
    });
    return { naturalRoll, total: result, rolledD20s, rollMode: actualRollMode, advantageSources: rollModeResult.advantageSources, disadvantageSources: rollModeResult.disadvantageSources, ...(situational ? { situationalBonus: situational } : {}) };
  };

  const handleSpellAttackRoll = useCallback(
    async (spell, targetRollMode = {}) => {
      const attackDetails = getSpellAttackDetails(spell);
      if (!attackDetails) {
        return;
      }

      const { total, abilityBonus, proficiencyBonus, extraBonus } = attackDetails;
      const situational = Number(targetRollMode.situationalBonus?.value) || 0;
      await prepareDiceRollSurface('Roll');
      const diceModifiers = getRollDiceModifiers(combatState, characterId, 'attack', targetRollMode.targetCombatantId);
      const { result, d20, keptD20, rolledD20s, rollMode, modifierDice } = await rollSkillWithDiceBox(total + situational, {
        diceColor: diceFaceColor,
        rollMode: targetRollMode.mode,
        diceModifiers,
      rollContext: 'attack',
        character: form,
        source: spell?.name,
      });
      diceBoxThemeRef.current = diceFaceColor;
      const naturalRoll = keptD20 ?? d20;
      const segments = [rollMode === 'advantage' || rollMode === 'disadvantage' ? `${naturalRoll} (d20) (Rolled ${(rolledD20s || [d20]).join(' and ')})` : `${d20} (d20)`];
      segments.push(`${formatModifier(abilityBonus)} ${attackDetails.ability || spellAbilityLabel}`);
      segments.push(
        `${formatModifier(proficiencyBonus)} Proficiency Bonus`,
      );
      if (extraBonus) {
        segments.push(`${formatModifier(extraBonus)} Spell Attack Bonus`);
      }
      if (situational) segments.push(`+ ${situational} ${targetRollMode.situationalBonus.label}`);

      window.dispatchEvent(
        new CustomEvent('damage-roll', {
          detail: {
            value: result,
            breakdown: [segments.join(' '), modifierDiceBreakdown(diceModifiers, modifierDice)].filter(Boolean).join(' '),
            source: `${spell?.name || 'Spell'} Spell Attack Roll`,
            critical: isCriticalAttackRoll(form, { kind: 'spell' }, naturalRoll),
            fumble: naturalRoll === 1,
            rollLabel: 'Attack Roll',
            rollMode: rollMode || targetRollMode.mode,
            advantageSources: targetRollMode.advantageSources,
            disadvantageSources: targetRollMode.disadvantageSources,
            diceRolls: [
              ...modifierDiceRecords(diceModifiers, modifierDice),
              {
                sides: 20,
                value: naturalRoll,
                rolled: rolledD20s,
                type: 'Attack Roll',
                category: 'base',
              },
            ],
          },
        }),
      );
      setPendingCriticalAttack({
        attackId: getSpellAttackRollId(spell),
        naturalRoll,
        total: result,
        isCriticalHit: isCriticalAttackRoll(form, { kind: 'spell' }, naturalRoll),
        isNaturalOne: naturalRoll === 1,
        sourceLabel: spell?.name || 'Spell',
      });
      return { naturalRoll, total: result, rolledD20s, ...(situational ? { situationalBonus: situational } : {}) };
    },
    [
      diceFaceColor,
      formatModifier,
      getSpellAttackDetails,
      prepareDiceRollSurface,
      spellAbilityLabel,
      form,
      combatState,
      characterId,
    ],
  );

  // 2024 Breath Weapon: choose a Cone or a Line, aim it on the map, and the server resolves it like an area spell
  // (Dexterity saves, one damage roll); it spends a use and one attack of the Attack action.
  // Cloud's Jaunt: choose the space on the map; the server checks the 30 feet, the Bonus Action and the space.
  // Teleports pick a square from the highlighted ones in reach (the server checks the same rule).
  const CLOUDS_JAUNT_TARGETING = useMemo(() => ({ shape: 'teleport', rangeFeet: 30, allowEmpty: true }), []);
  const beginCloudsJaunt = useCallback(() => {
    const definition = { id: 'species:clouds-jaunt', name: "Cloud's Jaunt", level: 0, targeting: CLOUDS_JAUNT_TARGETING };
    const intent = { definition, cloudsJaunt: true, sourceCombatantId: String(characterId), actionType: 'save-damage', targetId: '',
      combatRevision: combatState?.turnSequence, status: 'targeting', error: '', result: null };
    saveDamageCastIntentRef.current = intent;
    setSaveDamageCast(intent);
    onBeginTargeting({ sourceCombatantId: String(characterId), actionType: 'save-damage', sourceActionId: 'species:clouds-jaunt',
      areaCombatantIds: [], selectionMode: 'area', label: "Cloud's Jaunt", prompt: 'Choose a highlighted square within 30 feet to teleport to.', area: CLOUDS_JAUNT_TARGETING });
  }, [CLOUDS_JAUNT_TARGETING, characterId, combatState?.turnSequence, onBeginTargeting]);

  // Blink Steps (Boon of Dimensional Travel): the same space targeting; the server checks the action taken and 30 feet.
  const beginNaturesSanctuary = useCallback((moving) => {
    const targeting = { ...SANCTUARY_AREA, rangeFeet: SANCTUARY_RANGE_FEET, allowEmpty: true };
    const definition = { id: 'druid:natures-sanctuary', name: 'Nature’s Sanctuary', level: 0, targeting };
    const intent = { definition, sanctuary: { moving }, sourceCombatantId: String(characterId), actionType: 'save-damage', targetId: '',
      combatRevision: combatState?.turnSequence, status: 'targeting', error: '', result: null };
    saveDamageCastIntentRef.current = intent;
    setSaveDamageCast(intent);
    onBeginTargeting({ sourceCombatantId: String(characterId), actionType: 'save-damage', sourceActionId: 'druid:natures-sanctuary', areaCombatantIds: [], selectionMode: 'area', label: 'Nature’s Sanctuary',
      prompt: moving ? 'Choose where the Cube moves: up to 60 feet, within 120 feet of you.' : 'Choose where the 15-foot Cube goes, within 120 feet of you.', area: targeting });
  }, [characterId, combatState?.turnSequence, onBeginTargeting]);

  const beginBlinkSteps = useCallback(() => {
    const definition = { id: 'boon:blink-steps', name: 'Blink Steps', level: 0, targeting: CLOUDS_JAUNT_TARGETING };
    const intent = { definition, blinkSteps: true, sourceCombatantId: String(characterId), actionType: 'save-damage', targetId: '',
      combatRevision: combatState?.turnSequence, status: 'targeting', error: '', result: null };
    saveDamageCastIntentRef.current = intent;
    setSaveDamageCast(intent);
    onBeginTargeting({ sourceCombatantId: String(characterId), actionType: 'save-damage', sourceActionId: 'boon:blink-steps',
      areaCombatantIds: [], selectionMode: 'area', label: 'Blink Steps', prompt: 'Choose a highlighted square within 30 feet to teleport to.', area: CLOUDS_JAUNT_TARGETING });
  }, [CLOUDS_JAUNT_TARGETING, characterId, combatState?.turnSequence, onBeginTargeting]);

  const beginBreathWeapon = useCallback(async () => {
    if (!breathWeaponDetails) return;
    const choice = await resolveFeatureDecision({ id: 'breath-weapon-shape', featureId: 'species:breath-weapon', title: 'Breath Weapon',
      prompt: `${breathWeaponDetails.damageString} · Dexterity save DC ${breathWeaponDetails.saveDC}, half damage on a success. Replaces one attack of your Attack action.`,
      choices: [{ id: 'cone', label: '15-foot Cone' }, { id: 'line', label: '30-foot Line (5 feet wide)' }, { id: 'skip', label: 'Cancel' }] });
    const shape = choice?.choiceId;
    if (!['cone', 'line'].includes(shape)) return;
    const definition = breathWeaponDefinition(shape);
    const intent = { definition, breathWeapon: { shape }, sourceCombatantId: String(characterId), actionType: 'save-damage', targetId: '',
      pool: 'none', castLevel: 0, combatRevision: combatState?.turnSequence, status: 'targeting', error: '', result: null };
    saveDamageCastIntentRef.current = intent;
    setSaveDamageCast(intent);
    onBeginTargeting({ sourceCombatantId: String(characterId), actionType: 'save-damage', sourceActionId: `breath-weapon:${shape}`,
      areaCombatantIds: (combatState?.participants || []).map((p) => String(p.characterId || p.enemyId || '')),
      selectionMode: 'area', label: 'Breath Weapon', prompt: formatSaveDamageTargeting(definition.targeting), area: definition.targeting });
  }, [breathWeaponDetails, characterId, combatState?.participants, combatState?.turnSequence, onBeginTargeting, resolveFeatureDecision]);

const [showUpcast, setShowUpcast] = useState(false);
const [pendingSpell, setPendingSpell] = useState(null);
// A spell without an engine waiting for its slot level (manual cast).
const [manualSpell, setManualSpell] = useState(null);
const sendManualCast = async (item, slot = {}) => {
  const spell = item.spell || {};
  const level = Number(spell.level) || 0;
  try {
    await onCastSpell?.({ ...(spell.featureGrantId ? { featureGrantId: spell.featureGrantId } : { spellInstanceId: spell.spellInstanceId, name: spell.name, sourceId: spell.source?.sourceId }),
      name: item.name, level, baseLevel: level, castingTime: spell.castingTime, ...(level > 0 ? { slotLevel: slot.slotLevel, slotType: slot.slotType } : {}) });
    notify(`${item.name} cast. Apply its effect at the table.`, 'success');
  } catch { /* The sheet reports the error. */ }
};
// Cantrips cast at once; leveled spells choose a slot first.
const castManualSpell = (item) => {
  setShowAttack(false);
  if ((Number(item.spell?.level) || 0) === 0) sendManualCast(item);
  else setManualSpell(item);
};
const [directSpellSelection, setDirectSpellSelection] = useState(null);
const directSpellChoicesRef = useRef({});
const multiCastKey = `spell-rays:${campaignId}:${characterId}`;
const multiCastRef = useRef(null);
const multiCastLockRef = useRef(false);
const [multiCastRunning, setMultiCastRunning] = useState(false);
const [multiCast, setMultiCast] = useState(null);
const saveMultiCast = useCallback((cast) => {
  multiCastRef.current = cast; setMultiCast(cast);
  try { if (cast) window.sessionStorage.setItem(multiCastKey, JSON.stringify(cast)); else window.sessionStorage.removeItem(multiCastKey); } catch {}
}, [multiCastKey]);
useEffect(() => {
  // The initial normalized combat placeholder has revision 0 before hydration.
  // Do not discard recovery data until an actual combat turn is loaded.
  if (!campaignId || !characterId || !Number.isInteger(combatState?.turnSequence) || combatState?.activeTurn == null || !combatState?.participants?.length) return;
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(multiCastKey));
    if (saved?.turnSequence === combatState?.turnSequence && saved?.combatantId === characterId) saveMultiCast(saved);
    else saveMultiCast(null);
  } catch { saveMultiCast(null); }
}, [multiCastKey, campaignId, combatState?.turnSequence, combatState?.activeTurn, combatState?.participants?.length, characterId, saveMultiCast]);
const selectMultiCastTarget = useCallback((cast) => {
  onBeginTargeting({ sourceCombatantId: characterId, actionType: 'attack', attackId: cast.attackId,
    controlsInSpellBar: true, label: cast.name, prompt: `Choose target for attack ${cast.completed + 1} of ${cast.count} · resolve it before choosing the next`,
    ...(cast.pending?.targetId ? { lockedTargetCombatantId: cast.pending.targetId, allowResolvedTarget: true } : {}) });
}, [characterId, onBeginTargeting]);
const beginMultiCast = useCallback((item, choices = { castLevel: 0, pool: 'none' }, nativeCast = null) => {
  if (multiCastRef.current) {
    const resumed=nativeCast ? reconcileNativeMultiattackCast(multiCastRef.current,nativeCast) : multiCastRef.current;
    if(nativeCast)saveMultiCast(resumed);selectMultiCastTarget(resumed);setShowAttack(false);return;
  }
  const definition = item.directDefinition;
  const totalLevel = (form.occupation || []).reduce((sum, entry) => sum + (Number(entry.Level ?? entry.level) || 0), 0);
  const cast = { id: nativeCast?.resolutionId || window.crypto?.randomUUID?.() || `rays-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    combatantId: characterId, turnSequence: combatState?.turnSequence, attackId: item.id, name: item.name,
    spellInstanceId: item.spell.spellInstanceId, choices, completed: 0,
    count: definition.multiAttack ? directSpellAttackCount(definition, totalLevel, choices.castLevel) : 1,
    ...(nativeCast ? { multiattackStepId:nativeCast.stepId,multiattack:nativeCast.multiattack,...(nativeCast.resume || {}) } : {}) };
  saveMultiCast(cast); selectMultiCastTarget(cast); setShowAttack(false);
}, [characterId, combatState?.turnSequence, form.occupation, saveMultiCast, selectMultiCastTarget]);
const [pendingSpellRider, setPendingSpellRider] = useState(null);
const spellRiderRetryKey = `spell-rider-retry:${campaignId}:${characterId}`;
useEffect(() => {
  try {
    const pending = JSON.parse(window.sessionStorage.getItem(spellRiderRetryKey));
    setPendingSpellRider(pending?.payload?.combatantId === characterId ? pending : null);
  } catch { setPendingSpellRider(null); }
}, [spellRiderRetryKey, characterId]);
const applyDirectSpellRider = useCallback(async (pending) => {
  try { window.sessionStorage.setItem(spellRiderRetryKey, JSON.stringify(pending)); } catch {}
  try {
    const applied = await commitDirectSpellHit(campaignId, pending.payload);
    if (!['applied', 'replayed'].includes(applied.status)) throw new Error(applied.reason || 'The spell effect could not be applied.');
    if (applied.combat) onCombatStateReconciled?.(applied.combat);
    setPendingSpellRider(null);
    try { window.sessionStorage.removeItem(spellRiderRetryKey); } catch {}
    if(pending.multiattackStepId)onSpellCastProgress({type:'complete',multiattackStepId:pending.multiattackStepId});
    notify(applied.conditionImmune ? `${pending.name}: target is immune to Poisoned.` : `${pending.name}: effect applied.`, applied.conditionImmune ? 'info' : 'success');
  } catch (error) { setPendingSpellRider({ ...pending, error: error.message });if(pending.multiattackStepId)onSpellCastProgress({type:'error',multiattackStepId:pending.multiattackStepId,message:error.message}); }
}, [campaignId, onCombatStateReconciled, spellRiderRetryKey, onSpellCastProgress]);

  const applyUpcast = useCallback(
    async (spell, level, crit, slotType) => {
      if (spellCastBlockReason) throw new Error(spellCastBlockReason);
      const diff = level - (spell.level || 0);
      let extra;
      if (diff > 0 && spell.higherLevels) {
        const incMatch = spell.higherLevels.match(/(\d+)d(\d+)/);
        if (incMatch) {
        extra = {
          count: parseInt(incMatch[1], 10),
          sides: parseInt(incMatch[2], 10),
        };
      }
    }
    if (spell.scaling) {
      if (totalLevel >= 17 && spell.scaling[17]) spell.damage = spell.scaling[17];
      else if (totalLevel >= 11 && spell.scaling[11]) spell.damage = spell.scaling[11];
      else if (totalLevel >= 5 && spell.scaling[5]) spell.damage = spell.scaling[5];
    }
    const rollParams = {
      damageString: spell.damage,
      ability: 0,
      crit: crit || isCritical,
      extraDice: extra,
      levelsAbove: diff > 0 ? diff : 0,
    };

    const value = await rollDamageExpression(rollParams);

    if (!value) return;

    if (onCastSpell) {
      const payload = {
        level,
        slotType,
        damage: value.total,
        breakdown: value.breakdown,
        castingTime: spell.castingTime,
        name: spell.name,
      };
      if (Array.isArray(value.diceRolls) && value.diceRolls.length > 0) {
        payload.diceRolls = value.diceRolls;
      }
      if (Array.isArray(value.rollValues) && value.rollValues.length > 0) {
        payload.rollValues = value.rollValues;
      }
      onCastSpell(payload);
      return;
    }

    const extraDetails = {};
    if (Array.isArray(value.diceRolls) && value.diceRolls.length > 0) {
      extraDetails.diceRolls = value.diceRolls;
    }
    if (Array.isArray(value.rollValues) && value.rollValues.length > 0) {
      extraDetails.rollValues = value.rollValues;
    }
    if (Array.isArray(value.parts) && value.parts.length > 0) {
      extraDetails.parts = value.parts;
      extraDetails.critical = value.critical;
    }

    if (Object.keys(extraDetails).length > 0) {
      updateDamageValueWithAnimation(
        value.total,
        value.breakdown,
        spell.name,
        extraDetails,
      );
    } else {
      updateDamageValueWithAnimation(value.total, value.breakdown, spell.name);
    }
  }, [isCritical, onCastSpell, rollDamageExpression, totalLevel, spellCastBlockReason]);

  const handleSpellsButtonClick = (storedSpell, crit = false) => {
    const spell = withCatalogDice(storedSpell, SPELLS_BY_NAME);
    if (!spell?.damage) return;
    const attackRollId = getSpellAttackRollId(spell);
    const isCriticalDamage = Boolean(pendingCriticalAttack?.isCriticalHit && pendingCriticalAttack?.attackId === attackRollId) || crit || isCritical;
    if (pendingCriticalAttack?.attackId === attackRollId) {
      setPendingCriticalAttack(null);
    }
    if (spell.higherLevels) {
      setPendingSpell({ spell, crit: isCriticalDamage });
      setShowUpcast(true);
      return;
    }
    applyUpcast(spell, spell.level, isCriticalDamage);
  };

  // `freeCast`: a feature's free use (Natural Recovery), at the spell's own level with no slot; the server counts the use.
  const beginSaveDamageCast = useCallback((spell, nativeCast = null, reuseLine = false, freeCast = false) => {
    if (spellCastBlockReason) { notify(spellCastBlockReason, 'warning'); return; }
    if (!isCastAccess(spell)) return handleSpellsButtonClick(spell);
    if(nativeCast && saveDamageCastIntentRef.current?.resolutionId===nativeCast.resolutionId){setSaveDamageCast(saveDamageCastIntentRef.current);return;}
    const definition = castDefinition(spell.spellId);
    const intent = { spell, definition, ...(reuseLine ? { reuseLine: true } : {}), ...(freeCast ? { freeCast: true } : {}), spellInstanceId: spell.spellInstanceId, spellId: spell.spellId, source: spell.source,
      sourceCombatantId: String(characterId), actionType: 'save-damage', targetId: '', pool: '', castLevel: null,
      supported: true, storm: false, excludedCombatantIds: [], damageType: String(form.alignment || '').toLowerCase().includes('evil') ? 'necrotic' : 'radiant', combatRevision: combatState?.turnSequence, status: 'choosing-level', error: '', result: null,
      ...(nativeCast ? { nativeCast, multiattackStepId:nativeCast.stepId, resolutionId:nativeCast.resolutionId,
        ...(nativeCast.prepared ? {prepared:nativeCast.prepared,targetIds:nativeCast.prepared.targetCombatantIds,placement:nativeCast.prepared.placement,
          pool:'spellcasting',castLevel:nativeCast.castLevel,status:'finalize-failed',damageDice:nativeCast.prepared.damageEvidence,error:'Resume the prepared spell without spending another Action.'} : {}) } : {}) };
    saveDamageCastIntentRef.current = intent;
    setSaveDamageCast(intent);
  }, [characterId, combatState?.turnSequence, handleSpellsButtonClick, form.alignment, spellCastBlockReason]);

  const chooseSaveDamageCastLevel = useCallback((level, type) => {
    const spellInstanceId = saveDamageCast?.spell?.spellInstanceId;
    const selected = { ...(saveDamageCastIntentRef.current || saveDamageCast), pool: level === 0 || saveDamageCast?.reuseLine || saveDamageCast?.freeCast ? 'none' : type === 'warlock' ? 'pactMagic' : 'spellcasting', castLevel: level, status: FOLLOWING_AURAS.includes(saveDamageCast?.definition.id) ? 'self-cast' : 'targeting' };
    saveDamageCastIntentRef.current = selected;
    setSaveDamageCast(selected);
    if (FOLLOWING_AURAS.includes(selected.definition.id)) return;
    onBeginTargeting({ sourceCombatantId: String(characterId), actionType: 'save-damage', sourceActionId: `spell:${spellInstanceId}`, rangeFeet: selected.definition.targeting?.rangeFeet,
      areaCombatantIds: (combatState?.participants || []).map((p) => String(p.characterId || p.enemyId || '')),
      selectionMode: ['cone', 'sphere', 'line', 'cube', 'cylinder'].includes(selected.definition.targeting.shape) ? 'area' : 'single', label: selected.definition.name, prompt: formatSaveDamageTargeting(selected.definition.targeting), area: selected.definition.targeting });
  }, [saveDamageCast, characterId, combatState?.participants, onBeginTargeting]);

  useEffect(() => {
    if (saveDamageCast?.status === 'choosing-level' && saveDamageCast.nativeCast) chooseSaveDamageCastLevel(saveDamageCast.nativeCast.castLevel, 'regular');
    else if (saveDamageCast?.status === 'choosing-level' && saveDamageCast.definition.level === 0) chooseSaveDamageCastLevel(0, 'none');
    else if (saveDamageCast?.status === 'choosing-level' && (saveDamageCast.reuseLine || saveDamageCast.freeCast)) chooseSaveDamageCastLevel(saveDamageCast.definition.level, 'none');
  }, [saveDamageCast, chooseSaveDamageCastLevel]);

  useEffect(() => {
    const moveArea = event => {
      const { campaignId: requestedCampaign, castId, root } = event.detail || {};
      const moving = { 'spell:moonbeam': MOONBEAM_DEFINITION, 'spell:flaming-sphere': FLAMING_SPHERE_DEFINITION }[root?.definitionId];
      if (requestedCampaign !== campaignId || root?.sourceCombatantId !== String(characterId) || !moving) return;
      const { distanceFeet, actionCost } = moving.movement;
      const definition = { ...moving, targeting: { ...moving.targeting, allowEmpty: true, rangeFeet: distanceFeet, rangeOriginPoint: root.placement.point } };
      const intent = { definition, moveCastId: castId, sourceCombatantId: String(characterId), status: 'targeting', combatRevision: combatState?.turnSequence, error: '' };
      saveDamageCastIntentRef.current = intent; setSaveDamageCast(intent);
      onBeginTargeting({ sourceCombatantId: String(characterId), actionType: 'save-damage', sourceActionId: `move:${castId}`,
        areaCombatantIds: (combatState?.participants || []).map(p => String(p.characterId || p.enemyId || '')),
        selectionMode: 'area', label: `Move ${moving.name}`, prompt: `Move up to ${distanceFeet} feet in a straight line (${actionCost === 'bonusAction' ? 'Bonus Action' : 'Magic action'}).`, area: definition.targeting });
    };
    window.addEventListener('persistent-spell:move', moveArea);
    return () => window.removeEventListener('persistent-spell:move', moveArea);
  }, [campaignId, characterId, combatState?.turnSequence, combatState?.participants, onBeginTargeting]);

  useEffect(() => {
    const strike = event => {
      const { campaignId: requestedCampaign, castId, root } = event.detail || {};
      if (requestedCampaign !== campaignId || root?.sourceCombatantId !== String(characterId) || root?.definitionId !== 'spell:call-lightning') return;
      const definition = { ...CALL_LIGHTNING_DEFINITION, targeting: { ...root.strike, allowEmpty: true, rangeOriginPoint: root.placement.point } };
      const intent = { definition, strikeCastId: castId, sourceCombatantId: String(characterId), status: 'targeting', combatRevision: combatState?.turnSequence, error: '' };
      saveDamageCastIntentRef.current = intent; setSaveDamageCast(intent);
      onBeginTargeting({ sourceCombatantId: String(characterId), actionType: 'save-damage', sourceActionId: `strike:${castId}`,
        areaCombatantIds: (combatState?.participants || []).map(p => String(p.characterId || p.enemyId || '')),
        selectionMode: 'area', label: 'Call Lightning: Strike', prompt: 'Choose a point beneath the cloud (Magic action).', area: definition.targeting });
    };
    window.addEventListener('persistent-spell:strike', strike);
    return () => window.removeEventListener('persistent-spell:strike', strike);
  }, [campaignId, characterId, combatState?.turnSequence, combatState?.participants, onBeginTargeting]);

  const resolveLegacySpell = useCallback(async (spell, sourceId = '') => {
    const spellIndex = (form.spells || []).indexOf(spell);
    if (spellIndex < 0 || !characterId) return;
    setLegacySpellResolution({ spell, status: 'saving', candidates: [], error: '' });
    try {
      const response = await apiFetch(`/characters/${characterId}/spells/${spellIndex}/resolve-source`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(sourceId ? { sourceId } : {}),
      });
      const payload = await response.json();
      if (response.status === 409 && payload?.sourceResolution?.status === 'ambiguous') {
        setLegacySpellResolution({ spell, status: 'ambiguous', candidates: payload.sourceResolution.candidates, error: '' });
        return;
      }
      if (!response.ok) throw new Error(payload?.message || 'Spell source could not be resolved.');
      onCharacterChange?.((previous) => ({ ...previous, spells: payload.spells }));
      setLegacySpellResolution(null);
    } catch (error) {
      setLegacySpellResolution({ spell, status: 'failed', candidates: [], error: error.message });
    }
  }, [characterId, form.spells, onCharacterChange]);

  // A Wizard's own spell: who Sculpt Spells spares, and whether to Overchannel. Asked once, before anything is spent.
  const [sculptPrompt, setSculptPrompt] = useState(null);
  const [chainPrompt, setChainPrompt] = useState(null);
  const beadBurstRef = useRef(null);
  const askEvokerCastOptions = useCallback(async (targetIds) => {
    const intent = saveDamageCastIntentRef.current;
    if (!intent || intent.resolutionId || intent.prepared || intent.source?.sourceType !== 'class' || intent.source?.sourceId !== 'wizard') return;
    const spell = spellsCatalog[intent.spellId], options = {};
    const limit = targetIds?.length ? sculptSpellsLimit(form, spell, intent.castLevel) : 0;
    if (limit) {
      const creatures = targetIds.map((id) => { const entity = spatialContext?.entities?.[id] || {}; return { id, name: entity.label || entity.name || id, hostile: areHostile({ ...form, enemy: false }, entity) }; });
      const sculpted = await new Promise((resolve) => setSculptPrompt({ spellName: spell?.name, limit, creatures, resolve }));
      setSculptPrompt(null);
      if (sculpted.length) options.sculptedCombatantIds = sculpted;
    }
    if (intent.pool !== 'none' && canOverchannel(form, intent.castLevel)) {
      const dice = overchannelDice(form, intent.castLevel);
      const choice = await resolveFeatureDecision({ id: `overchannel:${intent.spellId}`, kind: 'use-feature', featureId: 'wizard:evoker:overchannel', title: 'Overchannel', label: 'Overchannel',
        prompt: `Deal maximum damage with ${spell?.name}?${dice ? ` You take ${dice}d12 Necrotic damage, which ignores Resistance and Immunity.` : ' Your first use since a Long Rest has no cost.'}`,
        choices: [{ id: 'use', label: 'Overchannel' }, { id: 'skip', label: 'No' }] });
      if (choice?.choiceId === 'use') options.overchannel = true;
    }
    saveDamageCastIntentRef.current = { ...saveDamageCastIntentRef.current, ...options };
  }, [form, spatialContext, resolveFeatureDecision]);

  const resolveSaveDamageCast = useCallback(async (selectedTargetId = saveDamageCast?.targetId, targetIds, placement) => {
    const pendingIntent = saveDamageCastIntentRef.current || saveDamageCast;
    if (!pendingIntent || saveDamageCastLock.current) throw new Error('The pending spell cast was lost or is already resolving.');
    if (pendingIntent.definition.id === 'spell:call-lightning' && !pendingIntent.strikeCastId && !pendingIntent.cloudPlacement) {
      if (!placement?.point) throw new Error('Choose the cloud position first.');
      const definition = { ...CALL_LIGHTNING_DEFINITION, targeting: { ...CALL_LIGHTNING_DEFINITION.strike, allowEmpty: true, rangeOriginPoint: placement.point } };
      const next = { ...pendingIntent, definition, cloudPlacement: placement, status: 'targeting' };
      saveDamageCastIntentRef.current = next; setSaveDamageCast(next);
      onBeginTargeting({ sourceCombatantId: String(characterId), actionType: 'save-damage', sourceActionId: `first-strike:${pendingIntent.spellInstanceId}`,
        areaCombatantIds: (combatState?.participants || []).map(p => String(p.characterId || p.enemyId || '')),
        selectionMode: 'area', label: 'Call Lightning: First Strike', prompt: 'Choose a point beneath the cloud. No resources are spent until this selection.', area: definition.targeting });
      return;
    }
    if (!placement) for (const id of [selectedTargetId, ...(targetIds || [])].filter(Boolean)) await passTargetingBlock({ campaignId, combatState, attackerId: characterId, targetId: id, onCombatChange: onCombatStateReconciled });
    if (pendingIntent.targetIds && JSON.stringify(pendingIntent.targetIds) !== JSON.stringify(targetIds || pendingIntent.targetIds)) throw new Error('Retry must use the original affected creatures.');
    if (pendingIntent.targetId && pendingIntent.targetId !== selectedTargetId) throw new Error('Retry must use the original affected creature.');
    saveDamageCastLock.current = true;
    if(pendingIntent.multiattackStepId)onSaveDamageStateChanged({type:'started',multiattackStepId:pendingIntent.multiattackStepId});
    const uuid = typeof crypto !== 'undefined' ? crypto.randomUUID?.() : null;
    const resolutionId = pendingIntent.resolutionId || uuid || `save-damage:${characterId}:${Date.now()}`;
    let selected = { ...pendingIntent, targetId: selectedTargetId, targetIds: targetIds || pendingIntent.targetIds, placement: placement || pendingIntent.placement, resolutionId, status: 'preparing', error: '' };
    saveDamageCastIntentRef.current = selected;
    const remember = (fields) => {
      if (saveDamageCastIntentRef.current?.resolutionId !== resolutionId) throw new Error('This spell cast belongs to an earlier turn.');
      selected = { ...selected, ...fields };
      if(enemySaveRecoveryKey)try{sessionStorage.setItem(enemySaveRecoveryKey,JSON.stringify(selected));}catch{}
      saveDamageCastIntentRef.current = selected;
      setSaveDamageCast(selected);
    };
    remember({});
    // The captured cast owns its placement now; close the cursor preview before requests or dice.
    onCancelTargeting();
    if (selected.sanctuary) {
      try {
        const response = await apiFetch(`/characters/${encodeURIComponent(String(form?._id || characterId))}/druid/natures-sanctuary${selected.sanctuary.moving ? '/move' : ''}`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ eventId: resolutionId, placement: selected.placement, turnSequence: Number.isInteger(combatState?.activeTurn) ? combatState.turnSequence : null }) });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.message || 'Nature’s Sanctuary could not be used.');
        onCharacterChange?.((previous) => applyWildShapeUpdate(previous, result.wildShape));
        if (result.combat) onCombatStateReconciled(result.combat);
      } catch (error) { notify(error.message, 'warning'); }
      finally { saveDamageCastLock.current = false; }
      saveDamageCastIntentRef.current = null; setSaveDamageCast(null);
      return;
    }
    if (selected.blinkSteps) {
      try {
        const result = await spendBlinkSteps(String(form?._id || characterId), { eventId: resolutionId, placement: selected.placement });
        if (result.combat) onCombatStateReconciled(result.combat);
        if (!result.replayed) notify(`Blink Steps · You teleport ${result.feet} feet.`, 'success');
      } catch (error) { notify(error.message, 'warning'); }
      finally { saveDamageCastLock.current = false; }
      saveDamageCastIntentRef.current = null; setSaveDamageCast(null);
      return;
    }
    if (selected.cloudsJaunt) {
      try {
        const result = await spendCloudsJaunt(String(form?._id || characterId), { eventId: resolutionId, placement: selected.placement });
        if (result.speciesResources) onCharacterChange?.((previous) => mergeSpeciesResources(previous, result.speciesResources));
        if (result.combat) onCombatStateReconciled(result.combat);
        if (!result.replayed) notify(`Cloud's Jaunt · You teleport ${result.feet} feet.`, 'success');
      } catch (error) { notify(error.message, 'warning'); }
      finally { saveDamageCastLock.current = false; }
      saveDamageCastIntentRef.current = null; setSaveDamageCast(null);
      return;
    }
    const automaticAreaDamage = !selected.moveCastId && ['spell:moonbeam', 'spell:cloudkill', 'spell:incendiary-cloud', 'spell:insect-plague', 'spell:call-lightning', 'spell:flaming-sphere'].includes(selected.definition.id);
    let initialDamageCompleted = false;
    const initialDamageContext = { campaignId, sourceCombatantId: String(characterId), castId: selected.strikeCastId || resolutionId };
    if (automaticAreaDamage) initialAreaDamage({ ...initialDamageContext, active: true });
    try {
      if (['spell:flaming-sphere', 'spell:web', 'spell:moonbeam', 'spell:cloudkill', 'spell:incendiary-cloud', 'spell:insect-plague', 'spell:call-lightning', ...FOLLOWING_AURAS].includes(selected.definition.id)) {
        const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/${selected.definition.id === 'spell:web' ? 'web' : 'persistent-spells'}/${selected.strikeCastId ? `${encodeURIComponent(selected.strikeCastId)}/strike` : selected.moveCastId ? `${encodeURIComponent(selected.moveCastId)}/move` : 'cast'}`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
            ...(selected.moveCastId || selected.strikeCastId ? { requestId: resolutionId } : { id: resolutionId, sourceCombatantId: String(characterId), spellInstanceId: selected.spellInstanceId }),
            view: form?.entityType === 'enemy' ? 'dm' : 'character', characterId: String(characterId),
            ...(FOLLOWING_AURAS.includes(selected.definition.id) ? { excludedCombatantIds: selected.excludedCombatantIds || [], damageType: selected.damageType } : {}),
            ...(selected.definition.id === 'spell:call-lightning' && !selected.strikeCastId ? { storm: selected.storm === true, strikePlacement: selected.placement } : {}),
            placement: selected.cloudPlacement || selected.placement, pool: selected.pool, castLevel: selected.castLevel, supported: selected.supported !== false,
          }),
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.message || 'Persistent spell could not be placed.');
        if (payload.resourceProfile) onSpellSlotReconciled(payload.resourceProfile);
        if (payload.actionLedger) onActionEconomyReconciled(payload.actionLedger);
        if (payload.root?.damage && payload.damageGroupId) {
          remember({ persistentDamageGroupId: payload.damageGroupId });
          let dice = selected.persistentDamageDice;
          if (!dice) {
            await prepareDiceRollSurface(`${payload.root.name} Damage`);
            const rolled = await rollSaveDamageEvidence([{ formula: payload.root.damage.formula, type: payload.root.damage.type }], rollDiceWithHeroicReroll('damage', 'damage'));
            dice = rolled[0]; remember({ persistentDamageDice: dice });
          }
          const damageResponse = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/persistent-spells/${encodeURIComponent(payload.id)}/damage`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ requestId: payload.damageGroupId, damageDice: dice, view: form?.entityType === 'enemy' ? 'dm' : 'character', characterId: String(characterId) }),
          });
          const damageResult = await damageResponse.json();
          if (!damageResponse.ok) throw new Error(damageResult.message || 'Damage could not be recorded.');
          initialDamageCompleted = true;
          window.dispatchEvent(new CustomEvent(SPELL_DAMAGE_ROLLED_EVENT, { detail: { campaignId, sourceCombatantId: String(characterId),
            label: payload.root.name, value: damageResult.rolledDamage,
            dice: dice.map(value => ({ value, sides: Number(payload.root.damage.formula.split('d')[1]), type: payload.root.damage.type })) } }));
        }
        window.dispatchEvent(new Event('web:changed'));
        notify(selected.definition.id === 'spell:spirit-guardians' ? 'Spirit Guardians follows you. Wisdom saves trigger on entry, aura movement into a creature, or turn end, once per turn. Affected Speed is halved.' : selected.definition.id === 'spell:call-lightning' ? 'Lightning strike called. Affected creatures make Dexterity saves. Use Call Lightning in the concentration menu for another Magic action strike; visibility and elevation are tracked manually.' : selected.definition.id === 'spell:web' ? 'Web placed. Creatures save when they enter or start their turn inside. Terrain and obscurement are tracked manually.' : `${selected.definition.name} ${selected.moveCastId ? 'moved' : 'placed'}. Constitution saves occur on appearance, entry${selected.definition.id === 'spell:insect-plague' ? '' : ', area movement'} and turn end, once per turn.${selected.definition.id === 'spell:insect-plague' ? ' Difficult terrain and light obscurement are tracked manually.' : ''}`, 'info');
        saveDamageCastIntentRef.current = null; setSaveDamageCast(null);if(enemySaveRecoveryKey)sessionStorage.removeItem(enemySaveRecoveryKey);
        return;
      }
      let prepared = selected.prepared;
      if (!prepared) {
        // Breath Weapon sends only its shape and placement; the server builds the save, damage and creatures.
        const prepareResponse = await apiFetch(selected.quiveringPalm
          ? `/campaigns/${encodeURIComponent(campaignId)}/resolutions/monk/quivering-palm/prepare`
          : selected.breathWeapon
          ? `/campaigns/${encodeURIComponent(campaignId)}/resolutions/species/breath-weapon/prepare`
          : `/campaigns/${encodeURIComponent(campaignId)}/resolutions/player-spells/${encodeURIComponent(selected.spellInstanceId)}/prepare`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(selected.quiveringPalm
            ? { resolutionId, sourceCombatantId: String(characterId) }
            : selected.breathWeapon
            ? { resolutionId, sourceCombatantId: String(characterId), shape: selected.breathWeapon.shape, placement: selected.placement }
            : { resolutionId,
            sourceCombatantId: String(characterId), ...(selected.targetIds ? { targetCombatantIds: selected.targetIds } : { targetCombatantId: selected.targetId }),
            ...(selected.placement ? { placement: selected.placement } : {}),
            pool: selected.pool, castLevel: selected.castLevel, ...(selected.nativeCast?.multiattack ? {multiattack:selected.nativeCast.multiattack} : {}),
            ...(selected.sculptedCombatantIds?.length ? { sculptedCombatantIds: selected.sculptedCombatantIds } : {}), ...(selected.overchannel ? { overchannel: true } : {}) }),
        });
        prepared = await prepareResponse.json();
        if (!prepareResponse.ok) throw new Error(prepared?.message || prepared?.errors?.[0]?.msg || `${selected.quiveringPalm ? 'Quivering Palm' : selected.breathWeapon ? 'Breath Weapon' : 'Spell'} could not be prepared.`);
        if (selected.quiveringPalm) onCharacterChange?.((previous) => previous ? { ...previous, classState: { ...previous.classState, monk: { ...previous.classState?.monk, quiveringPalm: null } } } : previous);
        remember({ prepared, status: 'rolling-damage' });
        onSpellSlotReconciled(prepared.resourceProfile);
        if (prepared.overchannel) {
          onCharacterChange?.((previous) => (previous ? { ...previous, classState: { ...previous.classState, wizard: { ...previous.classState?.wizard, overchannel: { uses: prepared.overchannel.uses } } } } : previous));
          if (prepared.overchannel.necrotic) notify(`Overchannel: you take ${prepared.overchannel.necrotic} Necrotic damage.`, 'warning');
        }
        if (prepared.speciesResources) onCharacterChange?.((previous) => mergeSpeciesResources(previous, prepared.speciesResources));
        if (prepared.actionLedger) onActionEconomyReconciled(prepared.actionLedger);
        onSaveDamageStateChanged({ type: 'prepared', resolutionId, targetCombatantId: selected.targetId, multiattackStepId:selected.multiattackStepId });
      }
      let damageDice = selected.damageDice || prepared.damageEvidence;
      if (!damageDice) {
        await prepareDiceRollSurface(`${prepared.sourceEffect?.displayName || selected.definition.name} Damage`);
        damageDice = prepared.rules?.damage?.maximized ? maximizedDamageDice(prepared.rules.damage.components) : selected.nativeCast?.multiattack
          ? await captureMultiattackRoll(campaignId,selected.nativeCast.multiattack,resolutionId,'save-damage',multiattackClientId.current,()=>rollSaveDamageEvidence(prepared.rules?.damage?.components,rollSharedDiceWithBox))
          : await rollSaveDamageEvidence(prepared.rules?.damage?.components, rollDiceWithHeroicReroll('damage', 'damage'));
      }
      // Keep captured evidence synchronously before any network submission. Retry never rerolls it.
      remember({ damageDice, status: 'recording-damage' });
      const evidenceResponse = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/resolutions/${encodeURIComponent(resolutionId)}/damage-evidence`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ damageDice }),
      });
      const result = await evidenceResponse.json();
      if (!evidenceResponse.ok) throw new Error(result?.message || result?.errors?.[0]?.msg || 'Spell damage could not be recorded.');
      window.dispatchEvent(new CustomEvent(SPELL_DAMAGE_ROLLED_EVENT, { detail: { campaignId, sourceCombatantId: String(characterId),
        label: selected.definition.name, value: damageDice.flat().reduce((sum, die) => sum + die, 0),
        dice: damageDice.flatMap((dice, index) => dice.map(value => ({ value, sides: Number(prepared.rules.damage.components[index].formula.split('d')[1]), type: prepared.rules.damage.components[index].type }))) } }));
      window.dispatchEvent(new CustomEvent(SPELL_DAMAGE_FEEDBACK_EVENT, { detail: result }));
      remember({ result, status: result.status === 'finalized' ? 'complete' : 'waiting-save' });
      onSaveDamageStateChanged({ type: result.status === 'finalized' ? 'finalized' : 'damage-recorded', resolutionId, resolution: result, targetCombatantId: selected.targetId, multiattackStepId:selected.multiattackStepId });
      if (result.kind === 'area-cast') {
        notify(`${selected.definition.name}: ${result.targetCombatantIds.length} affected creatures. Waiting for their saves.`, 'info');
        saveDamageCastIntentRef.current = null;
        setSaveDamageCast(null);if(enemySaveRecoveryKey)sessionStorage.removeItem(enemySaveRecoveryKey);
      } else if (result.status === 'finalized') {
        onDamageResolved(result);
        saveDamageCastIntentRef.current = null;
        setSaveDamageCast(null);if(enemySaveRecoveryKey)sessionStorage.removeItem(enemySaveRecoveryKey);
      }
    } catch (error) {
      onSaveDamageStateChanged({type:'error',multiattackStepId:selected.multiattackStepId,message:error.message});
      const emptyFollowUp = selected.definition.actionCost?.resource === 'free' && !selected.prepared && /no living/i.test(error.message);
      if (!emptyFollowUp) notify(error?.message || 'Spell could not continue.', 'danger');
      // A free follow-up with nobody left in its area has nothing to resolve: Ice Knife killed its target, or the bead went off alone.
      if (emptyFollowUp) {
        saveDamageCastIntentRef.current = null; setSaveDamageCast(null);
        if (selected.definition.followsBead) await clearLoneBead({ campaignId, characterId, onCombatStateReconciled });
        return;
      }
      if (saveDamageCastIntentRef.current?.resolutionId === resolutionId) remember({ status: selected.prepared ? 'finalize-failed' : 'failed', error: error.message });
    } finally {
      if (automaticAreaDamage) initialAreaDamage({ ...initialDamageContext, active: false,
        completed: initialDamageCompleted, requestId: selected.persistentDamageGroupId, damageDice: selected.persistentDamageDice });
      saveDamageCastLock.current = false;
    }
  }, [saveDamageCast, campaignId, characterId, form?._id, onCombatStateReconciled, onActionEconomyReconciled, onCharacterChange, onDamageResolved, onSaveDamageStateChanged, onSpellSlotReconciled, prepareDiceRollSurface, rollSharedDiceWithBox, onBeginTargeting, combatState?.participants, enemySaveRecoveryKey, form?.entityType, onCancelTargeting]);

  // Quivering Palm (Open Hand 17): end the vibrations with an action or one attack of the Attack action.
  const quiveringPalm = activeQuiveringPalm(form);
  const triggerQuiveringPalm = useCallback(async () => {
    const palm = activeQuiveringPalm(form);
    if (!palm || saveDamageCastLock.current) return;
    const intent = { definition: { id: QUIVERING_PALM, name: 'Quivering Palm', level: 0, delivery: 'saving-throw', save: { ability: 'constitution' } },
      quiveringPalm: true, sourceCombatantId: String(characterId), actionType: 'save-damage', targetId: palm.targetId, pool: 'none', castLevel: 0,
      combatRevision: combatState?.turnSequence, status: 'preparing', error: '', result: null };
    saveDamageCastIntentRef.current = intent; setSaveDamageCast(intent);
    try { await resolveSaveDamageCast(palm.targetId); }
    catch (error) { notify(error.message || 'Quivering Palm could not be used.', 'danger'); }
  }, [form, characterId, combatState?.turnSequence, resolveSaveDamageCast]);
  const endQuiveringPalmHarmlessly = useCallback(async () => {
    try {
      const response = await apiFetch(`/characters/${encodeURIComponent(String(form?._id || characterId))}/monk/quivering-palm/end`, { method: 'POST' });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'Quivering Palm could not be ended.');
      onCharacterChange?.((previous) => previous ? { ...previous, classState: { ...previous.classState, monk: { ...previous.classState?.monk, quiveringPalm: null } } } : previous);
      notify('Quivering Palm: the vibrations end harmlessly.', 'info');
    } catch (error) { notify(error.message, 'danger'); }
  }, [form?._id, characterId, onCharacterChange]);

  useEffect(() => {
    if (saveDamageCast?.status === 'self-cast') resolveSaveDamageCast();
  }, [saveDamageCast?.status, resolveSaveDamageCast]);

const handleDamageClick = useCallback(() => {
  setIsCritical((prev) => {
    const next = !prev;
    manualCriticalRef.current = next;
    return next;
  });
  setIsFumble(false);
}, []);

const setCriticalState = useCallback((value) => {
  const next = Boolean(value);
  manualCriticalRef.current = next;
  setIsCritical(next);
  if (!next) {
    setIsFumble(false);
  }
}, []);

// Spells may come from different caster types (e.g., Wizard, Cleric). Before
// rendering the spell table, group spells by caster type and sort each group by
// level so they display in a predictable order.
const sortedSpells = useMemo(() => {
  if (!Array.isArray(form.spells)) return [];
  const groups = (form.spells || []).reduce((acc, spell) => {
    if (!spell) return acc;
    const caster = spellSourceLabel(spell);
    if (!acc[caster]) acc[caster] = [];
    acc[caster].push(spell);
    return acc;
  }, {});
  return Object.keys(groups)
    .sort()
    .flatMap((caster) =>
      groups[caster].sort((a, b) => (a.level || 0) - (b.level || 0))
    );
}, [form.spells]);

const triggerDiceAnimation = useCallback((diceDetails = []) => {
  if (!Array.isArray(diceDetails) || diceDetails.length === 0) {
    setActiveDice([]);
    return;
  }

  const timestamp = Date.now();
  const nextDice = diceDetails.map((detail, index) => ({
    id: `${timestamp}-${index}`,
    value:
      typeof detail?.value === 'number'
        ? detail.value
        : Number(detail?.value) || 0,
    sides: Number.isFinite(detail?.sides) ? Math.max(2, Math.round(detail.sides)) : 20,
    type: detail?.type || '',
    category: detail?.category || 'base',
  }));

  setActiveDice(nextDice);
}, []);

const clearDamageDice = useCallback(() => {
  setActiveDice([]);
  clearDiceBoxResults();
}, []);

const preparedDice = useMemo(
  () =>
    activeDice.map((die) => {
      const normalizedType = normalizeDamageTypeForClass(die.type);
      const typeColor = resolveDamageTypeColor(normalizedType);
      return {
        ...die,
        typeClass: normalizedType ? `damage-${normalizedType}` : '',
        typeColor,
      };
    }),
  [activeDice],
);

const showOverlayDice = useMemo(() => {
  if (!Array.isArray(preparedDice) || preparedDice.length === 0) {
    return false;
  }

  const uniqueColors = new Set();

  preparedDice.forEach((die) => {
    const normalizedColor = normalizeDiceColor(die?.typeColor);
    if (normalizedColor) {
      uniqueColors.add(normalizedColor);
    }
  });

  return uniqueColors.size > 1;
}, [preparedDice]);

const updateDamageValueWithAnimation = (
  newValue,
  breakdown,
  source,
  extra = {}
) => {
  externalDiceResults?.(extra.diceRolls || []);
  setPulseClass('');
  setDamageValue(newValue);
  setHasDamageRoll(newValue !== undefined);
  setIsDiceRollPending(false);
  setDamageRollLabel(
    typeof extra?.rollLabel === 'string' && extra.rollLabel.trim()
      ? extra.rollLabel.trim()
      : 'Damage'
  );
  const details = Array.isArray(extra?.diceRolls) ? extra.diceRolls : [];
  triggerDiceAnimation(details);
  setLastRollTimestamp(Date.now());
  manualCriticalRef.current = false;
  if (newValue !== undefined && extra.log !== false) {
    {
      const d20 = (Array.isArray(extra.diceRolls) ? extra.diceRolls : []).find((detail) => Number(detail?.sides) === 20 && (detail?.category || 'base') === 'base');
      const luckD20 = STROKE_OF_LUCK_ROLLS.has(extra.rollLabel) ? Number(extra.effectiveD20 ?? d20?.value) : NaN;
      const entry = {
        id: window.crypto?.randomUUID?.() || `roll-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        ...(Number.isInteger(luckD20) ? { rollLabel: extra.rollLabel, luckD20 } : {}),
        ...(STROKE_OF_LUCK_ROLLS.has(extra.rollLabel) && Number.isInteger(extra.heroicReroll?.d20) ? { rollLabel: extra.rollLabel, heroicReroll: extra.heroicReroll } : {}),
        total: newValue,
        breakdown,
        ...(Array.isArray(extra.parts) && extra.parts.length ? { parts: extra.parts, critical: Boolean(extra.critical) } : {}),
        source: extra.sourceLabel
          ? extra.sourceLabel
          : source
          ? toTitleCase(source)
          : undefined,
        actionLabel: extra.actionLabel,
        expression: extra.expression,
        rollValues: Array.isArray(extra.rollValues)
          ? extra.rollValues
          : undefined,
        modifierValues: Array.isArray(extra.modifierValues)
          ? extra.modifierValues
          : undefined,
        diceRollDetails: Array.isArray(extra.diceRolls)
          ? extra.diceRolls.map((detail) => ({
              value:
                typeof detail?.value === 'number'
                  ? detail.value
                  : Number(detail?.value) || 0,
              sides: Number.isFinite(detail?.sides)
                ? Math.max(2, Math.round(detail.sides))
                : undefined,
              type: typeof detail?.type === 'string' ? detail.type : '',
              category:
                typeof detail?.category === 'string' && detail.category.trim()
                  ? detail.category
                  : 'base',
            }))
          : undefined,
      };
      addLogEntries(entry);
    }
  }
};

// Targeted attack rolls update the roller while their dice animate. Reconcile
// that provisional legacy total with resolveAttack's combined raw total once
// generic feature components have been included.
const reconcileResolvedAttackDamage = useCallback((result) => {
  if (result.resistanceReduction) notify(formatResistanceReduction(result.resistanceReduction), 'info');
  // A miss never starts a damage roll. Keep the surface as an attack roll and
  // reconcile it from resolveAttack rather than replacing it with zero damage.
  const resolvedValue = getResolvedAttackDisplayValue(result);
  if (resolvedValue === null) return;
  // Title it by what it is: a reused roll (a retried attack, a cached Opportunity Attack) fires no roll event, so
  // the popup would otherwise keep the title of whatever was shown last.
  setDamageRollLabel(result.outcome === 'miss' ? 'Attack Roll' : 'Damage');
  setDamageValue(resolvedValue);
}, []);

const [pulseClass, setPulseClass] = useState('');

useEffect(() => {
  if (typeof onDamageSummaryChange === 'function') {
    if (!hasDamageRoll) {
      onDamageSummaryChange({
        value: null,
        label: 'Damage',
        isCritical: false,
        isFumble: false,
        timestamp: null,
      });
      return;
    }

    onDamageSummaryChange({
      value: damageValue,
      label: damageRollLabel,
      isCritical,
      isFumble,
      timestamp: lastRollTimestamp || null,
    });
  }
}, [
  onDamageSummaryChange,
  hasDamageRoll,
  damageValue,
  damageRollLabel,
  isCritical,
  isFumble,
  lastRollTimestamp,
]);

useEffect(() => {
  if (!lastRollTimestamp) {
    return undefined;
  }
  const cls = isCritical ? 'pulse-gold' : isFumble ? 'pulse-red' : 'pulse';
  setPulseClass(cls);
  const timer = setTimeout(() => {
    setPulseClass('');
    if (!manualCriticalRef.current) {
      setIsCritical(false);
    }
    setIsFumble(false);
  }, 2000);
  return () => clearTimeout(timer);
}, [lastRollTimestamp, isCritical, isFumble]);

useEffect(() => {
  if (!lastRollTimestamp) {
    return undefined;
  }
  const timer = setTimeout(() => {
    setActiveDice([]);
  }, ROLL_DISPLAY_MS);
  return () => clearTimeout(timer);
}, [lastRollTimestamp]);

// Allow other components to display values in the damage circle
useEffect(() => {
  const handler = (e) => {
    const { value, breakdown, source, critical, fumble, ...extra } =
      e.detail || {};
    updateDamageValueWithAnimation(value, breakdown, source, extra);
    manualCriticalRef.current = false;
    setIsCritical(!!critical && !fumble);
    setIsFumble(!!fumble);
  };
  window.addEventListener('damage-roll', handler);
  return () => window.removeEventListener('damage-roll', handler);
}, []);

const damageWrapperRef = useRef(null);
const damageAmountRef = useRef(null);
const [damageLayout, setDamageLayout] = useState({
  maxWidth: 1200,
  diceSize: 640,
});

const updateDamageLayout = useCallback(() => {
  if (typeof window === 'undefined') {
    return;
  }

  const wrapperEl = damageWrapperRef.current;
  const damageAmountEl = damageAmountRef.current;

  if (!wrapperEl || !damageAmountEl) {
    return;
  }

  const wrapperWidth = wrapperEl.clientWidth || window.innerWidth;
  const viewportWidth = window.innerWidth || document.documentElement?.clientWidth || wrapperWidth;
  const spellSlotsEl = document.querySelector('.spell-slot-container');

  const widthCandidates = [wrapperWidth, Math.max(0, viewportWidth - 64)];
  const positiveWidths = widthCandidates.filter((value) => Number.isFinite(value) && value > 0);
  const maxAllowedWidth = positiveWidths.length > 0 ? Math.min(...positiveWidths) : wrapperWidth;

  const damageRect = damageAmountEl.getBoundingClientRect();
  const boundaries = [];

  if (spellSlotsEl) {
    const { top } = spellSlotsEl.getBoundingClientRect();
    if (Number.isFinite(top)) {
      boundaries.push(top);
    }
  }

  const navbarEl = document.querySelector('nav.navbar.fixed-bottom');
  if (navbarEl) {
    const { top } = navbarEl.getBoundingClientRect();
    if (Number.isFinite(top)) {
      boundaries.push(top);
    }
  }

  const viewportHeight = window.innerHeight || document.documentElement?.clientHeight || 0;
  if (viewportHeight) {
    boundaries.push(viewportHeight - 24);
  }

  const bottomBoundary = boundaries.length > 0 ? Math.min(...boundaries) : viewportHeight;
  const verticalGap = bottomBoundary ? bottomBoundary - damageRect.top - 16 : maxAllowedWidth;
  const maxAllowedHeight = Math.max(260, verticalGap);
  const diceSize = Math.max(360, Math.min(maxAllowedWidth * 0.96, maxAllowedHeight * 0.96));

  setDamageLayout((prev) => {
    const next = {
      maxWidth: Number.isFinite(maxAllowedWidth) && maxAllowedWidth > 0 ? maxAllowedWidth : prev.maxWidth,
      diceSize: Number.isFinite(diceSize) && diceSize > 0 ? diceSize : prev.diceSize,
    };

    if (
      Math.abs(next.maxWidth - prev.maxWidth) < 0.5 &&
      Math.abs(next.diceSize - prev.diceSize) < 0.5
    ) {
      return prev;
    }

    return next;
  });
}, []);

useEffect(() => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  updateDamageLayout();

  const handleResize = () => {
    updateDamageLayout();
  };

  window.addEventListener('resize', handleResize);

  let mutationObserver;
  if (typeof MutationObserver !== 'undefined') {
    mutationObserver = new MutationObserver(() => updateDamageLayout());

    const registerTargets = () => {
      const targets = [
        document.querySelector('.spell-slot-container'),
        document.querySelector('.footer-btn')?.parentElement,
        document.querySelector('nav.navbar.fixed-bottom'),
      ].filter(Boolean);

      if (targets.length === 0) {
        return false;
      }

      targets.forEach((target) => {
        mutationObserver.observe(target, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      });

      return true;
    };

    if (!registerTargets()) {
      const bodyTarget = document.body;
      if (bodyTarget) {
        mutationObserver.observe(bodyTarget, {
          childList: true,
          subtree: true,
        });
      }
    }
  }

  const timeoutId = window.setTimeout(() => updateDamageLayout(), 150);

  return () => {
    window.removeEventListener('resize', handleResize);
    window.clearTimeout(timeoutId);
    if (mutationObserver) {
      mutationObserver.disconnect();
    }
  };
}, [updateDamageLayout]);

useEffect(() => {
  updateDamageLayout();
}, [updateDamageLayout, showLog, showAttack, activeDice.length]);

const resolvedMaxWidth = Number.isFinite(damageLayout.maxWidth)
  ? damageLayout.maxWidth
  : 1200;
const resolvedDiceSize = Number.isFinite(damageLayout.diceSize)
  ? damageLayout.diceSize
  : 640;
const damageContainerMinHeight = Math.max(420, resolvedDiceSize + 320);
const damageAmountStyle = {
  '--damage-roller-max-width': `${resolvedMaxWidth}px`,
  '--damage-roller-min-height': `${damageContainerMinHeight}px`,
  '--damage-dice-area-size': `${resolvedDiceSize}px`,
};
const isDamageRollSurfaceVisible = hasDamageRoll || isDiceRollPending;
const isDamageRollResultVisible = hasDamageRoll && !isDiceRollPending;

const attackArsenalItems = useMemo(() => {
  const weaponItems = equippedWeapons.map(({ slot, weapon }) => {
    const damageString = getDamageStringForHandSelection(slot, weapon) || 'Unknown';
    const details = getWeaponPropertyDetails(weapon);
    const mastery = getWeaponMasteryDetails(weapon);
    const canUseMastery = Boolean(mastery && hasWeaponMastery(form, weapon));
    const id = getWeaponAttackRollId(slot, weapon);
    const tactical = tacticalMasteryChoice(form, canUseMastery, tacticalMasteryChoices[id]);
    const item = { id, kind: isUnarmedAttack(weapon) ? 'unarmed' : 'weapon', category: isUnarmedAttack(weapon) ? 'unarmed' : 'weapons', name: getWeaponDisplayName(slot, weapon), source: getWeaponTypeLabel(weapon), actionType: 'Attack', range: weapon?.range || weapon?.normalRange || weapon?.longRange || (isRangedWeapon(weapon) ? 'Ranged' : '5 ft'), damageText: damageString, damageNode: getDamageString(slot, weapon), damageType: extractDamageTypeText(damageString), attackBonus: formatModifier(getAttackBonus(slot, weapon)), sortAccuracy: Number(getAttackBonus(slot, weapon)) || 0, sortDamage: parseInt((damageString.match(/\d+d(\d+)/i) || [])[1] || '0', 10), tags: [getWeaponTypeLabel(weapon), ...(isRangedWeapon(weapon) ? ['Ranged'] : ['Melee']), ...details.map(({ label }) => label), canUseMastery ? mastery?.label : null].filter(Boolean), properties: details, mastery, hasWeaponMastery: canUseMastery, weaponInstanceId: getWeaponInstanceId(weapon, slot), slot, weapon, canAttackRoll: true, canDamageRoll: true };
    const attackModes = getWeaponAttackModeAvailability({ combat: combatState, combatantId: characterId, attack: item, character: form });
    const automaticallyUsesLight = !attackModes.ordinaryAvailable && attackModes.lightExtra;
    // 2024 Ammunition (players): each attack needs and spends one piece; the server counts it.
    const ammunitionType = form?.entityType !== 'enemy' ? weaponAmmunitionType(weapon) : null;
    const ammunition = ammunitionType ? { type: ammunitionType, label: AMMUNITION_TYPES[ammunitionType].label,
      left: remainingAmmunition(form, ammunitionType), recoverable: recoverableAmmunition(form, ammunitionType) } : null;
    // First, since the card shows only five tags.
    if (ammunition) item.tags = [`${ammunition.label}: ${ammunition.left}`, ...item.tags];
    return {
      ...item,
      ...(tactical ? { mastery: { key: tactical, ...weaponMasteryDefinitions[tactical], tacticalMaster: true, weaponMastery: mastery } } : {}),
      attackModes,
      ammunition,
      // Sacred Weapon: the imbued weapon's tile shows the glowing blade in gold.
      ...(sacredWeaponFor(weapon, slot) ? { sacredWeapon: true, accent: '#ffe9a3' } : {}),
      canAttackRoll: attackModes.hasAnyMode && ammunition?.left !== 0,
      ...(!attackModes.hasAnyMode ? { actionType: 'No attack available' } : ammunition?.left === 0 ? { actionType: `No ${ammunition.label.toLowerCase()} left` } : {}),
      ...(automaticallyUsesLight ? {
        actionType: attackModes.lightExtra.mode === 'nick' ? 'Uses Light Extra Attack · Nick' : 'Uses Light Extra Attack · Bonus Action',
        tags: [...item.tags, 'Light Extra Attack'],
        lightExtraAttack: attackModes.lightExtra,
      } : {}),
    };
  });
  const lightExtraItems = weaponItems.flatMap((item) => {
    const eligibility = getLightExtraAttackEligibility({ combat: combatState, combatantId: characterId, attack: item, character: form });
    if (!eligibility.eligible) return [];
    const label = eligibility.mode === 'nick'
      ? 'Light Extra Attack · Nick · Attack Action'
      : 'Light Extra Attack · Bonus Action';
    return [{ ...item, id: `${item.id}:light-extra`, actionType: label, tags: [...item.tags, 'Light Extra Attack'], lightExtraAttack: eligibility }];
  });
  const breathItems = breathWeaponDetails ? [{ id: 'feature:breath-weapon', kind: 'feature', category: 'racial', name: breathWeaponDetails.label, source: 'Racial Ability', actionType: breathWeaponDetails.save ? `${breathWeaponDetails.save} Save` : 'Action', range: breathWeaponDetails.shape || 'Area', damageText: breathWeaponDetails.damageString, damageNode: formatDamageSegments(breathWeaponDetails.damageString), damageType: extractDamageTypeText(breathWeaponDetails.damageString), attackBonus: `DC ${breathWeaponDetails.saveDC}`, sortAccuracy: Number(breathWeaponDetails.saveDC) || 0, sortDamage: parseInt((breathWeaponDetails.damageString.match(/\d+d(\d+)/i) || [])[1] || '0', 10), tags: ['Breath', breathWeaponDetails.shape, breathWeaponDetails.save].filter(Boolean), properties: [], breathWeapon: true }] : [];
  const preparedTileSpellIds = [...spellsWithPreparedTile(form), ...(favoredEnemySpell ? [HUNTERS_MARK_SPELL_ID] : [])];
  // Reaction spells cast from a prompt when their trigger happens, so they get no automatic tile.
  const isReactionSpell = (spell) => /reaction/i.test(spellsCatalog[spell.spellId]?.castingTime || spell.castingTime || '');
  // A Fiendish Legacy cantrip joins the taken spells, once; the legacy's other spells have tiles of their own.
  const isLegacyCantrip = (rawSpell) => fiendishLegacySpells.includes(rawSpell) && !Number(rawSpell.level) && !sortedSpells.some((spell) => spell?.name === rawSpell.name);
  const spellItems = [...(Array.isArray(form.spells) ? sortedSpells.filter(Boolean) : []), ...fiendishLegacySpells, ...styleCantripSpells, ...magicInitiateSpells, ...discoverySpells, ...oathSpells.filter(oath => !sortedSpells.some(spell => spell?.spellId === oath.spellId)), ...(favoredEnemySpell && !sortedSpells.some(spell => spell?.spellId === HUNTERS_MARK_SPELL_ID) ? [favoredEnemySpell] : [])].map((rawSpell, idx) => { const spell = canonicalSpellPresentation(rawSpell, totalLevel, isDruidSpellSource(rawSpell?.source) ? druidPotentBonus(form, wisMod) : 0); const buffDefinition = rawSpell?.castMode === 'attack' ? null : getBuffSpellDefinition(spell.spellId); const healingDefinition = getHealingSpellDefinition(spell.spellId); const details = healingDefinition || buffDefinition ? null : getSpellAttackDetails(spell); const levelNumber = Number(spell.level) || 0; const id = spell.spellInstanceId ? `spell:${spell.spellInstanceId}${rawSpell?.castMode === 'attack' ? ':attack' : ''}` : `${getSpellAttackRollId(spell)}:${idx}`; const authoritative = !buffDefinition && isCastAccess(spell); const resolvableLegacy = !buffDefinition && Boolean(spell.saveDamageDefinition) && !authoritative && form.spells?.includes(rawSpell); return { id, kind: levelNumber === 0 ? 'cantrip' : 'spell', category: levelNumber === 0 ? 'cantrips' : 'spells', name: spell.name || 'Spell', source: fiendishLegacySpells.includes(rawSpell) ? 'Fiendish Legacy' : styleCantripSpells.includes(rawSpell) || magicInitiateSpells.includes(rawSpell) ? rawSpell.styleName : oathSpells.includes(rawSpell) ? 'Oath of Devotion · always prepared' : rawSpell === favoredEnemySpell ? 'Ranger · always prepared' : spellSourceLabel(spell), hasActionBarTile: styleCantripSpells.includes(rawSpell) || (magicInitiateSpells.includes(rawSpell) && levelNumber === 0), takenSpell: (sortedSpells.includes(rawSpell) || isLegacyCantrip(rawSpell)) && !preparedTileSpellIds.includes(spell.spellId) && !isReactionSpell(spell), actionType: spell.castingTime || 'Cast', range: spell.range || '—', damageText: buffDefinition ? buffDefinition.description : healingDefinition ? `${healingDefinition.count}d${healingDefinition.sides}${healingDefinition.noModifier ? '' : ' + modifier'} healing` : spell.damage || 'Unknown', damageNode: formatDamageSegments(spell.damage || ''), damageType: extractDamageTypeText(spell.damage || ''), attackBonus: details ? formatModifier(details.total) : 'Save / Effect', sortAccuracy: details ? Number(details.total) || 0 : 0, sortDamage: parseInt(((spell.damage || '').match(/\d+d(\d+)/i) || [])[1] || '0', 10), spellLevel: levelNumber, school: spell.school, tags: [levelNumber === 0 ? 'Cantrip' : `Level ${levelNumber}`, spell.school, spell.duration, spell.components].filter(Boolean), spell: spell.directDefinition ? spell : rawSpell, directDefinition: spell.directDefinition, healingDefinition, buffDefinition, canAttackRoll: Boolean(details), canDamageRoll: !healingDefinition && !buffDefinition && Boolean(spell.damage), authoritative, resolvableLegacy,
    // Divine and Searing Smite cast from the Smite prompt after a melee hit. Spells with no engine cast manually: the
    // server spends the slot and Action, and the table applies the effect.
    smitePrompt: SMITE_PROMPT_SPELLS.includes(spell.spellId),
    manualCast: !details && !healingDefinition && !buffDefinition && !spell.damage && !authoritative && !resolvableLegacy && !SMITE_PROMPT_SPELLS.includes(spell.spellId) }; });
  // A lasting spell's attack exists only while the spell does.
  const lastingUp = (definition) => (combatState?.activeEffects || []).some((effect) => effect?.definitionId === definition.requiresEffect && String(effect.targetCombatantId) === String(characterId));
  return [...weaponItems, ...lightExtraItems, ...breathItems, ...spellItems.filter((item) => !item.directDefinition?.spellLevel || lastingUp(item.directDefinition))].map((item) => ({ ...item, icon: item.sacredWeapon ? <Sword size={20}/> : getAttackIcon(item), isFavorite: favoriteAttackIds.has(item.id), isRecent: recentAttackIds.includes(item.id) }));
}, [tacticalMasteryChoices, equippedWeapons, breathWeaponDetails, form, wisMod, sortedSpells, fiendishLegacySpells, styleCantripSpells, magicInitiateSpells, discoverySpells, oathSpells, favoredEnemySpell, getAttackIcon, favoriteAttackIds, recentAttackIds, extractDamageTypeText, getSpellAttackDetails, combatState, characterId, weaponAbilitySelections, numericStrMod, numericDexMod, profBonus]);

const visibleAttackIds = useMemo(() => shownAttackIds(attackArsenalItems, quickAttackIds, hiddenTileIds), [attackArsenalItems, quickAttackIds, hiddenTileIds]);
const toggleAttackTile = (item) => (isAutoTile(item) ? toggleHiddenTile(item.id) : toggleQuickAttack(item.id));

const visibleAttackItems = useMemo(() => {
  const search = attackSearch.trim().toLowerCase();
  const filters = Array.from(activeAttackFilters);
  return attackArsenalItems.filter((item) => {
    if (activeAttackCategory !== 'all' && item.category !== activeAttackCategory) return false;
    if (search && !`${item.name} ${item.source} ${item.damageText} ${item.tags?.join(' ')}`.toLowerCase().includes(search)) return false;
    return filters.every((filter) => filter === 'favorites' ? item.isFavorite : filter === 'equipped' ? ['weapon', 'unarmed'].includes(item.kind) : filter === 'weapons' ? ['weapon', 'unarmed'].includes(item.kind) : filter === 'spells' ? item.kind === 'spell' : filter === 'cantrips' ? item.kind === 'cantrip' : filter === 'melee' ? /melee|5 ft/i.test(`${item.range} ${item.tags?.join(' ')}`) : filter === 'ranged' ? /ranged|ft|mile/i.test(`${item.range} ${item.tags?.join(' ')}`) && !/5 ft$/.test(item.range) : filter === 'bonus' ? /bonus/i.test(item.actionType) : filter === 'reaction' ? /reaction/i.test(item.actionType) : true);
  }).sort((a, b) => { if (a.isFavorite !== b.isFavorite) return a.isFavorite ? -1 : 1; if (a.isRecent !== b.isRecent) return a.isRecent ? -1 : 1; if (attackSort === 'damage') return b.sortDamage - a.sortDamage || a.name.localeCompare(b.name); if (attackSort === 'accuracy') return b.sortAccuracy - a.sortAccuracy || a.name.localeCompare(b.name); if (attackSort === 'spellLevel') return (a.spellLevel || 0) - (b.spellLevel || 0) || a.name.localeCompare(b.name); if (attackSort === 'weaponType') return (a.source || '').localeCompare(b.source || '') || a.name.localeCompare(b.name); return a.name.localeCompare(b.name); });
}, [activeAttackCategory, activeAttackFilters, attackArsenalItems, attackSearch, attackSort]);

const selectedAttack = useMemo(() => attackArsenalItems.find((item) => item.id === selectedAttackId) || null, [attackArsenalItems, selectedAttackId]);

  // Unarmed Strike's effect as cards: Damage (an attack roll) or Grapple / Shove (a Strength or Dexterity save against
  // 8 + your Strength modifier, or Dexterity with Martial Arts, + Proficiency Bonus, as the server sets it).
  const unarmedSaveDC=8+(Number(profBonus)||0)+(canUseMartialArts(form)&&numericDexMod>numericStrMod?numericDexMod:numericStrMod);
  const unarmedOptionsDecision=useCallback((strike)=>{
    const icons={grapple:HandGrab,prone:ArrowDownToLine,push:ArrowRightToLine};
    const saveDetail=`STR or DEX save · DC ${unarmedSaveDC}`;
    return resolveFeatureDecision({id:'unarmed-option',title:'Unarmed Strike',
      cards:[{choiceId:'damage',label:'Damage',detail:`Attack roll${strike?.damageText?` · ${strike.damageText}`:''}`,Icon:Hand,primary:true},
        ...Object.entries(UNARMED_OPTIONS).map(([id,label])=>({choiceId:id,label,detail:saveDetail,Icon:icons[id]}))],
      choices:[{id:'damage',label:'Damage'},...Object.entries(UNARMED_OPTIONS).map(([id,label])=>({id,label})),{id:'skip',label:'Cancel'}]});
  },[resolveFeatureDecision,unarmedSaveDC]);
  const ordinaryUnarmedChoice = useRef(false);
  // Chromatic Orb and Sorcerous Burst ask which damage type to use.
  const chooseSpellDamageType = useCallback(async (item) => {
    const damageTypes = item.directDefinition.damageTypes;
    const choice = await resolveFeatureDecision({ id: 'spell-damage-type', title: item.name, cards: damageTypes.map((id) => ({ choiceId: id, label: id.charAt(0).toUpperCase() + id.slice(1), Icon: Crosshair })),
      choices: [...damageTypes.map((id) => ({ id, label: id })), { id: 'skip', label: 'Cancel' }] });
    return choice && choice.choiceId !== 'skip' ? choice.choiceId : null;
  }, [resolveFeatureDecision]);
// Dragon's Breath: the holder's own Magic action, on the strength of the buff.
  const breathe = useCallback((effect) => {
    if (spellCastBlockReason) { notify(spellCastBlockReason, 'warning'); return; }
    const definition = getExecutableSaveDamageDefinitionForSpell('dragon-s-breath');
    const spell = { spellId: 'dragon-s-breath', spellInstanceId: `grant:${effect.id}`, name: definition.name, level: definition.level, source: { sourceType: 'spell-grant' } };
    const intent = { spell, definition, reuseLine: true, spellInstanceId: spell.spellInstanceId, spellId: spell.spellId, source: spell.source, sourceCombatantId: String(characterId), actionType: 'save-damage',
      targetId: '', pool: '', castLevel: null, supported: true, storm: false, excludedCombatantIds: [], damageType: effect.choice?.damageType, combatRevision: combatState?.turnSequence, status: 'choosing-level', error: '' };
    saveDamageCastIntentRef.current = intent; setSaveDamageCast(intent);
  }, [characterId, combatState?.turnSequence, spellCastBlockReason]);
  // Delayed Blast Fireball: costs nothing further, at the point the bead was placed.
  const explodeBead = useCallback(async (bead) => {
    if (!bead || beadBurstRef.current === bead.id) return;
    const spell = sortedSpells.find((entry) => entry?.spellId === 'delayed-blast-fireball');
    if (!spell) return;
    beadBurstRef.current = bead.id;
    const definition = getExecutableSaveDamageDefinitionForSpell('delayed-blast-fireball');
    const intent = { spell, definition, reuseLine: true, spellInstanceId: spell.spellInstanceId, spellId: spell.spellId, source: spell.source, sourceCombatantId: String(characterId),
      actionType: 'save-damage', pool: 'none', castLevel: definition.level, status: 'finalize-pending', combatRevision: combatState?.turnSequence, error: '' };
    saveDamageCastIntentRef.current = intent; setSaveDamageCast(intent);
    try { await resolveSaveDamageCast(undefined, [String(characterId)], bead.placement); }
    catch (failure) { beadBurstRef.current = null; notify(failure.message, 'danger'); }
  }, [characterId, combatState?.turnSequence, resolveSaveDamageCast, sortedSpells]);
  // Concentration ended some other way: it goes off now.
  const orphanBead = (combatState?.activeEffects || []).find((effect) => effect?.definitionId === 'spell-bead:delayed-blast' && String(effect.sourceCombatantId) === String(characterId)
    && !(combatState.activeEffects || []).some((root) => root.id === effect.rootEffectId));
  useEffect(() => { if (orphanBead) void explodeBead(orphanBead); }, [explodeBead, orphanBead]);
const runAttackRoll = useCallback(async (item) => {
  if (!item) return;
  if (item.spell && spellCastBlockReason) { notify(spellCastBlockReason, 'warning'); return; }
  makeRecent(item.id); setSelectedAttackId(item.id);
  if (multiCastRef.current && item.directDefinition?.multiAttack) { selectMultiCastTarget(multiCastRef.current); setShowAttack(false); return; }
  if (item.directDefinition?.level > 0) { setDirectSpellSelection(item); return; }
  if (item.directDefinition?.multiAttack) { beginMultiCast(item); return; }
  if (item.directDefinition?.damageTypes) {
    setShowAttack(false);
    const damageType = await chooseSpellDamageType(item);
    if (!damageType) return;
    directSpellChoicesRef.current[item.id] = { castLevel: 0, pool: 'none', damageType };
  }
  let attackId = item.id;
  if (item.kind === 'unarmed' && campaignId) {
    if (ordinaryUnarmedChoice.current) return;
    ordinaryUnarmedChoice.current = true;
    setShowAttack(false);
    try {
      const choice = await unarmedOptionsDecision(item);
      if (!choice || choice.choiceId === 'skip') return;
      if (choice.choiceId !== 'damage') attackId = `${item.id}::${choice.choiceId}`;
    } finally { ordinaryUnarmedChoice.current = false; }
  }
  onBeginTargeting({ sourceCombatantId: characterId, actionType: 'attack', attackId });
  setShowAttack(false);
}, [beginMultiCast, selectMultiCastTarget, characterId, makeRecent, onBeginTargeting, spellCastBlockReason, campaignId, unarmedOptionsDecision]);
// 2024 Ammunition: after a fight, recover half the ammunition used since the last recovery.
const recoverAmmunition = useCallback(async () => {
  const id = form?._id || characterId;
  try {
    const response = await apiFetch(`/equipment/ammunition/recover/${encodeURIComponent(id)}`, { method: 'POST' });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Ammunition could not be recovered.');
    onCharacterChange?.(previous => ({ ...previous, ammunition: result.ammunition }));
    const recovered = Object.entries(result.recovered || {}).map(([type, count]) => `${count} ${(AMMUNITION_TYPES[type]?.label || type).toLowerCase()}`);
    notify(recovered.length ? `Recovered ${recovered.join(', ')}.` : 'No ammunition to recover.', recovered.length ? 'success' : 'info');
  } catch (error) { notify(error.message, 'danger'); }
}, [characterId, form?._id, onCharacterChange]);
const runLightAttackRoll = useCallback((item) => {
  const lightItem = attackArsenalItems.find((candidate) => candidate.id === `${item.id}:light-extra`);
  if (lightItem) runAttackRoll(lightItem);
}, [attackArsenalItems, runAttackRoll]);
const runDamageRoll = useCallback((item) => {
  if (!item) return;
  if (item.spell && spellCastBlockReason) { notify(spellCastBlockReason, 'warning'); return; }
  makeRecent(item.id);
  if (item.kind === 'weapon' || item.kind === 'unarmed') {
    handleWeaponAttack(item.slot, item.weapon);
  } else if (item.id === 'feature:breath-weapon') {
    // Like a spell, map targeting closes only the Arsenal.
    beginBreathWeapon();
    setShowAttack(false);
    return;
  } else if (item.spell) {
    // Match runAttackRoll: initiating map targeting closes only the Arsenal.
    // handleCloseAttack is the user-cancel path and calls onCancelTargeting,
    // which would immediately erase the selection request we just published.
    beginSaveDamageCast(item.spell);
    setShowAttack(false);
    return;
  }
  handleCloseAttack();
}, [beginSaveDamageCast, beginBreathWeapon, handleCloseAttack, handleWeaponAttack, makeRecent, spellCastBlockReason]);

  const pendingUnarmedAttempt=useRef(null);
  // While a target is being chosen: outlines of what the attack or spell reaches, and how the roll would go against a
  // hovered creature (range, Advantage/Disadvantage, Half Cover). Reads only; no dice and no writes.
  const getTargetingPreview = useCallback((request) => {
    if (!request || request.status !== 'selecting-target') return null;
    const sourceId = String(request.sourceCombatantId || characterId);
    const tokens = spatialContext?.tokens || {};
    const entityOf = (id) => ({ ...(tokens[id] || {}), ...(spatialContext?.entities?.[id] || {}) });
    const distanceTo = (targetId) => (tokens[sourceId] && tokens[targetId] ? minimumFootprintDistanceFeet({ sourceToken: tokens[sourceId],
      targetToken: tokens[targetId], sourceSize: ownCreatureSize(form, combatState, characterId), targetSize: entityOf(targetId).size, map: spatialContext?.map }) : null);
    if (request.actionType !== 'attack') {
      const feet = Number(request.rangeFeet);
      if (!(feet > 0) || request.selectionMode === 'area') return null;
      return { sourceId, rings: [{ feet, kind: 'normal' }], evaluate: (targetId) => {
        const distance = distanceTo(targetId);
        const tone = targetTone({ inRange: distance === null || distance <= feet, rollsToHit: false });
        return { tone, description: describeTarget({ tone, reason: `${request.label || 'This'} has a range of ${feet} feet.` }) };
      } };
    }
    const optionMatch = String(request.attackId).match(/::(grapple|prone|push)$/);
    const arsenalAttack = attackArsenalItems.find((candidate) => candidate.id === (optionMatch ? String(request.attackId).slice(0, optionMatch.index) : request.attackId));
    if (!arsenalAttack) return null;
    const isWeapon = arsenalAttack.kind === 'weapon' || arsenalAttack.kind === 'unarmed';
    const ownReach = Boolean(request.opportunityId) || ['cleave-extra', 'horde-breaker'].includes(request.attackOrigin);
    const directDefinition = arsenalAttack.spell ? getDirectSpellDefinition(arsenalAttack.spell?.spellId) : null;
    const spellFeet = arsenalAttack.spell ? (directSpellRangeFeet(form, arsenalAttack.spell, directDefinition) ?? spellRangeFeet(arsenalAttack.spell?.range)) : null;
    const rings = isWeapon ? weaponRangeRings({ weapon: arsenalAttack.weapon, unarmed: arsenalAttack.kind === 'unarmed' })
      : spellFeet ? [{ feet: spellFeet, kind: 'normal' }] : [];
    if (!rings.length) return null;
    return { sourceId, rings, evaluate: (targetId) => {
      const target = entityOf(targetId);
      const distance = distanceTo(targetId);
      const attack = { ...arsenalAttack };
      let inRange = true;
      let reason;
      if (isWeapon) {
        const range = resolveWeaponAttackRange({ weapon: attack.weapon, distanceFeet: distance, unarmed: attack.kind === 'unarmed' });
        inRange = ownReach || range.allowed;
        reason = range.reason;
        attack.attackMode = range.mode === 'melee' ? 'melee' : 'ranged';
        attack.thrown = range.mode === 'thrown';
        attack.longRange = !ownReach && range.longRange;
        attack.isMeleeAttack = attack.attackMode === 'melee';
      } else {
        inRange = distance === null || distance <= spellFeet;
        reason = `${arsenalAttack.name} has a range of ${spellFeet} feet.`;
        const delivery = directDefinition?.delivery;
        attack.attackMode = delivery === 'melee-spell-attack' ? 'melee' : delivery === 'ranged-spell-attack' || isRangedSpellAttack(attack.spell) ? 'ranged' : undefined;
      }
      let rollMode = getAttackRollMode({ attackerId: characterId, targetId, attack, attacker: form, target, combatState, spatialContext });
      if (isWeapon) {
        const unarmed = attack.kind === 'unarmed';
        rollMode = resolveAttackRollMode(form, { attackAbility: attackAbilityKeyForWeapon(attack.slot, attack.weapon), isMeleeAttack: unarmed || isMeleeWeapon(attack.weapon),
          kind: unarmed ? 'unarmed' : 'weapon', isWeaponAttack: !unarmed, isUnarmedStrike: unarmed }, { ...rollMode, combatState, actorId: characterId });
      }
      // Behind a door, the target reads as it would through the open door: the attack asks whether it is.
      const throughDoor = attackThroughDoor({ attackerId: characterId, targetId, spatialContext, combatState });
      const cover = getAttackCover({ attackerId: characterId, targetId, spatialContext, combatState, doorOpen: throughDoor });
      const tone = targetTone({ inRange, mode: rollMode.mode, cover });
      const sources = rollMode.mode === 'advantage' ? rollMode.advantageSources : rollMode.mode === 'disadvantage' ? rollMode.disadvantageSources : [];
      return { tone, description: describeTarget({ tone, sources: sources || [], reason, cover, throughDoor }) };
    } };
  }, [attackArsenalItems, characterId, combatState, form, attackAbilityKeyForWeapon, isMeleeWeapon, isRangedSpellAttack, spatialContext]);

  const resolveTargetedAttack = useCallback(async ({ attackId, targetId, target, attackOrigin = 'ordinary', parentResolutionId = null, primaryTargetId = null, primaryOutcome = 'hit', triggeringWeaponInstanceId = null, opportunityId = null, monkGrantId = null }) => {
      if(attackOrigin==='monk' && monkAttackLock.current)throw new Error('Wait for the current Monk strike to finish.');
      await passTargetingBlock({ campaignId, combatState, attackerId: characterId, targetId, targetName: target?.name, onCombatChange: onCombatStateReconciled });
      const trueStrike = activeRecipientBuff(combatState, characterId, 'true-strike');
      if(attackOrigin==='monk'){monkAttackLock.current=true;setMonkAttackRunning(monkAttackCacheKey(campaignId,characterId),true);}
      try {
      const optionMatch=String(attackId).match(/::(grapple|prone|push)$/);
      let unarmedOption=optionMatch?.[1];
      const baseAttackId=optionMatch?String(attackId).slice(0,optionMatch.index):attackId;
      const arsenalAttack = attackArsenalItems.find((candidate) => candidate.id === baseAttackId);
      if (arsenalAttack?.spell && spellCastBlockReason) throw new Error(spellCastBlockReason);
      const attack = arsenalAttack && attackOrigin === 'cleave-extra'
        ? { ...arsenalAttack, name: `Cleave · ${arsenalAttack.name}`, origin: 'cleave-extra', isMeleeAttack: true, abilityModifierDamagePolicy: CLEAVE_DAMAGE_POLICY }
        // Horde Breaker is a full attack with the same weapon; it never uses the Light extra attack.
        : arsenalAttack && attackOrigin === 'horde-breaker'
        ? { ...arsenalAttack, name: `Horde Breaker · ${arsenalAttack.name}`, origin: 'horde-breaker', lightExtraAttack: undefined }
        : arsenalAttack ? { ...arsenalAttack } : null;
      if (!attack) throw new Error('The selected attack is no longer available.');
      if (attack.kind === 'unarmed' && hasMonkFeature(form, 'empoweredStrikes')) attack.empoweredStrikes = true;
      let committedLedger = null; let cleaving = false;
      if(attack.kind==='weapon'&&grappleBlocksWeaponHands(combatState,String(characterId),attack.weapon,getHandSelectionForWeapon(attack.slot,attack.weapon)))throw new Error('Release the grapple or choose a one-handed weapon mode.');
      if(opportunityId&&attack.kind==='unarmed'&&!unarmedOption){const choice=await unarmedOptionsDecision(attack);if(!choice||choice.choiceId==='skip')return;unarmedOption=choice.choiceId==='damage'?null:choice.choiceId;}
      if(unarmedOption){
        if(attack.kind!=='unarmed'||!campaignId)throw new Error('Choose an Unarmed Strike during combat.');
        const previous=pendingUnarmedAttempt.current;
        if(previous&&previous.turnSequence===combatState.turnSequence&&(previous.targetId!==targetId||previous.option!==unarmedOption))throw new Error('Retry the original Unarmed option against its original target first.');
        const intent=previous?.turnSequence===combatState.turnSequence?previous:{id:window.crypto?.randomUUID?.()||`unarmed-${Date.now()}-${Math.random()}`,actorId:String(characterId),targetId,option:unarmedOption,turnSequence:combatState.turnSequence,origin:opportunityId?'opportunity':attackOrigin==='monk'?'monk':'ordinary',monkGrantId,opportunityId,canSee:Boolean(opportunityId)};
        pendingUnarmedAttempt.current=intent;
        const response=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/unarmed`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(intent)});
        const saved=await response.json();if(!response.ok){if(response.status>=400&&response.status<500)pendingUnarmedAttempt.current=null;throw new Error(saved.message||'Unarmed option could not be saved.');}
        pendingUnarmedAttempt.current=null;onCombatStateReconciled(saved.combat);if(intent.origin!=='opportunity')onActionEconomyReconciled(saved.combat.turnActionLedger);notify(`${UNARMED_OPTIONS[unarmedOption]}: waiting for the target’s save.`,'info');return saved;
      }
      // 2024 range and reach: an out-of-range target is refused before any dice. A Thrown weapon beyond reach makes a
      // ranged attack; beyond normal range it has Disadvantage. Opportunity, Cleave and Horde Breaker attacks check
      // their own reach.
      if(attack.kind==='weapon'||attack.kind==='unarmed'){
        const sourceToken=spatialContext?.tokens?.[characterId],targetToken=spatialContext?.tokens?.[targetId];
        const distanceFeet=sourceToken&&targetToken?minimumFootprintDistanceFeet({sourceToken,targetToken,sourceSize:ownCreatureSize(form,combatState,characterId),targetSize:target.size,map:spatialContext?.map}):null;
        const range=resolveWeaponAttackRange({weapon:attack.weapon,distanceFeet,unarmed:attack.kind==='unarmed'});
        const ownReach=opportunityId||['cleave-extra','horde-breaker'].includes(attackOrigin);
        if(!range.allowed&&!ownReach)throw new Error(range.reason);
        attack.attackMode=ownReach&&attackOrigin==='cleave-extra'?'melee':range.mode==='melee'?'melee':'ranged';
        attack.thrown=range.mode==='thrown';
        attack.longRange=!ownReach&&range.longRange;
        attack.isMeleeAttack=attack.attackMode==='melee';
        if(trueStrike?.choice?.damageType==='radiant'&&attack.kind==='weapon')attack.damageType='radiant';
      } else if (attack.spell) {
        const delivery=getDirectSpellDefinition(attack.spell?.spellId)?.delivery;
        attack.attackMode=delivery==='melee-spell-attack'?'melee':delivery==='ranged-spell-attack'||isRangedSpellAttack(attack.spell)?'ranged':undefined;
      }
      const monkCacheKey = monkAttackCacheKey(campaignId,characterId);
      let monkPending = null;
      if (attackOrigin === 'monk') {
        if (attack.kind !== 'unarmed' || !monkGrantId) throw new Error('Monk bonus attacks must use Unarmed Strike.');
        const stored = pendingMonkAttack.current?.key === monkCacheKey && pendingMonkAttack.current.turnSequence === combatState?.turnSequence
          ? pendingMonkAttack.current : readMonkAttack(monkCacheKey,combatState?.turnSequence);
        if (stored && (stored.targetId !== targetId || stored.parentId !== monkGrantId)) throw new Error('Finish the interrupted Monk strike against its original target first.');
        if (stored?.uncertain) throw new Error('A Monk dice roll was interrupted. Ask the DM to verify this strike, then mark it resolved in the Monk controls.');
        monkPending = stored || {key:monkCacheKey,turnSequence:combatState?.turnSequence,parentId:monkGrantId,targetId,attackId,
          resolutionId:window.crypto?.randomUUID?.() || `monk-strike-${Date.now()}-${Math.random()}`,hpBefore:target.currentHp,armorClass:target.armorClass};
        pendingMonkAttack.current=monkPending;saveMonkAttack(monkCacheKey,monkPending);
        attack.origin='monk';attack.monkAction=combatState?.turnActionLedger?.monkAttacks?.action;
      }
      const cacheMonkRoll = async (key,roll) => {
        if(!monkPending)return roll();
        if(monkPending[key] !== undefined)return monkPending[key];
        monkPending={...monkPending,uncertain:true};pendingMonkAttack.current=monkPending;saveMonkAttack(monkCacheKey,monkPending);
        const result=await roll();
        monkPending={...monkPending,[key]:result,uncertain:false};pendingMonkAttack.current=monkPending;saveMonkAttack(monkCacheKey,monkPending);
        return result;
      };
      const previousCriticalMove=(combatState?.eventLog||[]).find(e=>e.type==='championMovement'&&!e.completed&&e.turnSequence===combatState.turnSequence&&[String(characterId),String(form?._id),String(form?.characterId)].includes(e.actorId));
      if(previousCriticalMove){
        const response=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/fighter/champion/decline`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:previousCriticalMove.id})});
        const payload=await response.json();if(!response.ok)throw new Error(payload.message||'Finish the previous critical movement first.');
        onCombatStateReconciled(payload.combat);
      }
      const ability = attack.kind === 'weapon' || attack.kind === 'unarmed' ? attackAbilityKeyForWeapon(attack.slot, attack.weapon) : '';
      const isWeaponAttack = attack.kind === 'weapon';
      // Combat payloads intentionally contain only timeline state.  The campaign
      // identity lives beside that state on the character sheet, so join it here
      // before producing the authoritative post-hit feature context.
      const attackCombatState = campaignId && !combatState?.campaignId
        ? { ...combatState, campaignId }
        : combatState;
      const attackFeatureIntegration = createPlayerAttackFeatureIntegration({
        character: form, attackerId: characterId, targetId, target, attack, ability,
        abilityModifier: attack.kind === 'weapon' || attack.kind === 'unarmed'
          ? abilityForWeapon(attack.weapon, attack.slot)
          : getSpellAttackDetails(attack.spell)?.abilityBonus,
        proficiencyBonus: Number(profBonus) || 0, combatState: attackCombatState,
        isWeaponAttack,
        isMelee: isWeaponAttack ? attack.attackMode === 'melee' : getDirectSpellDefinition(attack.spell?.spellId)?.delivery === 'melee-spell-attack',
        isRanged: isWeaponAttack ? attack.attackMode === 'ranged' : getDirectSpellDefinition(attack.spell?.spellId)?.delivery === 'ranged-spell-attack',
        isFinesse: isWeaponAttack ? isFinesseWeapon(attack.weapon) : false,
        // Divine Smite offers the slots this sheet shows as available.
        queries: { availableSlots, rollDice: rollSharedDiceWithBox, targetDistanceFeet: spatialContext?.tokens?.[characterId] && spatialContext.tokens[targetId] ? minimumFootprintDistanceFeet({ sourceToken: spatialContext.tokens[characterId], targetToken: spatialContext.tokens[targetId], sourceSize: form?.size, targetSize: target?.size, map: spatialContext.map }) ?? undefined : undefined },
      });
      const pendingBrutalStrike = getBrutalStrikePendingEffect(combatState, characterId);
      let usesBrutalStrike = !opportunityId && Boolean(pendingBrutalStrike);
      if (usesBrutalStrike && (!isActiveTurn || !isBrutalStrikeEligibleAttack({ attack, ability, rollMode: 'normal' }))) {
        throw new Error('Brutal Strike requires a Strength-based attack that does not have Disadvantage.');
      }
      // Snapshot the selected arsenal entry's resource identity before rolling.
      // The shared resolver must authorize a weapon attack exactly once; a Light
      // extra attack is not also an ordinary Attack-action attack.
      if(opportunityId&&!(attack.kind==='unarmed'||attack.kind==='weapon'&&isMeleeWeapon(attack.weapon)))throw new Error('Opportunity Attacks require a melee weapon or Unarmed Strike.');
      const attackActionEconomy = attackOrigin === 'cleave-extra'
        ? { kind: 'cleave-extra', authorization: { parentResolutionId, primaryTargetId, secondaryTargetId: targetId, isMeleeAttack: true, primaryOutcome } }
        : attackOrigin === 'horde-breaker'
        ? { kind: 'horde-breaker', authorization: { parentResolutionId, primaryTargetId, secondaryTargetId: targetId, isMeleeAttack: Boolean(attack.isMeleeAttack) } }
        : attack.lightExtraAttack
        ? { kind: 'light-extra', mode: attack.lightExtraAttack.mode, attackActionId: attack.lightExtraAttack.attackActionId }
        : { kind: 'ordinary', light: (attack.weapon?.properties || []).some((property) => String(property?.name || property).toLowerCase() === 'light') };
      const directDefinition = getDirectSpellDefinition(attack.spell?.spellId);
      if (directDefinition && (!attack.spell.spellInstanceId || !['class','monster','class-feature'].includes(attack.spell.source?.sourceType))) throw new Error('Resolve this spell’s casting source before casting.');
      let rays = (directDefinition?.multiAttack || (multiCastRef.current?.multiattackStepId && multiCastRef.current?.attackId===attack.id)) ? multiCastRef.current : null;
      if ((directDefinition?.multiAttack || rays?.multiattackStepId) && (!rays || rays.attackId !== attack.id || rays.turnSequence !== combatState?.turnSequence || rays.completed >= rays.count)) throw new Error('Start this spell cast before choosing a target.');
      if (rays && (!campaignId || !Number.isInteger(combatState?.turnSequence) || !isActiveTurn)) throw new Error('Cast rays and beams on your active combat turn.');
      if (rays && multiCastLockRef.current) throw new Error('Wait for the current ray or beam to finish.');
      if (rays?.pending?.targetId && rays.pending.targetId !== targetId) throw new Error('Finish the interrupted attack against its original target.');
      if (rays?.pending?.uncertain && !rays.multiattack) throw new Error('A dice roll was interrupted. Ask the DM to verify this attack, then mark it resolved in the spell panel.');
      if (rays && !rays.pending) {
        const distance = minimumFootprintDistanceFeet({ sourceToken: spatialContext?.tokens?.[characterId], targetToken: spatialContext?.tokens?.[targetId], sourceSize: ownCreatureSize(form, combatState, characterId), targetSize: target.size, map: spatialContext?.map });
        if (!['character', 'enemy', 'monster'].includes(target.entityType) || Number(target.currentHp) <= 0 || distance === null || distance > directDefinition.rangeFeet) throw new Error(`Choose a living creature on the map within ${directDefinition.rangeFeet} feet.`);
      }
      if(rays?.multiattackStepId)onSpellCastProgress({type:'started',multiattackStepId:rays.multiattackStepId});
      const directChoices = rays?.choices || directSpellChoicesRef.current[attack.id] || { castLevel: 0, pool: 'none' };
      if (rays?.spellAttack) { attack.spell = { ...attack.spell, ...rays.spellAttack }; attack.damageText = rays.spellAttack.damage; }
      if (directDefinition?.missHalf) attack.missHalfDamage = true;
      const updateRay = (changes) => {
        if (multiCastRef.current?.id !== rays.id) throw new Error('This cast belongs to an earlier turn.');
        saveMultiCast({ ...multiCastRef.current, ...changes });
      };
      const cacheRayRoll = async (key, roll) => {
        const pending = multiCastRef.current?.pending || { targetId, hpBefore: target.currentHp, armorClass: target.armorClass };
        if (pending[key] !== undefined) return pending[key];
        updateRay({ pending: { ...pending, uncertain: true } });
        const value = rays.multiattack
          ? await captureMultiattackRoll(campaignId,rays.multiattack,directSpellAttackResolutionId(rays,directDefinition),key==='attackRoll' ? 'attack' : 'damage',multiattackClientId.current,roll)
          : await roll();
        updateRay({ pending: { ...multiCastRef.current.pending, [key]: value, uncertain: false } });
        return value;
      };
      if(rays?.multiattack){
        const bound=await multiattackRequest(campaignId,rays.multiattack,'bind',{eventId:directSpellAttackResolutionId(rays,directDefinition),targetId,armorClass:target.armorClass});
        updateRay({pending:{...(multiCastRef.current.pending || {}),targetId,hpBefore:bound.attack.target.currentHp,armorClass:bound.attack.target.armorClass}});
        rays=multiCastRef.current;
      }
      if (directDefinition?.level > 0 && directChoices.castLevel < directDefinition.level) throw new Error('Choose a spell slot before casting.');
      if (directDefinition?.rider && (!campaignId || !Number.isInteger(combatState?.turnSequence) || combatState?.activeTurn == null)) throw new Error('Start combat to track this spell’s resources and timed effect.');
      const actionEconomy = attackOrigin === 'monk' ? {kind:'monk',preRoll:true,commit:async({resolutionId})=>{
        const result=await submitMonkAction(campaignId,{action:'attack',id:resolutionId,combatantId:String(characterId),turnSequence:combatState.turnSequence,parentId:monkGrantId,targetId,attackKind:'unarmed'});
        onCombatStateReconciled(result.combat);onActionEconomyReconciled(result.ledger);onCharacterChange?.(previous=>mergeMonkFocus(previous,result.focus));return result;
      }} : opportunityId ? {kind:'opportunity',preRoll:true,commit:async({resolutionId})=>{
        const response=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/movement/opportunities/${encodeURIComponent(opportunityId)}`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({decision:'use',resolutionId,canSee:true,attackName:attack.weapon?.name||'Unarmed Strike'})});
        const result=await response.json();if(!response.ok)throw new Error(result.message||'Reaction unavailable.');return result;
      }} : directDefinition && campaignId && Number.isInteger(combatState?.turnSequence) && combatState?.activeTurn != null
        ? { kind: 'magic', preRoll: true, commit: async ({ resolutionId }) => {
          if (rays?.spellAttack) return { status: 'replayed', spellAttack: rays.spellAttack };
          const claim = await spendTurnResource(campaignId, { combatantId: characterId, turnSequence: combatState.turnSequence, resolutionId: rays?.id || resolutionId, resource: directDefinition.requiresEffect ? directDefinition.action : 'action', spellInstanceId: attack.spell.spellInstanceId, targetId, ...directChoices });
          if (claim.ledger) onActionEconomyReconciled?.(claim.ledger);
          if (claim.resourceProfile) onSpellSlotReconciled?.(claim.resourceProfile);
          if (['spent', 'replayed'].includes(claim.status)) {
            if (!claim.spellAttack) throw new Error('The spell attack authorization was not confirmed.');
            attack.spell = { ...attack.spell, ...claim.spellAttack };
            attack.damageText = claim.spellAttack.damage;
            if (rays) {
              const count = confirmedDirectSpellAttackCount(claim.spellAttack);
              updateRay({ spellAttack: claim.spellAttack, count });
            }
          }
          return claim;
        } }
        : ['weapon','unarmed'].includes(attack.kind) && campaignId && Number.isInteger(combatState?.turnSequence) && combatState?.activeTurn != null
        ? {
          kind: attackActionEconomy.kind,
          ...(['cleave-extra', 'horde-breaker'].includes(attackActionEconomy.kind) ? { preRoll: true } : {}),
          ...(attackActionEconomy.mode ? { mode: attackActionEconomy.mode } : {}),
          commit: async ({ resolutionId, doorOpen }) => {
            const payload = {
              combatantId: characterId,
              turnSequence: combatState.turnSequence,
              resolutionId,
              targetId: String(targetId),
              ...(doorOpen === true ? { doorOpen: true } : {}),
              weaponInstanceId: getWeaponInstanceId(attack.weapon, attack.slot),
              baseWeaponKey: [attack.weapon?.index, attack.weapon?.type, attack.weapon?.weaponType, attack.weapon?.name].map(normalizeWeaponKey).find(key => weaponTypeMasteries[key]) || normalizeWeaponKey(attack.weapon?.index || attack.weapon?.type || attack.weapon?.name),
            };
            if (triggeringWeaponInstanceId && payload.weaponInstanceId !== triggeringWeaponInstanceId) throw new Error(`${attackOrigin === 'horde-breaker' ? 'Horde Breaker' : 'Cleave'} must use the weapon that triggered it.`);
            const claim = await commitWeaponAttack(campaignId, attackActionEconomy, payload);
            if (claim?.ledger) { committedLedger = claim.ledger; onActionEconomyReconciled(claim.ledger); }
            if (claim?.ammunition) onCharacterChange?.(previous => ({ ...previous, ammunition: claim.ammunition }));
            return claim;
          },
        }
        : undefined;
      const recklessActorId = resolveRecklessActorId(form, combatState, characterId);
      const currentRecklessWindow = recklessWindow(combatState, recklessActorId);
      const pendingAttackKey = `barbarian:first-attack:${campaignId}:${characterId}`;
      const storedAttack = pendingBarbarianAttack.current || readPendingBarbarianAttack(pendingAttackKey);
      const retryingFirstRoll = storedAttack?.cacheKey === pendingAttackKey && storedAttack?.turnSequence === combatState?.turnSequence && Boolean(storedAttack?.roll);
      const recordsFirstAttack = Boolean(campaignId && getClassLevel(form, 'barbarian') >= 2 && currentRecklessWindow.ownTurn && (!currentRecklessWindow.firstAttackMade || retryingFirstRoll));
      const recordsFrenzy = Boolean(campaignId && currentRecklessWindow.ownTurn && hasBerserkerFrenzy(form) && ['weapon','unarmed'].includes(attack.kind) && ['str','strength'].includes(ability));
      let approvedFrenzy = null;
      // Reckless Attack (2024): the Barbarian decides on the turn's first attack roll, before the dice. Choosing it readies
      // it on the server first, so this roll already has its Advantage. A readied Brutal Strike implies it.
      let recklessCombat = null;
      const retryingThisAttack = storedAttack?.cacheKey === pendingAttackKey && storedAttack?.turnSequence === combatState?.turnSequence
        && storedAttack?.attackId === attackId && storedAttack?.targetId === targetId;
      if (retryingThisAttack && storedAttack?.brutalStrike) usesBrutalStrike = true;
      const strengthAttack = ['weapon','unarmed'].includes(attack.kind) && ['str','strength'].includes(ability);
      // Brutal Strike (Barbarian 9): on a reckless turn, forgo any Advantage on one Strength attack roll that has no
      // Disadvantage, once per turn. It is offered in the same prompts as Reckless Attack.
      const brutalOffered = !usesBrutalStrike && !retryingThisAttack && !rays && !opportunityId && isActiveTurn && strengthAttack
        && getClassLevel(form, 'barbarian') >= 9 && !brutalStrikeUsedThisTurn(combatState, String(characterId))
        && isBrutalStrikeEligibleAttack({ attack, ability, rollMode: 'normal' })
        && getAttackRollMode({ attackerId: characterId, targetId, attack, attacker: form, target, combatState, spatialContext }).disadvantageSources.length === 0;
      const brutalText = `Brutal Strike: forgo every Advantage on this roll; on a hit it deals an extra ${brutalStrikeDiceCount(form)}d10 and you choose ${brutalStrikeDiceCount(form) === 2 ? 'two Brutal Strike effects' : 'a Brutal Strike effect'}. Once per turn.`;
      if (recordsFirstAttack && !retryingThisAttack && !rays && !opportunityId && !currentRecklessWindow.active && !currentRecklessWindow.ready && strengthAttack) {
        const choice = usesBrutalStrike ? { choiceId: 'reckless' } : await resolveFeatureDecision({ id: `reckless:${combatState.turnSequence}:${attackId}`, featureId: 'barbarian:reckless-attack',
          title: 'Reckless Attack', prompt: `This is your first attack roll this turn. Attack recklessly? You have Advantage on attack rolls using Strength until the start of your next turn, and attack rolls against you have Advantage until then too.${brutalOffered ? ` ${brutalText}` : ''}`,
          choices: [{ id: 'reckless', label: 'Attack recklessly', action: 'apply' },
            ...(brutalOffered ? [{ id: 'reckless-brutal', label: 'Recklessly, with Brutal Strike', action: 'apply' }] : []),
            { id: 'normal', label: 'Attack normally' }] });
        if (choice?.choiceId === 'reckless-brutal') usesBrutalStrike = true;
        if (['reckless', 'reckless-brutal'].includes(choice?.choiceId)) {
          const saved = await commitRecklessAttack(String(characterId), { kind:'ready', ready:true, turnSequence:combatState.turnSequence,
            id: typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `reckless-${Date.now()}-${Math.random().toString(36).slice(2)}` });
          recklessCombat = saved.combat;
          if (recklessScope.current === `${campaignId}:${characterId}`) onCombatStateReconciled(saved.combat);
        }
      } else if (brutalOffered && (currentRecklessWindow.active || currentRecklessWindow.ready)) {
        const choice = await resolveFeatureDecision({ id: `brutal-strike:${combatState.turnSequence}:${attackId}`, featureId: 'barbarian:brutal-strike',
          title: 'Brutal Strike', prompt: `Use Brutal Strike on this attack? ${brutalText}`,
          choices: [{ id: 'brutal', label: 'Use Brutal Strike', action: 'apply' }, { id: 'skip', label: 'Attack normally' }] });
        if (choice?.choiceId === 'brutal') usesBrutalStrike = true;
      }
      let pendingAttack;
      if ((recordsFirstAttack || recordsFrenzy) && !rays && !opportunityId) {
        pendingAttack = storedAttack;
        if (pendingAttack?.cacheKey !== pendingAttackKey || pendingAttack?.turnSequence !== combatState.turnSequence) pendingAttack = null;
        if (pendingAttack?.roll && (pendingAttack.attackId !== attackId || pendingAttack.targetId !== targetId)) throw new Error('Retry the interrupted attack against its original target first.');
        if (pendingAttack?.roll && pendingAttack.ability !== undefined && (pendingAttack.ability !== ability || pendingAttack.attackOrigin !== attackOrigin)) throw new Error('Retry the interrupted attack with its original ability and attack type.');
        if (!pendingAttack || pendingAttack.attackId !== attackId || pendingAttack.targetId !== targetId) {
          const window = currentRecklessWindow;
          pendingAttack = { cacheKey: pendingAttackKey, resolutionId: typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `barbarian-${Date.now()}-${Math.random().toString(36).slice(2)}`, attackId, targetId, turnSequence: combatState.turnSequence, useReckless: window.active || window.ready || Boolean(recklessCombat), brutalStrike: usesBrutalStrike, ability, attackOrigin, hpBefore: target.currentHp, armorClass: target.armorClass };
        }
        pendingBarbarianAttack.current = pendingAttack;
        savePendingBarbarianAttack(pendingAttackKey, pendingAttack);
      }
      if (rays) { multiCastLockRef.current = true; setMultiCastRunning(true); }
      let result;
      try {
      result = await resolveAttack({
        attackerId: characterId, sourceType: form?.entityType === 'enemy' ? 'monster' : 'character', resolveDefenderReaction, defenderReactionRequired: Boolean(resolveDefenderReaction), ...(resolveFateWindow ? { resolveFateWindow } : {}), ...(resolveCuttingWords ? { resolveCuttingWords } : {}), targetId, attack, target: rays?.pending || pendingAttack ? { ...target, currentHp: (rays?.pending || pendingAttack).hpBefore ?? target.currentHp, armorClass: (rays?.pending || pendingAttack).armorClass ?? target.armorClass } : target,
        ...(opportunityId?{attackResolutionId:`attack:${opportunityId}`} : {}),
        ...(pendingAttack ? { attackResolutionId: pendingAttack.resolutionId } : {}),
        ...(rays ? { attackResolutionId: directSpellAttackResolutionId(rays, directDefinition), parentResolutionId: rays.multiattackStepId || rays.id } : {}),
        ...(monkPending ? {attackResolutionId:monkPending.resolutionId,target:{...target,currentHp:monkPending.hpBefore,armorClass:monkPending.armorClass}} : {}),
        combatState: attackCombatState,
        ...(directDefinition ? {
          validateTarget: () => {
            const distance = minimumFootprintDistanceFeet({ sourceToken: spatialContext?.tokens?.[characterId], targetToken: spatialContext?.tokens?.[targetId], sourceSize: ownCreatureSize(form, combatState, characterId), targetSize: target.size, map: spatialContext?.map });
            if (!['character', 'enemy', 'monster'].includes(target.entityType)) return { valid: false, reason: 'Choose a creature; object effects are managed by the DM.' };
            if (distance === null) return { valid: false, reason: 'Place both creatures on the map before casting.' };
            return { valid: distance <= directSpellRangeFeet(form, attack.spell, directDefinition), reason: `${directDefinition.name} has a range of ${directSpellRangeFeet(form, attack.spell, directDefinition)} feet.` };
          },
          calculateAppliedDamage: ({ rawDamage, damageType, target }) => applyDamageTypeTraits({ type: damageType, damage: rawDamage }, target, { combatState: attackCombatState, targetCombatantId: targetId, source: form }).finalDamage,
        } : {}),
        rollAttack: async (selected, targetRollMode) => {
          if (pendingAttack?.roll) return pendingAttack.roll;
          const roll = await cacheMonkRoll('attackRoll',()=>cachedOpportunityRoll(opportunityId,'attack',()=>selected.kind === 'weapon' || selected.kind === 'unarmed'
            ? handleWeaponAttackRoll(selected.slot, selected.weapon, recklessCombat ? { ...targetRollMode, combatState: recklessCombat } : targetRollMode)
            : rays ? cacheRayRoll('attackRoll', () => handleSpellAttackRoll(selected.spell, targetRollMode)) : handleSpellAttackRoll(selected.spell, targetRollMode)));
          if (pendingAttack && Number.isInteger(roll?.naturalRoll)) {
            pendingAttack = { ...pendingAttack, roll }; pendingBarbarianAttack.current = pendingAttack;
            savePendingBarbarianAttack(pendingAttackKey, pendingAttack);
          }
          return roll;
        },
        onAttackRollCommitted: recordsFirstAttack ? async entry => {
          const window = currentRecklessWindow;
          const saved = await commitRecklessAttack(String(characterId), { kind:'roll', id:entry.resolutionId, turnSequence:combatState.turnSequence,
            naturalRoll:entry.naturalRoll, authorizationId:rays?.id || entry.resolutionId, useReckless:pendingAttack?.useReckless ?? (window.active || window.ready) });
          if (recklessScope.current === `${campaignId}:${characterId}`) onCombatStateReconciled(saved.combat);
          if (pendingAttack && !recordsFrenzy) { if (pendingBarbarianAttack.current?.cacheKey === pendingAttackKey) pendingBarbarianAttack.current = null; savePendingBarbarianAttack(pendingAttackKey,null); }
        } : undefined,
        onAttackRollResolved: async entry => {
          await rageControlsRef.current?.recordAttack({ ...entry, authorizationId: rays?.id || entry.resolutionId });
          if (recordsFrenzy) {
            const saved = await claimBerserkerFrenzy(String(characterId), { id:entry.resolutionId, turnSequence:combatState.turnSequence, targetId, kind:attack.kind, ability, hit:entry.hit, naturalRoll:entry.naturalRoll });
            approvedFrenzy = saved.dice;
            if (recklessScope.current === `${campaignId}:${characterId}`) onCombatStateReconciled(saved.combat);
          }
        },
        suppressedAdvantageSources: usesBrutalStrike ? [FORGO_ALL_ADVANTAGE] : [],
        brutalStrike: usesBrutalStrike,
        ...attackFeatureIntegration,
        resolveFeatureDecision,
        // Boon of Combat Prowess: turn a miss into a hit, once per turn on your own turn.
        ...(campaignId && form?.entityType !== 'enemy' && canUsePeerlessAim(form, combatState, String(characterId)) ? { resolvePeerlessAim: async ({ resolutionId }) => {
          const choice = await resolveFeatureDecision(peerlessAimDecision(resolutionId));
          if (choice?.choiceId !== 'use') return false;
          const claim = await claimFeatureUsage({ campaignId, combatantId: String(characterId), featureId: PEERLESS_AIM_FEATURE_ID, turnSequence: combatState.turnSequence, resolutionId });
          if (claim.combat) onCombatStateReconciled(claim.combat);
          if (!['claimed', 'replayed'].includes(claim.status)) { notify('Peerless Aim is unavailable now.', 'warning'); return false; }
          return true;
        } } : {}),
        // Boon of Fate: 2d4 added to a missed attack roll, again after Initiative or a rest.
        ...(form?.entityType !== 'enemy' && canUseFate(form) ? { resolveFate: async ({ resolutionId }) => {
          const choice = await resolveFeatureDecision(fateDecision(resolutionId, 'attack roll'));
          if (choice?.choiceId !== 'use') return null;
          try { return await spendFateOnRoll({ characterId: String(form?._id || characterId), requestId: resolutionId, kind: 'attack', onCharacterChange }); }
          catch (error) { notify(error.message, 'warning'); return null; }
        } } : {}),
        // A held Bardic Inspiration die, added to a missed attack roll.
        ...(form?.entityType !== 'enemy' && heldBardicDie(form) ? { resolveBardicDie: async ({ resolutionId }) => {
          const choice = await resolveFeatureDecision(bardicDieDecision(resolutionId, 'attack roll', heldBardicDie(form)));
          if (choice?.choiceId !== 'use') return null;
          try { return await spendBardicDieOnRoll({ character: form, characterId: String(form?._id || characterId), requestId: `${resolutionId}:bardic-inspiration`, kind: 'attack', onCharacterChange }); }
          catch (error) { notify(error.message, 'warning'); return null; }
        } } : {}),
        // Peerless Skill (College of Lore 14): the Bard's die on a missed attack roll, spent only if it turns into a hit.
        ...(form?.entityType !== 'enemy' && canUsePeerlessSkill(form, charismaModifier) ? { resolvePeerlessSkill: async ({ resolutionId, total, armorClass }) => {
          const { sides } = getBardicInspirationProfile(form, charismaModifier);
          const choice = await resolveFeatureDecision(peerlessSkillDecision(resolutionId, sides));
          if (choice?.choiceId !== 'use') return null;
          try { return await spendPeerlessSkillOnRoll({ characterId: String(form?._id || characterId), requestId: resolutionId, kind: 'attack', sides, onCharacterChange, worked: async (rolled) => total + rolled >= armorClass }); }
          catch (error) { notify(error.message, 'warning'); return null; }
        } } : {}),
        // Stroke of Luck (Rogue 20): a missed attack roll becomes a 20, once per Short or Long Rest.
        ...(form?.entityType !== 'enemy' && canUseStrokeOfLuck(form) ? { resolveStrokeOfLuck: async ({ resolutionId }) => {
          const choice = await resolveFeatureDecision(strokeOfLuckDecision(resolutionId, 'attack roll', 'a Critical Hit'));
          if (choice?.choiceId !== 'use') return false;
          try {
            const claimed = await claimStrokeOfLuck(String(characterId), { requestId: resolutionId, kind: 'attack' });
            onCharacterChange?.(previous => withStrokeOfLuck(previous, claimed.strokeOfLuck));
            return true;
          } catch (error) { notify(error.message, 'warning'); return false; }
        } } : {}),
        // Heroic Inspiration: a missed attack roll can be rerolled; the server spends it, then the d20 is rolled again.
        ...(form?.entityType !== 'enemy' && hasHeroicInspiration(form) ? { resolveHeroicInspiration: async ({ resolutionId, naturalRoll, rollMode, dice }) => {
          const choice = await resolveFeatureDecision(heroicInspirationDecision(resolutionId, 'attack roll'));
          if (choice?.choiceId !== 'use') return null;
          try {
            const reroll = await rerollWithHeroicInspiration({ character: form, characterId: String(form?._id || characterId), requestId: resolutionId,
              kind: 'attack', rollMode, kept: naturalRoll, dice, onCharacterChange, prepareRoll: prepareReroll });
            notify(`Heroic Inspiration\nAttack roll: rerolled the d20 (${naturalRoll} → ${reroll.d20}).`, 'success');
            return { naturalRoll: reroll.d20 };
          } catch (error) { notify(error.message, 'warning'); return null; }
        } } : {}),
        claimFeatureUsage: async claim => {
          // Divine Smite's claim also spends its slot or free use and the Bonus Action on the server.
          // Giant Ancestry spends a species use (and applies Frost's Chill or Hill's Tumble) on the server.
          if (claim.featureId === GIANT_ANCESTRY_ID) {
            const giant = await claimGiantAncestry(String(form?._id || characterId), claim);
            if (giant.speciesResources) onCharacterChange?.((previous) => mergeSpeciesResources(previous, giant.speciesResources));
            if (giant.combat) onCombatStateReconciled(giant.combat);
            return giant;
          }
          const result = claim.featureId === DIVINE_SMITE_FEATURE_ID
            ? await claimDivineSmite({ ...claim, attackerId: claim.combatantId, kind: attack.kind === 'unarmed' ? 'unarmed' : 'weapon',
              ...(attack.kind === 'unarmed' ? {} : { weaponInstanceId: getWeaponInstanceId(attack.weapon, attack.slot) }) }, {
              onSpellSlotReconciled, onCharacterChange: spellcastingState => onCharacterChange?.(previous => ({ ...previous, spellcastingState })) })
            : await claimFeatureUsage(claim);
          // Reconcile the committed snapshot before the attack finishes; do not
          // depend on the socket broadcast arriving before the next attack.
          if (result.combat) onCombatStateReconciled(result.combat);
          return result;
        },
        rollDamage: async (selected, { critical, brutalStrike, damageComponents, inheritedDamageType, rollFeatureIds }) => cacheMonkRoll('damageRoll',()=>cachedOpportunityRoll(opportunityId,'damage',async()=>{
          if (selected.kind === 'weapon' || selected.kind === 'unarmed') {
            if (recordsFrenzy && pendingAttack?.damageRoll) return pendingAttack.damageRoll;
            const fullAbility = abilityForWeapon(selected.weapon, selected.slot);
            const lightAbility = selected.lightExtraAttack && selected.origin !== 'cleave-extra'
              ? lightDamageAbilityModifier(fullAbility, { twoWeaponFighting: hasFightingStyle(form, 'two-weapon-fighting') }) : null;
            const result = await rollDamageExpression({
              damageString: getDamageStringForHandSelection(selected.slot, selected.weapon),
              ability: selected.origin === 'cleave-extra'
                ? abilityDamageModifier(fullAbility, { policy: CLEAVE_DAMAGE_POLICY })
                : lightAbility ?? fullAbility,
              crit: critical,
              options: {
                ...(lightAbility !== null && lightAbility < fullAbility
                  ? { abilityNote: `Light extra attack: ${attackAbilityKeyForWeapon(selected.slot, selected.weapon) === 'spell' ? 'spellcasting ability' : String(attackAbilityKeyForWeapon(selected.slot, selected.weapon)).toUpperCase()} not added` } : {}),
                character: form,
                combatState,
                frenzyDice: approvedFrenzy,
                attack: {
                  weapon: selected.weapon, hands: getHandSelectionForWeapon(selected.slot, selected.weapon),
                  ability: attackAbilityKeyForWeapon(selected.slot, selected.weapon),
                  kind: selected.kind,
                  origin: selected.origin || attackOrigin,
                  isWeaponAttack: selected.kind === 'weapon',
                  isUnarmedStrike: selected.kind === 'unarmed',
                  dealsDamage: true,
                  hit: true,
                  isOwnTurn: isActiveTurn,
                  damageType: selected.damageType,
                },
                brutalStrike,
                savageAttacker: Boolean(rollFeatureIds?.includes(SAVAGE_ATTACKER_FEATURE_ID)),
              },
              damageComponents,
              inheritedDamageType,
            });
            if (recordsFrenzy && pendingAttack && result) {
              pendingAttack = { ...pendingAttack, damageRoll: result };
              pendingBarbarianAttack.current = pendingAttack;
              savePendingBarbarianAttack(pendingAttackKey,pendingAttack);
            }
            if (result) updateDamageValueWithAnimation(result.total, result.breakdown, selected.name, { diceRolls: result.diceRolls, log: false });
            return result;
          }
          const details = getSpellAttackDetails(selected.spell);
          // Riders roll on the same visible dice so the attack's log entry can show them.
          const roll = () => rollDamageExpression({ damageString: selected.damageText, ability: directDefinition ? 0 : details?.abilityBonus || 0, crit: critical, damageComponents, inheritedDamageType });
          const result = rays ? await cacheRayRoll('damageRoll', roll) : await roll();
          if (result) updateDamageValueWithAnimation(result.total, result.breakdown, selected.name, { diceRolls: result.diceRolls, log: false });
          return result;
})),
        applyDamage: payload=>onApplyTargetDamage({...payload,...(rays?.multiattack ? {multiattack:rays.multiattack} : {})}),
        writeLog: async (entry) => addLogEntries({ ...entry, targetName: combatantName(entry.targetId, target?.characterName || target?.name || target?.label || '') }),
        onDamageResolved,
        onAttackResolved: async entry=>{
          await onAttackResolved?.(entry);
          if(campaignId&&canOfferStunningStrike(form,combatState,String(characterId),attack,entry)){
            const choice=await resolveFeatureDecision(stunningStrikeDecision(entry.resolutionId));
            if(choice?.choiceId==='use'){
              const response=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/monk/stunning-strike`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({resolutionId:entry.resolutionId,attackerId:String(characterId),targetId,turnSequence:combatState.turnSequence,hit:true,naturalRoll:entry.naturalRoll,kind:attack.kind,weaponInstanceId:attack.weaponInstanceId})});
              const saved=await response.json();if(!response.ok)throw new Error(saved.message||'Stunning Strike could not be saved.');
              onCombatStateReconciled(saved.combat);onCharacterChange?.(old=>mergeMonkFocus(old,saved.focus));notify('Stunning Strike: waiting for the target’s Constitution save.','info');
            }
          }
          if(campaignId&&canOfferQuiveringPalm(form,attack,entry)){
            const choice=await resolveFeatureDecision(quiveringPalmDecision(entry.resolutionId));
            if(choice?.choiceId==='use'){
              const response=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/monk/quivering-palm`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({resolutionId:entry.resolutionId,attackerId:String(characterId),targetId,turnSequence:combatState.turnSequence})});
              const saved=await response.json();if(!response.ok)throw new Error(saved.message||'Quivering Palm could not be saved.');
              onCharacterChange?.(old=>{const merged=mergeMonkFocus(old,saved.focus);return merged?{...merged,classState:{...merged.classState,monk:{...merged.classState?.monk,quiveringPalm:saved.quiveringPalm}}}:merged;});
              notify(`Quivering Palm: vibrations start in ${saved.quiveringPalm.targetName}.`,'info');
            }
          }
          if(campaignId&&canOfferPunchAndGrab(form,combatState,String(characterId),attack,entry,attackOrigin)){
            const choice=await resolveFeatureDecision(punchAndGrabDecision(entry.resolutionId));
            if(choice?.choiceId==='use'){
              const response=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/unarmed`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:`${entry.resolutionId}:punch-and-grab`,actorId:String(characterId),targetId,option:'grapple',turnSequence:combatState.turnSequence,origin:'punch-and-grab',hitResolutionId:entry.resolutionId})});
              const saved=await response.json();if(!response.ok)throw new Error(saved.message||'Punch and Grab could not be saved.');
              onCombatStateReconciled(saved.combat);notify('Punch and Grab: waiting for the target’s Strength or Dexterity save.','info');
            }
          }
          if(campaignId&&canOfferOpenHand(form,attack,entry)){
            let selection=monkPending?.openHandChoice;
            if(!selection){
              const decision=await resolveFeatureDecision(openHandDecision(entry.resolutionId));
              selection=decision?.choiceId||'skip';
              if(monkPending){monkPending={...monkPending,openHandChoice:selection};pendingMonkAttack.current=monkPending;saveMonkAttack(monkCacheKey,monkPending);}
            }
            if(selection!=='skip'){
              const option=selection.startsWith('push-')?'push':selection;
              const response=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/monk/open-hand`,{
                method:'POST',headers:{'Content-Type':'application/json'},
                body:JSON.stringify({resolutionId:entry.resolutionId,attackerId:String(characterId),targetId,
                  turnSequence:combatState.turnSequence,hit:true,naturalRoll:entry.naturalRoll,option,
                  ...(option==='push'?{distanceFeet:Number(selection.split('-')[1])}:{})}),
              });
              const saved=await response.json();if(!response.ok){
                if(response.status>=400&&response.status<500&&monkPending){
                  monkPending={...monkPending,openHandChoice:null};pendingMonkAttack.current=monkPending;saveMonkAttack(monkCacheKey,monkPending);
                }
                throw new Error(saved.message||'Open Hand Technique could not be saved.');
              }
              onCombatStateReconciled(saved.combat);
              notify(option==='addle'?'Addle: target cannot make Opportunity Attacks until its next turn.':`Open Hand: waiting for the target’s ${option==='push'?'Strength':'Dexterity'} save.`,'info');
            }
          }
          if(campaignId&&Number.isInteger(combatState?.activeTurn)&&entry.outcome==='critical-hit'&&hasRemarkableAthlete(form))await championMovementRef.current?.claim({actorId:String(characterId),resolutionId:entry.resolutionId,authorizationId:rays?.id||entry.resolutionId,attackKind:attack.kind,naturalRoll:entry.naturalRoll,turnSequence:combatState.turnSequence});
        },
        commitVexAttackRoll: (payload) => consumeVexAttackRoll(campaignId, payload),
        applyVexOnHit: (payload) => createVexOnHit(campaignId, payload),
        commitStudiedAttackRoll: (payload) => consumeStudiedAttackRoll(campaignId, payload),
        applyStudiedOnMiss: (payload) => markStudiedOnMiss(campaignId, payload),
        applySlowOnHit: (payload) => createSlowOnHit(campaignId, payload),
        commitSapAttackRoll: (payload) => consumeSapAttackRoll(campaignId, payload),
        commitSteadyAimAttackRoll: async (payload) => {
          const consumed = await consumeSteadyAimAttack(campaignId, { combatantId: String(characterId), ...payload });
          if (consumed?.combat) onCombatStateReconciled(consumed.combat);
          return consumed;
        },
        applySapOnHit: (payload) => createSapOnHit(campaignId, payload),
        spatialContext,
        applyPushOnHit: async (payload) => {
          const applied = await applyPushOnHit(campaignId, payload);
          if (applied?.mapPayload) onMapReconciled(applied.mapPayload);
          return applied;
        },
        resolveTargetedSave: async (request) => {
          await prepareDiceRollSurface('Roll');
          const rolled = await rollSkillWithDiceBox(request.targetSaveModifier, {
            diceColor: diceFaceColor, rollMode: request.mode, rollContext: 'save',
            diceModifiers: getRollDiceModifiers(combatState, request.targetCombatantId, 'save'),
            character: target, source: `${String(request.ability).toUpperCase()} Save`,
          });
          const natural = rolled.keptD20 ?? rolled.d20;
          const resolved = { ...resolveTargetedSaveResult({ ...request, targetSaveModifier: request.targetSaveModifier + modifierDiceTotal(rolled.diceModifiers, rolled.modifierDice) }, natural),
            baseSaveModifier: request.targetSaveModifier, modifierDice: rolled.modifierDice };
          if (!campaignId) return resolved;
          const committed = await commitTargetedCombatSave(campaignId, {
            ...resolved, turnSequence: combatState?.turnSequence,
            failureCondition: 'condition:prone', sourceFeature: 'weapon-mastery:topple',
          });
          if (committed.combat) onCombatStateReconciled(committed.combat);
          return committed.save || resolved;
        },
        resolveCunningStrike: async ({ effect, parentResolutionId, attackerId, targetId: effectTargetId, target: effectTarget }) => {
          const definition = CUNNING_STRIKE_EFFECTS[effect.id];
          if (!definition) throw new Error('Unknown Cunning Strike effect.');
          const committed = await commitCunningStrikeResolution(campaignId, {
            parentResolutionId, attackerId, targetId: effectTargetId, effectId: definition.id,
            turnSequence: combatState?.turnSequence,
          });
          if (committed.combat) onCombatStateReconciled(committed.combat);
          const resolution = committed.resolution;
          const targetName = combatantName(effectTargetId, effectTarget?.name || effectTarget?.displayName || 'Target');
          if (committed.status === 'pending') notify(`Cunning Strike · ${definition.label}\nWaiting for ${targetName}'s save.`, 'info');
          if (resolution?.save) {
            const save = resolution.save;
            const outcome = save.success ? 'Succeeded' : 'Failed';
            const consequence = save.success ? '' : `\n${resolution.conditionImmune ? 'Immune to ' : ''}${CUNNING_STRIKE_FAILURE_TEXT[definition.id]}`;
            notify(`Cunning Strike · ${definition.label}\n${targetName}: ${save.ability.slice(0, 3).toUpperCase()} Save ${save.total} vs DC ${save.dc} — ${outcome}${consequence}`, save.success ? 'success' : 'danger');
          } else if (resolution?.stealthAttack) {
            notify('Cunning Strike · Stealth Attack\nYou stay Hidden if you end your turn behind Three-Quarters or Total Cover.', 'success');
          } else if (resolution?.movementGrant) {
            notify(`Cunning Strike · Withdraw\nMove up to ${resolution.movementGrant.maxDistance} ft now.\nThis movement does not provoke Opportunity Attacks.`, 'success');
          }
          return resolution;
        },
        actionEconomy,
        attackOrigin,
        parentResolutionId: rays?.id || parentResolutionId,
      });
      } catch (error) {
        if (rays) updateRay({ error: error.message });
        if (rays?.multiattackStepId) onSpellCastProgress({type:'error',multiattackStepId:rays.multiattackStepId,message:error.message});
        throw error;
      } finally { if (rays) { multiCastLockRef.current = false; setMultiCastRunning(false); } }
      if(monkPending){pendingMonkAttack.current=null;saveMonkAttack(monkCacheKey,null);}
      if (recordsFrenzy && pendingAttack) {
        if (pendingBarbarianAttack.current?.cacheKey === pendingAttackKey) pendingBarbarianAttack.current = null;
        savePendingBarbarianAttack(pendingAttackKey,null);
      }
      if(rays?.multiattack)await multiattackRequest(campaignId,rays.multiattack,'attack-result',{eventId:directSpellAttackResolutionId(rays,directDefinition),result:{outcome:result.outcome,damageApplied:result.damageApplied || 0}});
      if (rays) {
        const next = { ...multiCastRef.current, completed: rays.completed + 1, pending: null, error: null };
        if (next.completed < next.count) { saveMultiCast(next); selectMultiCastTarget(next); }
        else { saveMultiCast(null); notify(`${rays.name}: all ${next.count} attacks resolved.`, 'success'); }
      }
      // Ice Knife bursts, hit or miss: around the target, through the save damage flow, at no further cost.
      if (directDefinition?.burst && spatialContext?.tokens?.[targetId]) {
        const burst = getExecutableSaveDamageDefinitionForSpell(directDefinition.spellId);
        const intent = { spell: attack.spell, definition: burst, reuseLine: true, spellInstanceId: attack.spell.spellInstanceId, spellId: directDefinition.spellId, source: attack.spell.source, sourceCombatantId: String(characterId),
          actionType: 'save-damage', pool: 'none', castLevel: directChoices.castLevel || directDefinition.level, status: 'finalize-pending', combatRevision: combatState?.turnSequence, error: '' };
        saveDamageCastIntentRef.current = intent; setSaveDamageCast(intent);
        resolveSaveDamageCast(undefined, [String(targetId)], { mapId: spatialContext.map?.mapId, point: { x: spatialContext.tokens[targetId].x, y: spatialContext.tokens[targetId].y } })
          .catch((failure) => notify(failure.message, 'danger'));
      }
      // A Beast attack that knocks its target Prone (a Wolf's Bite). The attack stands if this fails.
      if (['hit', 'critical-hit'].includes(result.outcome) && attack.weapon?.proneLimit && campaignId && Number.isInteger(combatState?.turnSequence)) {
        try {
          const response = await apiFetch(`/characters/${encodeURIComponent(String(form?._id || characterId))}/druid/wild-shape/rider`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ resolutionId: result.resolutionId, attackName: attack.weapon.name, targetId: String(targetId), turnSequence: combatState.turnSequence }) });
          const rider = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(rider.message || 'The target could not be knocked Prone.');
          if (rider.combat) onCombatStateReconciled?.(rider.combat);
          if (rider.prone) notify(`${attack.weapon.name}: ${target?.name || 'the target'} is Prone.`, 'info');
        } catch (riderError) { notify(riderError.message, 'warning'); }
      }
      // Ensnaring Strike: the weapon hit brings on the save.
      if (['hit', 'critical-hit'].includes(result.outcome) && (attack.kind === 'weapon' || attack.kind === 'unarmed')) {
        const ensnare = (combatState?.activeEffects || []).find((effect) => effect?.definitionId === 'spell:ensnaring-strike' && !effect.parentEffectId && !effect.struck && String(effect.sourceCombatantId) === String(characterId));
        if (ensnare) {
          const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/buffs/hit-save`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: `hit-save:${ensnare.concentrationId}`, castId: ensnare.concentrationId, sourceCombatantId: String(characterId), targetCombatantId: String(targetId) }) });
          const saved = await response.json();
          if (response.ok) onCombatStateReconciled?.(saved.combat); else notify(saved.message || 'Ensnaring Strike’s save could not start.', 'danger');
        }
      }
      if (directDefinition?.rider && ['hit', 'critical-hit'].includes(result.outcome)) {
        await applyDirectSpellRider({ name: directDefinition.name, ...(rays?.multiattackStepId ? {multiattackStepId:rays.multiattackStepId} : {}), payload: { combatantId: characterId, turnSequence: combatState.turnSequence, resolutionId: result.resolutionId, spellInstanceId: attack.spell.spellInstanceId, targetId, ...directChoices,
          ...(directDefinition.rider === 'drain' ? { damageDealt: Math.round(Number(result.damageApplied) || 0) } : {}) } });
      }
      if (rays?.multiattackStepId && rays.completed + 1 >= rays.count && !(directDefinition?.rider && ['hit','critical-hit'].includes(result.outcome))) onSpellCastProgress({type:'complete',multiattackStepId:rays.multiattackStepId});
      const failure = result.featureResolution?.claimFailures?.[0];
      reconcileResolvedAttackDamage(result);
      if (result.targetedSave) {
        const saved = result.targetedSave.success === true;
        notify(formatToppleSaveNotification(result.targetedSave, combatantName(targetId, target?.name || target?.displayName || 'Target')), saved ? 'success' : 'danger');
      }
      if (result.slowApplied) notify(`${combatantName(targetId, target?.name || target?.displayName || 'Target')}'s Speed reduced by 10 ft.`, 'success');
      if (failure) {
        notify(failure.status === 'already-claimed'
          ? `${failure.featureLabel} has already been used this turn.`
          : failure.message ? `${failure.featureLabel} was not applied: ${failure.message}`
            : `${failure.featureLabel} could not be claimed; the feature was not applied.`, 'warning');
      }
      // Superior Hunter's Prey (Hunter 11): the mark's extra damage can also reach a second creature, once per turn.
      const preyTargets = superiorHuntersPreyTargets({ form, characterId, markedId: targetId, result, combatState, spatialContext });
      if (preyTargets.length) {
        const sides = huntersMarkDieSides(form);
        const choice = await resolveFeatureDecision(createSuperiorHuntersPreyDecision({ resolutionId: result.resolutionId, sides, targets: preyTargets }));
        const chosen = preyTargets.find(entry => entry.id === choice?.choiceId);
        if (chosen) {
          try {
            await prepareDiceRollSurface('Superior Hunter’s Prey');
            const rolled = await rollSharedDiceWithBox([{ count: 1, sides }]);
            const applied = await applySuperiorHuntersPrey(campaignId, { attackerId: String(characterId), markedId: String(targetId), targetId: chosen.id,
              resolutionId: result.resolutionId, turnSequence: combatState.turnSequence, dice: rolled?.rolls?.[0] });
            if (applied.combat) onCombatStateReconciled(applied.combat);
            notify(`Superior Hunter’s Prey: ${applied.amount} Force damage to ${chosen.name}.`, 'success');
          } catch (error) { notify(error.message, 'warning'); }
        }
      }
      const candidateIds = getCleaveCandidateIds({ attackerId: characterId, primaryTargetId: targetId, weapon: attack.weapon, combatState, spatialContext });
      if (attackOrigin !== 'cleave-extra' && qualifiesForCleave({
        attack: { ...attack, isMeleeAttack: isWeaponAttack && attack.attackMode === 'melee' },
        outcome: result.outcome, combatState, attackerId: characterId, candidateIds,
      })) {
        const choice = await resolveFeatureDecision(createCleaveDecision(result.resolutionId));
        if (choice?.choiceId === 'apply') {
          cleaving = true;
          onBeginTargeting({
            sourceCombatantId: characterId, actionType: 'cleave-extra', attackId: attack.id,
            attackOrigin: 'cleave-extra', allowedTargetIds: candidateIds,
            parentResolutionId: result.resolutionId, primaryTargetId: targetId,
            primaryOutcome: result.outcome,
            triggeringWeaponInstanceId: getWeaponInstanceId(attack.weapon, attack.slot),
          });
        }
      }
      // Hunter's Prey: Horde Breaker follows a weapon attack (hit or miss) once per turn. Read the ledger the
      // commit returned, which already lists this target as attacked.
      if (!cleaving && attackOrigin !== 'horde-breaker' && attack.kind === 'weapon') {
        const afterAttack = committedLedger ? { ...combatState, turnActionLedger: committedLedger } : combatState;
        const isMeleeAttack = attack.attackMode === 'melee';
        const hordeCandidateIds = getHordeBreakerCandidateIds({ attackerId: characterId, primaryTargetId: targetId, weapon: attack.weapon, isMeleeAttack, combatState: afterAttack, spatialContext });
        if (qualifiesForHordeBreaker({ character: form, attack, outcome: result.outcome, combatState: afterAttack, attackerId: characterId, candidateIds: hordeCandidateIds })) {
          const choice = await resolveFeatureDecision(createHordeBreakerDecision(result.resolutionId));
          if (choice?.choiceId === 'apply') onBeginTargeting({
            sourceCombatantId: characterId, actionType: 'horde-breaker', attackId: String(attack.id).replace(/:light-extra$/, ''),
            attackOrigin: 'horde-breaker', allowedTargetIds: hordeCandidateIds,
            parentResolutionId: result.resolutionId, primaryTargetId: targetId,
            triggeringWeaponInstanceId: getWeaponInstanceId(attack.weapon, attack.slot),
          });
        }
      }
      return result;
      } finally {if(attackOrigin==='monk'){monkAttackLock.current=false;setMonkAttackRunning(monkAttackCacheKey(campaignId,characterId),false);}}
  }, [availableSlots, onSpellCastProgress, unarmedOptionsDecision, chooseSpellDamageType, spellCastBlockReason, saveMultiCast, selectMultiCastTarget, applyDirectSpellRider, onSpellSlotReconciled, abilityForWeapon, attackArsenalItems, campaignId, characterId, combatState, form, attackAbilityKeyForWeapon, getDamageStringForHandSelection, getSpellAttackDetails, handleSpellAttackRoll, isActiveTurn, isFinesseWeapon, isMeleeWeapon, isRangedWeapon, onActionEconomyReconciled, onApplyTargetDamage, onAttackResolved, onCharacterChange, onCombatStateReconciled, onDamageResolved, onMapReconciled, reconcileResolvedAttackDamage, resolveFeatureDecision, resolveDefenderReaction, rollDamageExpression, spatialContext, onBeginTargeting, onCancelTargeting]);
  useImperativeHandle(ref, () => ({
    // A Reaction prompt's dice, thrown on this sheet's dice surface.
    rollReactionDice: async (label, count, sides) => { await prepareDiceRollSurface(label); const result = await rollSharedDiceWithBox([{ count, sides }]); return result?.rolls?.[0]; },
    showReactionDamage: (amount, detail, label) => updateDamageValueWithAnimation(amount, detail, label, { log: false }),
    // A lasting spell's next attack, for a monster's menu.
    startLastingAttack: (spellId) => {
      const item = attackArsenalItems.find((entry) => entry.directDefinition?.spellLevel && entry.spell?.spellId === spellId);
      if (item) void runAttackRoll(item); else notify('That spell has ended.', 'warning');
    },
    startSpell: (instanceId, nativeCast = null) => {
      if (spellCastBlockReason) throw new Error(spellCastBlockReason);
      const item=attackArsenalItems.find(candidate=>candidate.spell?.spellInstanceId===instanceId);
      if(!item) throw new Error('This spell is not in the current caster’s spell list.');
      if(item.buffDefinition) buffControlsRef.current?.start(item);
      else if(item.healingDefinition) healingControlsRef.current?.start(item);
      else if(isCastAccess(item.spell)) {
        beginSaveDamageCast(item.spell, nativeCast);
        const restored=saveDamageCastIntentRef.current;
        if(nativeCast && (restored?.prepared || restored?.placement)) void resolveSaveDamageCast(restored.targetId,restored.targetIds,restored.placement)
          .catch(error=>onSaveDamageStateChanged({type:'error',multiattackStepId:nativeCast.stepId,message:error.message}));
      }
      else if(item.directDefinition && nativeCast?.resume?.riderPending) void applyDirectSpellRider({name:item.directDefinition.name,multiattackStepId:nativeCast.stepId,payload:{combatantId:characterId,turnSequence:combatState.turnSequence,resolutionId:nativeCast.resolutionId,spellInstanceId:instanceId,targetId:nativeCast.resume.targetId,castLevel:nativeCast.castLevel,pool:nativeCast.pool,multiattack:nativeCast.multiattack}});
      else if(item.directDefinition && nativeCast) beginMultiCast(item,{castLevel:nativeCast.castLevel,pool:nativeCast.pool,...(nativeCast.multiattack ? {multiattack:nativeCast.multiattack} : {})},nativeCast);
      else if(item.directDefinition) runAttackRoll(item);
      else throw new Error('This spell does not have an executable casting flow.');
    },
    getAttackContext: (attackId) => {
      const selected = attackArsenalItems.find((candidate) => candidate.id === attackId);
      if (!selected) return null;
      return {
        attack: { ...selected, attackAbility: selected.kind === 'weapon' || selected.kind === 'unarmed' ? attackAbilityKeyForWeapon(selected.slot, selected.weapon) : '' },
        ability: selected.kind === 'weapon' || selected.kind === 'unarmed' ? attackAbilityKeyForWeapon(selected.slot, selected.weapon) : '',
      };
    },
    updateDamageValueWithAnimation,
    openAttackModal: handleShowAttack,
    usePotion: request => potionControlsRef.current?.usePotion(request),
    openDiceRoller: handleShowDiceRoller,
    openDamageLog: () => setShowLog(true),
    toggleCritical: handleDamageClick,
    setCritical: setCriticalState,
    clearDamageDice,
    resolveTargetedPotion: request => potionControlsRef.current?.chooseRecipient(request),
    resolveTargetedBuff: request => buffControlsRef.current?.chooseTarget(request),
    resolveBuffArea: request => buffControlsRef.current?.chooseArea(request),
    resolveTargetedHealing: request => healingControlsRef.current?.chooseTarget(request),
    resolveTargetedLayOnHands: request => layOnHandsRef.current?.chooseTarget(request),
    resolveHealingArea: request => healingControlsRef.current?.chooseArea(request),
    cancelMultiattackCast: (stepId, force = false) => {
      if(!stepId)return;
      const cast=multiCastRef.current;
      if(cast?.multiattackStepId===stepId && (force || (!cast.spellAttack && !cast.pending)))saveMultiCast(null);
      const save=saveDamageCastIntentRef.current;
      if(save?.multiattackStepId===stepId && (force || ['targeting','choosing-level'].includes(save.status))){
        saveDamageCastIntentRef.current=null;setSaveDamageCast(null);if(enemySaveRecoveryKey)sessionStorage.removeItem(enemySaveRecoveryKey);
      }
      if(force){setPendingSpellRider(pending=>pending?.multiattackStepId===stepId ? null : pending);try{const saved=JSON.parse(sessionStorage.getItem(spellRiderRetryKey));if(saved?.multiattackStepId===stepId)sessionStorage.removeItem(spellRiderRetryKey);}catch{}}
    },
    cancelPendingTargeting: () => {
      potionControlsRef.current?.cancelTargeting();
      healingControlsRef.current?.cancel();
      layOnHandsRef.current?.cancelTargeting();
      buffControlsRef.current?.cancel();
      if (saveDamageCastIntentRef.current?.status === 'targeting') saveDamageCastIntentRef.current = null;
      setSaveDamageCast((pending) => pending?.status === 'targeting' ? null : pending);
    },
    resolveTargetedSaveDamage: async ({ targetId, target, targetIds, placement }) => {
      const range = saveDamageCastIntentRef.current?.definition?.targeting?.rangeFeet;
      if (range && saveDamageCastIntentRef.current?.definition?.targeting?.shape === 'single') {
        const distance = minimumFootprintDistanceFeet({ sourceToken: spatialContext?.tokens?.[characterId], targetToken: spatialContext?.tokens?.[targetId], sourceSize: ownCreatureSize(form, combatState, characterId), targetSize: target?.size, map: spatialContext?.map });
        if (distance === null || distance > range) throw new Error(`Choose a creature on the map within ${range} feet.`);
      }
      if (!targetId && !targetIds?.length && !saveDamageCastIntentRef.current?.definition.targeting.allowEmpty) throw new Error('Select a living affected creature.');
      // Chain Lightning: the first target, then the caster picks who the bolts leap to.
      const chain = saveDamageCastIntentRef.current?.definition?.targeting;
      if (chain?.chainFeet && targetId) {
        const entities = spatialContext?.entities || {}, tokens = spatialContext?.tokens || {};
        const options = Object.keys(tokens).filter(id => id !== String(targetId) && id !== String(characterId) && !(Number(entities[id]?.currentHp) <= 0)).map(id => ({ id, name: entities[id]?.label || entities[id]?.name || id,
          feet: minimumFootprintDistanceFeet({ sourceToken: tokens[targetId], targetToken: tokens[id], sourceSize: target?.size, targetSize: entities[id]?.size, map: spatialContext?.map }) })).filter(entry => entry.feet !== null && entry.feet <= chain.chainFeet);
        const limit = chain.chainTargets + Math.max(0, Number(saveDamageCastIntentRef.current.castLevel) - Number(saveDamageCastIntentRef.current.definition.level));
        const chosen = options.length ? await new Promise((resolve) => setChainPrompt({ name: saveDamageCastIntentRef.current.definition.name, options, limit, picked: [], resolve })) : [];
        setChainPrompt(null);
        if (chosen.length) { await resolveSaveDamageCast(undefined, [String(targetId), ...chosen]); return; }
      }
      await askEvokerCastOptions(targetIds);
      await resolveSaveDamageCast(targetId, targetIds, placement);
    },
    resolveTargetedAttack,
    getTargetingPreview,
  }), [askEvokerCastOptions, onSaveDamageStateChanged, enemySaveRecoveryKey, spellRiderRetryKey, beginMultiCast, onSpellCastProgress, spellCastBlockReason, resolveTargetedAttack, getTargetingPreview, saveMultiCast, selectMultiCastTarget, applyDirectSpellRider, onSpellSlotReconciled, abilityForWeapon, attackArsenalItems, campaignId, characterId, combatState, form, attackAbilityKeyForWeapon, getDamageStringForHandSelection, getSpellAttackDetails, handleShowAttack, isActiveTurn, isFinesseWeapon, isMeleeWeapon, isRangedWeapon, onActionEconomyReconciled, onApplyTargetDamage, onAttackResolved, onCharacterChange, onCombatStateReconciled, onDamageResolved, onMapReconciled, reconcileResolvedAttackDamage, resolveFeatureDecision, resolveDefenderReaction, beginSaveDamageCast, runAttackRoll, resolveSaveDamageCast, rollDamageExpression, spatialContext]);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <OpportunityAttackPrompt campaignId={campaignId} combatState={combatState} controlledIds={form?.entityType==='enemy'?[]:[String(characterId)]} onCombatChange={onCombatStateReconciled}
        attackOptions={attackArsenalItems.filter(a=>a.kind==='unarmed'||a.kind==='weapon'&&isMeleeWeapon(a.weapon))}
        onAttack={async(opportunity,selected)=>{
          const target={...opportunity.target,armorClass:resolveCombatantArmorClass(opportunity.target,{combatState,targetCombatantId:opportunity.targetCombatantId})};
          if(target.armorClass===null)throw new Error('Target Armor Class is unavailable.');
          await resolveTargetedAttack({attackId:selected.id,targetId:opportunity.targetCombatantId,target,attackOrigin:'opportunity',opportunityId:opportunity.opportunityId});
        }}/>
      <BuffSpellControls onCharacterChange={onCharacterChange} ref={buffControlsRef} campaignId={campaignId} characterId={characterId}
        availableSlots={availableSlots} isActiveTurn={isActiveTurn} combatState={combatState} spatialContext={spatialContext} form={form}
        onBeginTargeting={onBeginTargeting} onCancelTargeting={onCancelTargeting} onSpellSlotReconciled={onSpellSlotReconciled}
        onActionEconomyReconciled={onActionEconomyReconciled} onCombatStateReconciled={onCombatStateReconciled} onPendingChange={setBuffPending} resolveCastWindow={resolveCastWindow} />
      <HuntersMarkMovePrompt campaignId={campaignId} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} spatialContext={spatialContext}
        hidden={buffPending} onMove={dropped => buffControlsRef.current?.startMove({ castId: dropped.castId, previousTargetIds: dropped.targetIds })}
        onCombatStateReconciled={onCombatStateReconciled} />
      <HuntersMarkMovePrompt effectId="spell:hex" spellName="Hex" campaignId={campaignId} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} spatialContext={spatialContext}
        hidden={buffPending} onMove={dropped => buffControlsRef.current?.startMove({ spellId: 'hex', castId: dropped.castId, previousTargetIds: dropped.targetIds })}
        onCombatStateReconciled={onCombatStateReconciled} />
      <HealingSpellControls ref={healingControlsRef} campaignId={campaignId} characterId={characterId} onCharacterChange={onCharacterChange}
        availableSlots={availableSlots} isActiveTurn={isActiveTurn} combatState={combatState} spatialContext={spatialContext} form={form}
        onBeginTargeting={onBeginTargeting} onCancelTargeting={onCancelTargeting}
        onSpellSlotReconciled={onSpellSlotReconciled} onActionEconomyReconciled={onActionEconomyReconciled}
        rollHealing={async ({ count, sides }) => { await prepareDiceRollSurface('Healing'); const result = await rollDiceWithHeroicReroll('healing', 'healing')([{ count, sides }]); return result?.rolls?.[0]; }}
        onCompleted={record => { if (healingLoggedRef.current.has(record.id)) return; healingLoggedRef.current.add(record.id);
          addLogEntries({ type: 'spell-healing', source: record.name, rolledTotal: record.total,
            formula: describeHealing({ dice: record.roll, sides: record.dice?.sides, modifier: record.modifier }),
            recipients: record.results.map(result => ({ targetName: result.name, healingBlocked: result.healingBlocked, total: result.healed, hpBefore: result.previousHp, hpAfter: result.currentHp })) }); }} />
      {(() => {
        // One entry from the spell and weapon list, run by its engine: shared by the quick tiles and the always-prepared tiles.
        const castArsenalItem = (item) => {
          if (item.spell && spellCastBlockReason) { notify(spellCastBlockReason, 'warning'); return; }
          if (item.manualCast) { makeRecent(item.id); castManualSpell(item); return; }
          if (item.buffDefinition || item.healingDefinition) {
            makeRecent(item.id);
            setShowAttack(false);
            const controls = item.buffDefinition ? buffControlsRef : healingControlsRef;
            controls.current?.start(item);
            return;
          }
          if (item.canAttackRoll) runAttackRoll(item);
          else runDamageRoll(item);
        };
        const controls = <><ChampionMovementTrigger ref={championMovementRef} campaignId={campaignId} characterId={characterId} combatState={combatState} onCombatChange={onCombatStateReconciled}/>{(featureActionTarget || renderStandaloneFeatureActions) && <><UncannyMetabolismPrompt form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><PersistentRagePrompt form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><HeroicInitiativePrompt form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><RelentlessRagePrompt form={form} characterId={characterId} diceColor={diceFaceColor} onCharacterChange={onCharacterChange}/>
{quiveringPalm && <><button type="button" data-action-tile="monk:quivering-palm" className="combat-hud-resource-tile combat-hud-feature-action-tile" style={{'--hud-resource-accent':'#b47cff'}}
  title={`Quivering Palm · ${quiveringPalm.targetName} · Constitution save, 10d12 Force (half on a success) · uses one attack of your Attack action`}
  aria-label={`Quivering Palm: end the vibrations in ${quiveringPalm.targetName}`} disabled={!campaignId||!isActiveTurn||Boolean(saveDamageCast)} onClick={triggerQuiveringPalm}>
  <span className="combat-hud-resource-tile__icon" aria-hidden="true"><Activity size={20}/></span><span className="combat-hud-resource-tile__name">Quivering Palm</span>
</button><button type="button" data-action-tile="monk:quivering-palm-end" className="combat-hud-resource-tile combat-hud-feature-action-tile" style={{'--hud-resource-accent':'#8a7aa8'}}
  title={`End the vibrations in ${quiveringPalm.targetName} harmlessly (no action)`} aria-label="End Quivering Palm harmlessly" onClick={endQuiveringPalmHarmlessly}>
  <span className="combat-hud-resource-tile__icon" aria-hidden="true"><Activity size={20}/></span><span className="combat-hud-resource-tile__name">End Palm</span>
</button></>}<MonkActionControls form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} combatants={combatants} isActiveTurn={isActiveTurn} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled} onClearInterrupted={()=>{pendingMonkAttack.current=null;}} onStrike={async grant=>{
          const stored=readMonkAttack(monkAttackCacheKey(campaignId,characterId),combatState?.turnSequence);
          const choice=stored?{choiceId:'damage'}:await unarmedOptionsDecision(attackArsenalItems.find(item=>item.kind==='unarmed'));
          if(!choice||choice.choiceId==='skip')return;
          const strike=attackArsenalItems.find(item=>item.kind==='unarmed');
          if(strike)onBeginTargeting({sourceCombatantId:String(characterId),actionType:'attack',attackId:choice.choiceId==='damage'?strike.id:`${strike.id}::${choice.choiceId}`,attackOrigin:'monk',monkGrantId:grant.id});
        }}/><RageControls ref={rageControlsRef} form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} isActiveTurn={isActiveTurn} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><IntimidatingPresenceControls form={form} characterId={characterId} combatState={combatState} spatialContext={spatialContext} isActiveTurn={isActiveTurn} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><GeneralMovementActions campaignId={campaignId} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} onActionEconomyReconciled={onActionEconomyReconciled} onCombatStateReconciled={onCombatStateReconciled} standalone={!featureActionTarget} />{cunningActionTiles}<TacticalMindControls form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} onCharacterChange={onCharacterChange}/><ActionSurgeControls form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} isActiveTurn={isActiveTurn} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><FavoredEnemyControls form={form} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} blockReason={spellCastBlockReason}
        onCast={() => { if (favoredEnemySpell) buffControlsRef.current?.start({ spell: favoredEnemySpell, freeCast: true }); }}/><ActiveSpellTiles campaignId={campaignId} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} blockReason={spellCastBlockReason}
        onAttack={(spellId) => { const item = attackArsenalItems.find((entry) => entry.directDefinition?.spellLevel && entry.spell?.spellId === spellId); if (item) void runAttackRoll(item); }}
        onRetarget={castId => buffControlsRef.current?.startRetarget({ castId, spellId: 'eyebite' })}
        onBeam={() => { const spell = sortedSpells.find((entry) => entry?.spellId === 'sunbeam'); if (spell) beginSaveDamageCast(spell, null, true); }} onBead={explodeBead} onBreathe={breathe} onCombatStateReconciled={onCombatStateReconciled}/><ClassCantripControls form={form} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} blockReason={spellCastBlockReason}
        onCast={({ grantId }, { name, bonusAction, mode }) => {
          // Spell attacks, save damage and buffs use their engines through the spell-list entry; other cantrips are a plain cast.
          const item = attackArsenalItems.find((entry) => entry.spell?.featureGrantId === grantId && (entry.spell?.castMode === 'attack') === (mode === 'attack'));
          if (item?.buffDefinition) { buffControlsRef.current?.start(item); return; }
          if (item?.canAttackRoll) { runAttackRoll(item); return; }
          if (item?.authoritative) { runDamageRoll(item); return; }
          Promise.resolve(onCastSpell?.({ featureGrantId: grantId, level: 0, name, castingTime: bonusAction ? '1 bonus action' : '1 action' })).catch(() => { /* The sheet reports the error. */ });
        }}/><FiendishLegacySpellControls form={form} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} blockReason={spellCastBlockReason}
        onCast={({ grantId, level }, { name, castingTime }) => Promise.resolve(onCastSpell?.({ featureGrantId: grantId, mode: 'feature', baseLevel: level, level, name, castingTime })).catch(() => { /* The sheet reports the error. */ })}/><MagicInitiateSpellControls form={form} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} blockReason={spellCastBlockReason}
        onCast={({ grantId }, { name, castingTime }) => {
          // Buffs and healing use their engine's free cast; other level 1 spells commit the free use and their effect is narrated.
          const item = attackArsenalItems.find((entry) => entry.spell?.featureGrantId === grantId && (entry.buffDefinition || entry.healingDefinition));
          if (item?.healingDefinition) { healingControlsRef.current?.start({ ...item, freeCast: true }); return; }
          if (item) { buffControlsRef.current?.start({ ...item, freeCast: true }); return; }
          Promise.resolve(onCastSpell?.({ featureGrantId: grantId, mode: 'feature', baseLevel: 1, level: 1, name, castingTime })).catch(() => { /* The sheet reports the error. */ });
        }}/><SecondWindControls form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} isActiveTurn={isActiveTurn}
        rollHealing={async dice => { await prepareDiceRollSurface('Second Wind'); const result = await rollDiceWithHeroicReroll('healing', 'Second Wind')([dice]); return result?.rolls?.[0]; }}
        onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><WholenessOfBodyControls form={form} characterId={characterId} campaignId={campaignId}
        combatState={combatState} isActiveTurn={isActiveTurn} wisdomModifier={Number.isFinite(Number(wisMod)) && wisMod !== null ? Number(wisMod) : Math.floor(((Number(form?.wis) || 10) - 10) / 2)}
        rollHealing={async dice => { await prepareDiceRollSurface('Wholeness of Body'); const result = await rollDiceWithHeroicReroll('healing', 'Wholeness of Body')([dice]); return result?.rolls?.[0]; }}
        onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><RangerActionControls form={form} characterId={characterId} campaignId={campaignId}
        combatState={combatState} isActiveTurn={isActiveTurn} wisdomModifier={Number.isFinite(Number(wisMod)) && wisMod !== null ? Number(wisMod) : Math.floor(((Number(form?.wis) || 10) - 10) / 2)}
        rollDie={async dice => { await prepareDiceRollSurface('Tireless'); const result = await rollDiceWithHeroicReroll('healing', 'Tireless')([dice]); return result?.rolls?.[0]; }}
        onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><RangerPassiveTiles form={form} characterId={characterId} combatState={combatState}/><SpeciesActionControls form={form} characterId={characterId} combatState={combatState}
        isActiveTurn={isActiveTurn} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}
        onBreathWeapon={breathWeaponDetails ? beginBreathWeapon : null} onCloudsJaunt={beginCloudsJaunt}/><LayOnHandsControls ref={layOnHandsRef} form={form} characterId={characterId} campaignId={campaignId}
        combatState={combatState} isActiveTurn={isActiveTurn} spatialContext={spatialContext} onBeginTargeting={onBeginTargeting} onCancelTargeting={onCancelTargeting}
        onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}
        onCompleted={result => { if (!result.healed) return;
          updateDamageValueWithAnimation(result.healed, `${result.pointsSpent} points spent · ${result.healed} HP restored`, result.targetCombatantId !== result.characterId ? `Lay On Hands → ${result.targetName}` : 'Lay On Hands', { log: false });
          addLogEntries({ type: 'spell-healing', source: 'Lay On Hands', note: `${result.pointsSpent} points spent from the pool`,
            recipients: [{ targetName: result.targetName, total: result.healed, hpBefore: result.previousHp, hpAfter: result.currentHp }] }); }}/><BardicInspirationControls form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} isActiveTurn={isActiveTurn}
        charismaModifier={charismaModifier} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><ClericChannelDivinityControls form={form} characterId={characterId} campaignId={campaignId} combatState={combatState} spatialContext={spatialContext} isActiveTurn={isActiveTurn}
        wisdomModifier={Number.isFinite(Number(wisMod)) && wisMod !== null ? Number(wisMod) : Math.floor(((Number(form?.wis) || 10) - 10) / 2)} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><DivineInterventionControls form={form}
        characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} blockReason={spellCastBlockReason} catalog={spellsCatalog} onCast={({ spellId, name, level, grantId }) => {
          // Healing and buff spells run their own cast, free through the grant; any other spell spends the use and is resolved at the table.
          const spell = { spellId, name, level, featureGrantId: grantId, spellInstanceId: `class-feature:${grantId}`, castResource: 'action', source: { sourceType: 'class-feature', sourceId: grantId, classId: 'cleric' } };
          if (getHealingSpellDefinition(spellId)) { healingControlsRef.current?.start({ spell, freeCast: true }); return; }
          if (getBuffSpellDefinition(spellId)) { buffControlsRef.current?.start({ spell, freeCast: true }); return; }
          Promise.resolve(onCastSpell?.({ featureGrantId: grantId, mode: 'feature', baseLevel: level, level, name, castingTime: '1 action' })).catch(() => { /* The sheet reports the error. */ });
        }}/><AlwaysPreparedSpellControls form={form} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} blockReason={spellCastBlockReason} catalog={spellsCatalog}
        onCast={({ spellId, name, level, grantId, castingTime, free }) => {
          // Spell Mastery, Signature Spells and Natural Recovery cast free through their grant, at their lowest level.
          if (free) {
            const spell = { spellId, name, level, featureGrantId: grantId, spellInstanceId: `class-feature:${grantId}`, source: { sourceType: 'class-feature', sourceId: grantId, classId: String(grantId).startsWith('druid-') ? 'druid' : 'wizard' } };
            if (getHealingSpellDefinition(spellId)) { healingControlsRef.current?.start({ spell, freeCast: true }); return; }
            if (getBuffSpellDefinition(spellId)) { buffControlsRef.current?.start({ spell, freeCast: true }); return; }
            // A free lingering area (Natural Recovery's Web) has no free path on the server yet; it is resolved at the table.
            if (isCastAccess(spell) && !isPersistentAreaAccess(spell)) { beginSaveDamageCast(spell, null, false, true); return; }
            Promise.resolve(onCastSpell?.({ featureGrantId: grantId, mode: 'feature', baseLevel: level, level, name, castingTime })).catch(() => { /* The sheet reports the error. */ });
            return;
          }
          // The spell's own entry in the spell list runs its engine (save damage, an attack roll, a buff or healing), the
          // grant's entry first. Spells with no engine spend a slot and are resolved at the table.
          const item = attackArsenalItems.find((entry) => entry.spell?.spellId === spellId && entry.spell?.featureGrantId === grantId)
            || attackArsenalItems.find((entry) => entry.spell?.spellId === spellId && !entry.manualCast);
          if (item && !item.manualCast) { castArsenalItem(item); return; }
          castManualSpell({ name, spell: { spellId, name, level, castingTime, featureGrantId: grantId } });
        }}/><BardPassiveTiles form={form} characterId={characterId} combatState={combatState} proficiencyBonus={profBonus}/><WildShapeControls form={form} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><LandsAidControls form={form} characterId={characterId} combatState={combatState} spatialContext={spatialContext} isActiveTurn={isActiveTurn} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><NaturesSanctuaryTile form={form} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} onPlace={beginNaturesSanctuary}/><DruidPassiveTiles form={form} characterId={characterId} combatState={combatState}/><CuttingWordsTile form={form} characterId={characterId} charismaModifier={charismaModifier} onCharacterChange={onCharacterChange}/><ClericPassiveTiles form={form} characterId={characterId} combatState={combatState}/><WizardPassiveTiles form={form} characterId={characterId} combatState={combatState}/>{sculptPrompt && <SculptSpellsPrompt spellName={sculptPrompt.spellName} limit={sculptPrompt.limit} creatures={sculptPrompt.creatures} onDone={sculptPrompt.resolve}/>}<ChannelDivinityControls form={form} characterId={characterId} campaignId={campaignId}
        combatState={combatState} spatialContext={spatialContext} isActiveTurn={isActiveTurn} charismaModifier={charismaModifier} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}
        heldMeleeWeapons={equippedWeapons.filter(({ slot, weapon }) => ['mainHand', 'offHand'].includes(slot) && !isUnarmedAttack(weapon) && isMeleeWeapon(weapon))
          .map(({ slot, weapon }) => ({ id: getWeaponInstanceId(weapon, slot), name: getWeaponDisplayName(slot, weapon) }))}/><HolyNimbusControls form={form}
        characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}/><PaladinPassiveTiles form={form}
        characterId={characterId} combatState={combatState}/><FighterPassiveTiles form={form} characterId={characterId} combatState={combatState}/><RoguePassiveTiles form={form} characterId={characterId} combatState={combatState} resolveFeatureDecision={resolveFeatureDecision}
        rollDie={async sides => { await prepareDiceRollSurface('Use Magic Device'); const result = await rollSharedDiceWithBox([{ count: 1, sides }]); return result?.rolls?.[0]?.[0]; }}/><MonkPassiveTiles form={form} characterId={characterId} combatState={combatState} campaignId={campaignId} isActiveTurn={isActiveTurn}
        resolveFeatureDecision={resolveFeatureDecision} onCombatStateReconciled={onCombatStateReconciled}/><EpicBoonTiles form={form} characterId={characterId} combatState={combatState} isActiveTurn={isActiveTurn} onBlinkSteps={beginBlinkSteps} onCombatStateReconciled={onCombatStateReconciled}/><FaithfulSteedControls form={form} characterId={characterId}
        combatState={combatState} isActiveTurn={isActiveTurn} blockReason={spellCastBlockReason}
        onCast={() => Promise.resolve(onCastSpell?.({ featureGrantId: FAITHFUL_STEED_GRANT_ID, mode: 'feature', baseLevel: 2, level: 2, name: 'Find Steed', castingTime: '1 action' }))
          .catch(() => { /* The sheet reports the error. */ })}/><FastHandsControls campaignId={campaignId} form={form} characterId={characterId} combatState={combatState} onCombatChange={onCombatStateReconciled} onCharacterChange={onCharacterChange} /></>}<PotionControls ref={potionControlsRef} characterId={characterId} campaignId={campaignId} form={form}
          onBeginTargeting={onBeginTargeting} onCancelTargeting={onCancelTargeting} spatialContext={spatialContext} pinnedKeys={featureActionTarget || renderStandaloneFeatureActions ? quickPotionKeys : []} combatState={combatState} isActiveTurn={isActiveTurn} onCharacterChange={onCharacterChange} onCombatStateReconciled={onCombatStateReconciled}
          rollHealing={async dice => { await prepareDiceRollSurface('Healing'); const result = await rollDiceWithHeroicReroll('healing', 'healing')([dice]); return result?.rolls?.[0]; }}
          onCompleted={result => { if (result.invisible) return;
            updateDamageValueWithAnimation(result.actualHealing, result.healingBlocked ? 'Healing blocked by Chill Touch' : `${result.rolledHealing} rolled · ${result.actualHealing} HP restored`, result.sourceCombatantId !== result.targetCombatantId && result.targetName ? `${result.name} → ${result.targetName}` : result.name, { log: false });
            addLogEntries({ type: 'spell-healing', source: result.name, rolledTotal: result.rolledHealing,
              formula: describeHealing({ dice: result.healingDice, sides: result.healingSides, rolledTotal: result.rolledHealing }),
              recipients: [{ targetName: result.targetName || form.characterName || form.name || 'Self', total: result.actualHealing, hpBefore: result.previousHp, hpAfter: result.currentHp, healingBlocked: result.healingBlocked }] }); }}/></>;
        const shortcuts = (featureActionTarget || renderStandaloneFeatureActions) && <QuickAttackControls items={attackArsenalItems} pinnedIds={visibleAttackIds} activeSpellCast={multiCast} spellCastBusy={multiCastRunning} combatState={combatState} characterId={characterId} isActiveTurn={isActiveTurn}
          spellCastBlockReason={spellCastBlockReason} onUse={castArsenalItem} />;
        const content = <>{controls}{shortcuts}</>;
        return featureActionTarget ? createPortal(content, featureActionTarget) : content;
      })()}
      <Modal centered show={showHideConfirmation} onHide={() => setShowHideConfirmation(false)}>
        <Modal.Header closeButton><Modal.Title>Cunning Action: Hide</Modal.Title></Modal.Header>
        <Modal.Body>
          Are you Heavily Obscured or behind Three-Quarters or Total Cover, and out of every enemy&apos;s line of sight?
          <div className="small text-muted mt-2">RealmTracker cannot evaluate cover or line of sight. Your confirmation records the table/DM judgment; you must still succeed on a DC 15 Dexterity (Stealth) check.</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowHideConfirmation(false)}>Cancel</Button>
          <Button disabled={!cunningActionAvailable || cunningActionPending} onClick={() => { setShowHideConfirmation(false); executeCunningAction('hide'); }}>Yes — Roll Stealth</Button>
        </Modal.Footer>
      </Modal>
      <div
        ref={damageWrapperRef}
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '4px',
          width: '100%',
        }}
      >
        <div
          id="damageAmount"
          ref={damageAmountRef}
          style={damageAmountStyle}
          className={`${isDamageRollSurfaceVisible ? 'damage-roller--visible' : 'damage-roller--hidden'} ${
            isDamageRollResultVisible ? 'damage-roller--result-visible' : 'damage-roller--result-hidden'
          } ${pulseClass} ${isCritical ? 'critical-active' : ''} ${
            isFumble ? 'critical-failure' : ''
          }`}
        >
          <div className="attack-roll-controls damage-roller__controls">
            <span
              id="damageValue"
              className="visually-hidden"
              aria-hidden="true"
            >
              {damageValue}
            </span>
            <button
              type="button"
              className="visually-hidden"
              onClick={handleDamageClick}
              aria-pressed={isCritical}
              aria-label={
                isCritical
                  ? 'Critical damage roll enabled. Click to roll normally.'
                  : 'Click to enable a critical damage roll on your next roll.'
              }
            >
              Toggle critical damage roll
            </button>
            <div
              className="damage-roller__dice-wrapper"
              style={{
                width: `${resolvedDiceSize}px`,
                height: `${resolvedDiceSize}px`,
              }}
            >
              <div
                className="damage-roller__dice-area"
                aria-hidden="true"
                style={{
                  width: `${resolvedDiceSize}px`,
                  height: `${resolvedDiceSize}px`,
                }}
              >
                {!externalDiceSurface && <DamageDiceCanvas
                  dice={preparedDice}
                  diceColor={diceFaceColor}
                  instanceKey={characterId}
                  showOverlayDice={showOverlayDice}
                  diceAreaSize={resolvedDiceSize}
                />}
              </div>
            </div>
          </div>
        </div>
      </div>
      {(() => {
        const rollLogList = (
          <ul className="list-unstyled mb-0">
            {damageLog.map((entry, idx) =>
              entry.divider ? (
                <li key={idx} className="roll-separator" />
              ) : (
                <li key={idx}>
                  {entry.type === 'spell-healing' ? (
                    <div>
                      <strong>{entry.source}</strong>
                      {entry.formula && <div>Healing rolled: {entry.formula}</div>}
                      {(entry.recipients || [entry]).map((recipient, recipientIdx) => (
                        <div key={recipientIdx}>{recipient.targetName}: +{recipient.total} HP ({recipient.hpBefore} → {recipient.hpAfter}){recipient.healingBlocked ? ' · Healing blocked by Chill Touch' : Number.isFinite(entry.rolledTotal) && recipient.total < entry.rolledTotal ? ' · stops at maximum HP' : ''}</div>
                      ))}
                      {entry.note && <div>{entry.note}</div>}
                    </div>
                  ) : entry.type === 'spell-save-resolution' ? (
                    Array.isArray(entry.lines) && entry.lines.length > 0 ? (
                      <div className="damage-log__save">
                        <div><strong>{entry.lines[0]}</strong></div>
                        {entry.lines.slice(1).map((line, lineIdx) => <div key={lineIdx}>{line}</div>)}
                      </div>
                    ) : <div><strong>{entry.source}</strong><div>{entry.targetName}: save {entry.success ? 'succeeded' : 'failed'}; {entry.total} {entry.damageType || 'spell'} damage</div></div>
                  ) : entry.type === 'attack-resolution' ? (
                    <div className="attack-resolution-log">
                      <div><strong>{[entry.attackName, entry.targetName].filter(Boolean).join(' → ') || 'Attack'} · {entry.outcome === 'critical-hit' ? 'Critical Hit' : entry.outcome === 'hit' ? 'Hit' : entry.grazeApplied ? 'Miss (Graze)' : 'Miss'}</strong></div>
                      <div>Attack: {entry.attackTotal}{Number.isFinite(entry.naturalRoll) ? ` (d20 ${entry.naturalRoll}${entry.naturalRoll === 20 ? ', natural 20' : ''})` : ''} vs AC {entry.targetArmorClass}{entry.cover ? ` (${entry.cover.label} +${entry.cover.bonus})` : ''}{entry.rollMode && entry.rollMode !== 'normal' ? ` · ${entry.rollMode}` : ''}</div>
                      {describeAttackResolution(entry).map((line, lineIdx) => <div key={lineIdx}>{line}</div>)}
                    </div>
                  ) : Array.isArray(entry.parts) && entry.parts.length > 0 ? (
                    <div>
                      <div>{entry.source || 'Damage'}{entry.critical ? ' · Critical' : ''} - ({entry.total})</div>
                      {entry.expression && <div>{entry.actionLabel ? `${entry.actionLabel} - ` : ''}({entry.expression})</div>}
                      {entry.parts.map((part, partIdx) => (
                        <div key={partIdx}>- {describeDamagePart({ ...part, type: '' })}{part.type ? <> <span className={`damage-${normalizeDamageTypeForClass(part.type)}`}>{part.type}</span></> : null}</div>
                      ))}
                    </div>
                  ) : <div>
                    {entry.source ? (
                      <>


                        {entry.source}
                        {entry.total !== undefined && entry.total !== null
                          ? ` - (${entry.total})`
                          : ''}
                      </>
                    ) : (
                      entry.total
                    )}
                  </div>}
                  {entry.strokeOfLuck ? <div>Stroke of Luck: the d20 became a 20</div>
                    : Number.isInteger(entry.luckD20) && entry.luckD20 < 20 && canUseStrokeOfLuck(form) && (
                      <Button size="sm" variant="outline-light" className="mt-1" onClick={() => spendStrokeOfLuckOn(entry)}>Stroke of Luck · make the d20 a 20</Button>)}
                  {entry.heroicInspiration ? <div>Heroic Inspiration: rerolled the d20 ({entry.heroicInspiration.from} → {entry.heroicInspiration.to})</div>
                    : entry.heroicReroll && !entry.strokeOfLuck && hasHeroicInspiration(form) && (
                      <Button size="sm" variant="outline-light" className="mt-1" onClick={() => spendHeroicInspirationOn(entry)}>Reroll · Heroic Inspiration</Button>)}
                  {entry.fate ? <div>Boon of Fate: +{entry.fate.bonus} (2d4: {entry.fate.rolls.join(', ')})</div>
                    : entry.heroicReroll && canUseFate(form) && (
                      <Button size="sm" variant="outline-light" className="mt-1" onClick={() => spendFateOn(entry)}>+2d4 · Boon of Fate</Button>)}
                  {entry.type !== 'attack-resolution' && entry.bardicDie ? <div>Bardic Inspiration: +{entry.bardicDie.bonus} (d{entry.bardicDie.sides})</div>
                    : entry.heroicReroll && heldBardicDie(form) && (
                      <Button size="sm" variant="outline-light" className="mt-1" onClick={() => spendBardicDieOn(entry)}>+d{heldBardicDie(form).sides} · Bardic Inspiration</Button>)}
                  {entry.type !== 'attack-resolution' && entry.peerlessSkill ? <div>Peerless Skill: +{entry.peerlessSkill.bonus} (d{entry.peerlessSkill.sides}){entry.peerlessSkill.spent ? '' : ', use kept'}</div>
                    : entry.heroicReroll && entry.rollLabel !== 'Saving Throw' && canUsePeerlessSkill(form, charismaModifier) && (
                      <Button size="sm" variant="outline-light" className="mt-1" onClick={() => spendPeerlessSkillOn(entry)}>+d{getBardicInspirationProfile(form, charismaModifier).sides} · Peerless Skill</Button>)}
                  {!(Array.isArray(entry.parts) && entry.parts.length > 0) && !['attack-resolution', 'spell-healing', 'spell-save-resolution'].includes(entry.type) && ((entry.expression) ||
                  entry.breakdown ||
                  (Array.isArray(entry.rollValues) && entry.rollValues.length > 0) ||
                  (Array.isArray(entry.modifierValues) && entry.modifierValues.length > 0)) ? (
                    <div>
                      {entry.expression && (
                        <div>{entry.actionLabel ? `${entry.actionLabel} - (${entry.expression})` : `(${entry.expression})`}</div>
                      )}
                      {(() => {
                        const breakdownSegments = parseDamageBreakdownSegments(
                          entry.breakdown,
                          normalizeDamageTypeForClass,
                        );
                        const modifierValues = Array.isArray(entry.modifierValues)
                          ? entry.modifierValues.filter(
                              (value) => typeof value === 'string' && value.trim(),
                            )
                          : [];
                        const diceRollDetails = Array.isArray(entry.diceRollDetails)
                          ? entry.diceRollDetails
                          : [];

                        const shouldShowGroupedSegments =
                          breakdownSegments.length > 0 &&
                          (diceRollDetails.length > 0 || modifierValues.length > 0);

                        if (shouldShowGroupedSegments) {
                          const diceGroups = groupDiceRollsByType(
                            diceRollDetails,
                            normalizeDamageTypeForClass,
                          );
                          let remainingModifiers = [...modifierValues];

                          return breakdownSegments.map((segment, segmentIdx) => {
                            const key = segment.normalizedType || DEFAULT_DAMAGE_TYPE_KEY;
                            const diceForType = diceGroups.get(key) || [];
                            const assignedDice = diceForType.splice(0, diceForType.length);

                            const detailItems = [];

                            assignedDice.forEach((detail, dieIdx) => {
                              const numericValue = Number(detail?.value);
                              if (!Number.isFinite(numericValue)) {
                                return;
                              }

                              detailItems.push(
                                <div
                                  key={`segment-${segmentIdx}-die-${dieIdx}`}
                                  className="damage-log__segment-detail"
                                >
                                  - {numericValue}
                                </div>
                              );
                            });

                            if (segmentIdx === 0 && remainingModifiers.length > 0) {
                              const appliedModifiers = remainingModifiers.splice(
                                0,
                                remainingModifiers.length,
                              );
                              appliedModifiers.forEach((modifier, modIdx) => {
                                detailItems.push(
                                  <div
                                    key={`segment-${segmentIdx}-modifier-${modIdx}`}
                                    className="damage-log__segment-detail"
                                  >
                                    - {modifier}
                                  </div>
                                );
                              });
                            }

                            return (
                              <div
                                key={`breakdown-${segmentIdx}`}
                                className="damage-log__segment"
                              >
                                <div>
                                  -{' '}
                                  <span className={segment.className}>{segment.text}</span>
                                </div>
                                {detailItems.length > 0 && (
                                  <div className="damage-log__segment-details">
                                    {detailItems}
                                  </div>
                                )}
                              </div>
                            );
                          });
                        }

                        const fallbackSegments = breakdownSegments.length
                          ? breakdownSegments
                          : parseDamageBreakdownSegments(
                              entry.breakdown,
                              normalizeDamageTypeForClass,
                            );

                        return (
                          <>
                            {fallbackSegments.map((segment, i) => (
                              <div key={`breakdown-${i}`}>
                                -{' '}
                                <span className={segment.className}>{segment.text}</span>
                              </div>
                            ))}
                            {Array.isArray(entry.rollValues) &&
                              entry.rollValues.map((value, rollIdx) => (
                                <div key={`roll-${rollIdx}`}>- {value}</div>
                              ))}
                            {Array.isArray(entry.modifierValues) &&
                              entry.modifierValues.map((value, modIdx) => (
                                <div key={`mod-${modIdx}`}>- {value}</div>
                              ))}
                          </>
                        );
                      })()}
                    </div>
                  ) : null}
                </li>
              )
            )}
          </ul>
        );
        // On the player HUD the log is a tab above the stat pills; elsewhere it stays a modal.
        return logAsTab ? (
          <RollLogTab open={showLog} onOpenChange={setShowLog} count={damageLog.filter((entry) => !entry.divider).length}>{rollLogList}</RollLogTab>
        ) : (
          <Modal centered show={showLog} onHide={() => setShowLog(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Log</Modal.Title>
            </Modal.Header>
            <Modal.Body>{rollLogList}</Modal.Body>
          </Modal>
        );
      })()}
      <DiceRollerModal
        show={showDiceRoller}
        onHide={handleCloseDiceRoller}
        onRollComplete={handleDiceRollComplete}
        diceColor={diceFaceColor}
      />
      <FeatureDecisionModal decision={featureDecision} onChoose={finishFeatureDecision} />
{/* Attack Modal */}

      <Modal
        size="xl"
        className="dnd-modal modern-modal combat-arsenal-modal"
        centered
        scrollable
        show={showAttack}
        onHide={handleCloseAttack}
      >
        <Card className="modern-card combat-arsenal">
          <Card.Header className="combat-arsenal__header">
            <div>
              <span className="combat-arsenal__eyebrow">Combat Arsenal</span>
              <Card.Title className="combat-arsenal__title">Attacks</Card.Title>
              <p className="combat-arsenal__subtitle">Choose, inspect, favorite, and roll without leaving the fight.</p>
            </div>
            <div className="combat-arsenal__search-wrap">
              <i className="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
              <input
                className="combat-arsenal__search"
                type="search"
                value={attackSearch}
                onChange={(event) => setAttackSearch(event.target.value)}
                placeholder="Search attacks..."
                aria-label="Search attacks"
              />
            </div>
          </Card.Header>
          <Card.Body className="combat-arsenal__body">
            <div className="combat-arsenal__layout">
              <aside className="combat-arsenal__sidebar" aria-label="Attack categories">
                {[
                  ['all', 'All Attacks', '✦'], ['weapons', 'Weapons', '⚔️'], ['spells', 'Spells', '🔮'],
                  ['cantrips', 'Cantrips', '✨'], ['class', 'Class Abilities', '🌟'], ['racial', 'Racial Abilities', '🐉'],
                  ['unarmed', 'Unarmed', '👊'], ['improvised', 'Improvised', '🪨'], ['magic-items', 'Magic Items', '💎'],
                  ['favorites', 'Favorites', '⭐'],
                ].map(([key, label, icon]) => (
                  <button
                    key={key}
                    type="button"
                    className={`combat-category ${activeAttackCategory === key ? 'is-active' : ''}`}
                    onClick={() => {
                      setActiveAttackCategory(key);
                      if (key === 'favorites') setActiveAttackFilters((prev) => new Set([...prev, 'favorites']));
                    }}
                  >
                    <span>{icon}</span>{label}
                  </button>
                ))}
              </aside>
              <main className="combat-arsenal__main">
                <div className="combat-arsenal__toolbar">
                  <span>{visibleAttackItems.length} available actions</span>
                  <Form.Select
                    value={attackSort}
                    onChange={(event) => setAttackSort(event.target.value)}
                    aria-label="Sort attacks"
                    size="sm"
                  >
                    <option value="favorites">Favorites / Recent</option>
                    <option value="alpha">Alphabetical</option>
                    <option value="damage">Highest Damage</option>
                    <option value="accuracy">Most Accurate</option>
                    <option value="spellLevel">Spell Level</option>
                    <option value="weaponType">Weapon Type</option>
                  </Form.Select>
                </div>
                <div className="attack-card-grid combat-attack-grid">
                  {visibleAttackItems.length === 0 ? (
                    <div className="attack-card attack-card--empty combat-action-card">No attacks match your filters.</div>
                  ) : visibleAttackItems.map((item) => {
                    const pendingId = item.kind === 'weapon' || item.kind === 'unarmed' ? getWeaponAttackRollId(item.slot, item.weapon) : item.spell ? getSpellAttackRollId(item.spell) : item.id;
                    const hasPendingCritical = Boolean(pendingCriticalAttack?.isCriticalHit && pendingCriticalAttack?.attackId === pendingId);
                    return (
                      <article
                        key={item.id}
                        className={`attack-card combat-action-card combat-action-card--${item.kind} ${selectedAttack?.id === item.id ? 'is-selected' : ''} ${item.isFavorite ? 'is-favorite' : ''}`}
                        onClick={() => setSelectedAttackId(item.id)}
                      >
                        <div className="combat-action-card__topline"><span>{item.source}</span><span>{item.actionType}</span></div>
                        <div className="combat-action-card__hero">
                          <div className={`combat-action-card__icon${item.sacredWeapon ? ' combat-action-card__icon--sacred' : ''}`} aria-hidden="true">{item.icon}</div>
                          <div>
                            <h3>{item.name}</h3>
                            <p>{item.kind === 'spell' || item.kind === 'cantrip' ? item.school || 'Arcane attack' : item.damageType || 'Martial attack'}</p>
                          </div>
                        </div>
                        <div className="combat-action-card__stats">
                          <div><strong>{item.damageNode}</strong><span>Damage</span></div>
                          <div><strong>{item.attackBonus}</strong><span>Hit / DC</span></div>
                          <div><strong>{item.range}</strong><span>Range</span></div>
                        </div>
                        <div className="attack-card__details visually-hidden">
                          <div className="attack-card__row"><span className="attack-card__label">{item.kind === 'feature' ? 'Save DC' : 'Attack Bonus'}</span><span className="attack-card__value">{item.kind === 'feature' ? String(item.attackBonus).replace(/^DC\s*/, '') : item.attackBonus}</span></div>
                          {(item.kind === 'weapon' || item.kind === 'unarmed') && <div className="attack-card__meta-item"><span className="attack-card__meta-label">Weapon Type:</span><span className="attack-card__meta-value">{item.source}</span></div>}
                        </div>
                        <div className="combat-action-card__tags">
                          {(item.tags || []).slice(0, 5).map((tag, tagIndex) => <span key={`${item.id}-${tag}-${tagIndex}`}>{tag}</span>)}
                        </div>
                        <div className="combat-action-card__actions" onClick={(event) => event.stopPropagation()}>
                          {item.spell && spellCastBlockReason && <small>{spellCastBlockReason}</small>}
                          <Button type="button" variant="link" className={`combat-icon-button ${item.isFavorite ? 'is-active' : ''}`} onClick={() => toggleAttackFavorite(item.id)} aria-label={`Favorite ${item.name}`}>⭐</Button>
                          <Button type="button" variant="link" className="combat-icon-button" onClick={() => setSelectedAttackId(item.id)} aria-label={`Inspect ${item.name}`}>📖</Button>
                          {canPinAttack(item) && <Button type="button" variant="link" className="combat-favorite-button" aria-pressed={visibleAttackIds.includes(item.id)} onClick={() => toggleAttackTile(item)} aria-label={`${visibleAttackIds.includes(item.id) ? 'Remove' : 'Add'} ${item.name} ${visibleAttackIds.includes(item.id) ? 'from' : 'to'} action bar`}>{visibleAttackIds.includes(item.id) ? '− Action bar' : '+ Action bar'}</Button>}
                          {item.canAttackRoll && <Button disabled={Boolean(item.spell && spellCastBlockReason)} title={item.spell ? spellCastBlockReason : undefined} type="button" aria-label={item.directDefinition ? `Cast ${item.name}` : item.spell ? 'Roll spell attack' : 'Roll to hit'} className="combat-roll-button combat-roll-button--attack" onClick={() => runAttackRoll(item)}>{item.directDefinition ? '✨ Cast Spell' : '🎲 Roll Attack'}</Button>}
                          {item.ammunition?.recoverable > 0 && !isActiveTurn && <Button type="button" variant="outline-light" size="sm" className="combat-roll-button" aria-label={`Recover ${item.ammunition.recoverable} ${item.ammunition.label.toLowerCase()}`} title="After a fight: spend 1 minute to recover half the ammunition you used." onClick={() => recoverAmmunition()}>↺ Recover {item.ammunition.recoverable}</Button>}
                          {item.kind === 'weapon' && item.attackModes?.ordinaryAvailable && item.attackModes?.lightExtra && !item.lightExtraAttack && <Button type="button" aria-label={`Use ${item.name} for Light Extra Attack · ${item.attackModes.lightExtra.mode === 'nick' ? 'Nick' : 'Bonus Action'}`} className="combat-roll-button combat-roll-button--light" onClick={() => runLightAttackRoll(item)}>Light · {item.attackModes.lightExtra.mode === 'nick' ? 'Nick' : 'Bonus Action'}</Button>}
                          {item.buffDefinition && <Button type="button" disabled={Boolean(spellCastBlockReason)} title={spellCastBlockReason} aria-label={`Cast ${item.name}`} className="combat-roll-button" onClick={() => { setShowAttack(false); buffControlsRef.current?.start(item); }}>✨ Cast Spell</Button>}
                          {item.healingDefinition && <Button type="button" disabled={Boolean(spellCastBlockReason)} title={spellCastBlockReason} aria-label={`Cast ${item.name}`} className="combat-roll-button" onClick={() => { setShowAttack(false); healingControlsRef.current?.start(item); }}>✨ Cast Healing</Button>}
                          {item.authoritative && <Button type="button" disabled={Boolean(spellCastBlockReason)} title={spellCastBlockReason} aria-label={`Cast ${item.name}`} className="combat-roll-button" onClick={() => runDamageRoll(item)}>✨ Cast Spell</Button>}
                          {item.manualCast && <Button type="button" disabled={Boolean(spellCastBlockReason)} title={spellCastBlockReason || 'Spends the slot and Action; apply the effect at the table.'} aria-label={`Cast ${item.name}`} className="combat-roll-button" onClick={() => castManualSpell(item)}>✨ Cast Spell</Button>}
                          {item.breathWeapon && <Button type="button" aria-label={`Use ${item.name}`} className="combat-roll-button" onClick={() => runDamageRoll(item)}>🐉 Use Breath Weapon</Button>}
                          {item.smitePrompt && <small className="text-muted" title="Hit with a melee weapon or Unarmed Strike on your turn; the Smite prompt offers this spell.">Cast after a melee hit</small>}
                          {item.resolvableLegacy && <Button type="button" aria-label={`Resolve source for ${item.name}`} className="combat-roll-button" onClick={() => resolveLegacySpell(item.spell)}>Resolve Source</Button>}
                          {item.canDamageRoll && !item.directDefinition && !item.authoritative && !item.resolvableLegacy && <Button type="button" disabled={Boolean(item.spell && spellCastBlockReason)} title={item.spell ? spellCastBlockReason : undefined} aria-label={hasPendingCritical ? 'Roll critical damage' : 'Roll damage'} className={`combat-roll-button ${hasPendingCritical ? 'critical-active' : ''}`} onClick={() => runDamageRoll(item)}>💥 {hasPendingCritical ? 'Roll Critical' : 'Roll Damage'}</Button>}
                        </div>
                      </article>
                    );
                  })}
                </div>
              </main>
              <aside className="combat-inspector" aria-live="polite">
                {selectedAttack ? (
                  <>
                    <button
                      type="button"
                      className="combat-inspector__close"
                      onClick={() => setSelectedAttackId('')}
                      aria-label="Close attack preview"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                    <div className={`combat-inspector__art combat-inspector__art--${selectedAttack.kind}`}><span>{selectedAttack.icon}</span></div>
                    <div className="combat-inspector__preview">
                      <h3>{selectedAttack.name}</h3>
                      <div><span>{selectedAttack.attackBonus}</span><small>to Hit / DC</small></div>
                      <div><span>{selectedAttack.damageNode}</span><small>Damage</small></div>
                      <div><span>{selectedAttack.range}</span><small>Reach</small></div>
                    </div>
                    {selectedAttack.spell && spellCastBlockReason && <p>{spellCastBlockReason}</p>}
                    <p className="combat-inspector__description">{selectedAttack.source} • {selectedAttack.actionType}{selectedAttack.damageType ? ` • ${selectedAttack.damageType}` : ''}</p>
                    {(selectedAttack.kind === 'weapon' || selectedAttack.kind === 'unarmed') && (isFinesseWeapon(selectedAttack.weapon) || qualifiesForMonkDexterity(selectedAttack.weapon)) && (
                      <Form.Select size="sm" value={getAbilityKeyForWeapon(selectedAttack.slot, selectedAttack.weapon)} onChange={(event) => selectWeaponAbility(selectedAttack.slot, event.target.value)} aria-label={`Select ability for ${selectedAttack.name}`}>
                        <option value="str">Strength ({formatModifier(numericStrMod)})</option>
                        <option value="dex">Dexterity ({formatModifier(numericDexMod)})</option>
                      </Form.Select>
                    )}
                    <div className="combat-inspector__properties">
                      {(selectedAttack.properties || []).map(({ label, description }) => <div key={`${selectedAttack.id}-${label}`}><strong>{label}</strong><span>{description}</span></div>)}
                      {selectedAttack.kind === 'weapon' && selectedAttack.hasWeaponMastery && hasTacticalMaster(form) && (
                        <Form.Select size="sm" aria-label="Tactical Master" value={tacticalMasteryChoices[selectedAttack.id.replace(/:light-extra$/, '')] || ''}
                          onChange={(event) => setTacticalMasteryChoices((current) => ({ ...current, [selectedAttack.id.replace(/:light-extra$/, '')]: event.target.value || null }))}>
                          <option value="">Mastery: {(selectedAttack.mastery?.weaponMastery || selectedAttack.mastery)?.label} (weapon's own)</option>
                          {TACTICAL_MASTER_PROPERTIES.map((key) => <option key={key} value={key}>Tactical Master: {weaponMasteryDefinitions[key]?.label || key}</option>)}
                        </Form.Select>
                      )}
                      {selectedAttack.mastery && <div><strong>Mastery property: {selectedAttack.mastery.label}{selectedAttack.mastery.tacticalMaster ? ' (Tactical Master)' : ''}</strong><span>{selectedAttack.hasWeaponMastery ? `Usable — ${selectedAttack.mastery.description}` : 'Reference only — this character has not selected mastery with this weapon.'}</span></div>}
                      {(selectedAttack.tags || []).length === 0 && <div><strong>Properties</strong><span>No special properties listed.</span></div>}
                    </div>
                    <div className="combat-inspector__buttons">
                      {selectedAttack.canAttackRoll && <Button disabled={Boolean(selectedAttack.spell && spellCastBlockReason)} title={selectedAttack.spell ? spellCastBlockReason : undefined} type="button" aria-label={selectedAttack.directDefinition ? `Cast ${selectedAttack.name}` : selectedAttack.spell ? 'Roll spell attack' : 'Roll to hit'} className="combat-roll-button combat-roll-button--attack" onClick={() => runAttackRoll(selectedAttack)}>{selectedAttack.directDefinition ? '✨ Cast Spell' : '🎲 Roll Attack'}</Button>}
                      {selectedAttack.kind === 'weapon' && selectedAttack.attackModes?.ordinaryAvailable && selectedAttack.attackModes?.lightExtra && !selectedAttack.lightExtraAttack && <Button type="button" aria-label={`Use ${selectedAttack.name} for Light Extra Attack · ${selectedAttack.attackModes.lightExtra.mode === 'nick' ? 'Nick' : 'Bonus Action'}`} className="combat-roll-button combat-roll-button--light" onClick={() => runLightAttackRoll(selectedAttack)}>Light Extra · {selectedAttack.attackModes.lightExtra.mode === 'nick' ? 'Nick' : 'Bonus Action'}</Button>}
                      {selectedAttack.buffDefinition && <Button type="button" disabled={Boolean(spellCastBlockReason)} title={spellCastBlockReason} aria-label={`Cast ${selectedAttack.name}`} className="combat-roll-button" onClick={() => { setShowAttack(false); buffControlsRef.current?.start(selectedAttack); }}>✨ Cast Spell</Button>}
                      {selectedAttack.healingDefinition && <Button type="button" disabled={Boolean(spellCastBlockReason)} title={spellCastBlockReason} aria-label={`Cast ${selectedAttack.name}`} className="combat-roll-button" onClick={() => { setShowAttack(false); healingControlsRef.current?.start(selectedAttack); }}>✨ Cast Healing</Button>}
                      {selectedAttack.manualCast && <Button type="button" disabled={Boolean(spellCastBlockReason)} title={spellCastBlockReason || 'Spends the slot and Action; apply the effect at the table.'} aria-label={`Cast ${selectedAttack.name}`} className="combat-roll-button" onClick={() => { setSelectedAttackId(''); castManualSpell(selectedAttack); }}>✨ Cast Spell</Button>}
                      {selectedAttack.smitePrompt && <small className="text-muted">Cast after a melee hit: the Smite prompt offers this spell.</small>}
                      {selectedAttack.breathWeapon && <Button type="button" aria-label={`Use ${selectedAttack.name}`} className="combat-roll-button" onClick={() => runDamageRoll(selectedAttack)}>🐉 Use Breath Weapon</Button>}
                      {selectedAttack.authoritative && <Button type="button" disabled={Boolean(spellCastBlockReason)} title={spellCastBlockReason} aria-label={`Cast ${selectedAttack.name}`} className="combat-roll-button" onClick={() => runDamageRoll(selectedAttack)}>✨ Cast Spell</Button>}
                      {selectedAttack.resolvableLegacy && <Button type="button" aria-label={`Resolve source for ${selectedAttack.name}`} className="combat-roll-button" onClick={() => resolveLegacySpell(selectedAttack.spell)}>Resolve Source</Button>}
                      {selectedAttack.canDamageRoll && !selectedAttack.directDefinition && !selectedAttack.authoritative && !selectedAttack.resolvableLegacy && <Button type="button" disabled={Boolean(selectedAttack.spell && spellCastBlockReason)} title={selectedAttack.spell ? spellCastBlockReason : undefined}  aria-label="Roll damage" className="combat-roll-button" onClick={() => runDamageRoll(selectedAttack)}>💥 Roll Damage</Button>}
                      <Button type="button" variant="link" className={`combat-favorite-button ${selectedAttack.isFavorite ? 'is-active' : ''}`} onClick={() => toggleAttackFavorite(selectedAttack.id)}>⭐ Favorite</Button>
                      {canPinAttack(selectedAttack) && <Button type="button" variant="link" aria-pressed={visibleAttackIds.includes(selectedAttack.id)} onClick={() => toggleAttackTile(selectedAttack)}>{visibleAttackIds.includes(selectedAttack.id) ? 'Remove from action bar' : 'Add to action bar'}</Button>}
                    </div>
                  </>
                ) : <p className="text-muted">Select an attack to inspect its combat profile.</p>}
              </aside>
            </div>
          </Card.Body>
          <Card.Footer className="modal-footer combat-arsenal__footer">
            <Button className="close-btn" variant="secondary" onClick={handleCloseAttack}>Close Arsenal</Button>
          </Card.Footer>
        </Card>
      </Modal>
      <Modal centered show={Boolean(legacySpellResolution)} onHide={() => legacySpellResolution?.status !== 'saving' && setLegacySpellResolution(null)}>
        <Modal.Header closeButton><Modal.Title>Resolve {legacySpellResolution?.spell?.name || 'Spell'} Source</Modal.Title></Modal.Header>
        <Modal.Body>
          {legacySpellResolution?.status === 'saving' && <p role="status">Validating owned casting sources…</p>}
          {legacySpellResolution?.status === 'ambiguous' && <><p>Choose casting source:</p><div className="d-grid gap-2">{legacySpellResolution.candidates.map((candidate) => <Button key={candidate.sourceId} onClick={() => resolveLegacySpell(legacySpellResolution.spell, candidate.sourceId)}>{candidate.sourceId.charAt(0).toUpperCase() + candidate.sourceId.slice(1)}</Button>)}</div></>}
          {legacySpellResolution?.error && <div className="alert alert-danger" role="alert">{legacySpellResolution.error}</div>}
        </Modal.Body>
      </Modal>
      {multiCast && <SpellControlsBar label={multiCast.name}
        hint={multiCastRunning ? 'Rolling attack…' : multiCast.pending?.uncertain ? 'Dice interrupted · DM verification needed' : 'Choose one target · resolve its attack, then choose the next'}
        count={multiCast.completed} maximum={multiCast.count}
        countLabel={`${multiCast.completed} of ${multiCast.count} attacks resolved`}
        error={multiCast.error}
        actions={multiCast.pending?.uncertain && !multiCastRunning && !multiCast.multiattack ? <button className={spellControlStyles.undo} onClick={() => {
          if (multiCastLockRef.current) return;
          const next = { ...multiCast, completed: multiCast.completed + 1, pending: null, error: null };
          if (next.completed < next.count) { saveMultiCast(next); selectMultiCastTarget(next); } else { saveMultiCast(null);if(multiCast.multiattackStepId)onSpellCastProgress({type:'complete',multiattackStepId:multiCast.multiattackStepId,manuallyVerified:true}); }
        }}>DM verified — mark attack resolved</button> : <button className={spellControlStyles.cast} disabled={multiCastRunning} onClick={() => { if (!multiCastLockRef.current) selectMultiCastTarget(multiCast); }}>
          ✦ {multiCastRunning ? 'Rolling attack…' : multiCast.pending ? 'Retry current attack' : 'Choose next target'}</button>}
      />}
      {pendingSpellRider && !multiCast && <SpellControlsBar label={pendingSpellRider.name} hint="Damage saved · effect needs retrying" error={pendingSpellRider.error}
        actions={<button className={spellControlStyles.cast} onClick={() => applyDirectSpellRider(pendingSpellRider)}>Retry spell effect</button>} />}
      <UpcastModal compact show={Boolean(directSpellSelection)} onHide={() => setDirectSpellSelection(null)}
        title={`Cast ${directSpellSelection?.name || 'Spell'}`} baseLevel={directSpellSelection?.directDefinition?.level}
        slots={availableSlots} describeLevel={level => directSpellSelection?.directDefinition?.multiAttack ? `${level + 1} rays · 2d6 fire each` : directSpellSelection?.directDefinition ? directSpellDamage(directSpellSelection.directDefinition, totalLevel, level) : ''}
        higherLevels="Choose the spell slot to spend. The slot and Action are spent when you confirm a legal target, even if the attack misses."
        onSelect={async (castLevel, type) => {
          const selected = directSpellSelection; if (!selected) return;
          let damageType;
          if (selected.directDefinition?.damageTypes) {
            setDirectSpellSelection(null);
            damageType = await chooseSpellDamageType(selected);
            if (!damageType) return;
          }
          directSpellChoicesRef.current[selected.id] = { castLevel, pool: type === 'warlock' ? 'pactMagic' : 'spellcasting', ...(damageType ? { damageType } : {}) };
          if (selected.directDefinition?.multiAttack) beginMultiCast(selected, directSpellChoicesRef.current[selected.id]);
          else onBeginTargeting({ sourceCombatantId: characterId, actionType: 'attack', attackId: selected.id });
          setDirectSpellSelection(null); setShowAttack(false);
        }} />
      <UpcastModal
        show={showUpcast}
        onHide={() => setShowUpcast(false)}
        baseLevel={pendingSpell?.spell?.level}
        slots={availableSlots}
        onSelect={async (lvl, type) => {
          if (pendingSpell) {
            await applyUpcast(pendingSpell.spell, lvl, pendingSpell.crit, type);
            setPendingSpell(null);
          }
          setShowUpcast(false);
        }}
      />
      {chainPrompt && <ChainTargetPrompt {...chainPrompt} />}
      <UpcastModal compact show={Boolean(manualSpell)} onHide={() => setManualSpell(null)} title={`Cast ${manualSpell?.name || 'Spell'}`}
        baseLevel={Number(manualSpell?.spell?.level) || 1} slots={availableSlots}
        higherLevels="Spends the slot and the spell's casting time. RealmTracker doesn't automate this spell's effect; apply it at the table."
        onSelect={async (slotLevel, slotType) => { const item = manualSpell; setManualSpell(null); if (item) await sendManualCast(item, { slotLevel, slotType }); }} />
      <UpcastModal show={saveDamageCast?.status === 'choosing-level' && saveDamageCast.definition.level > 0} onHide={() => setSaveDamageCast((current) => {
        if (current?.status !== 'choosing-level') return current;
        saveDamageCastIntentRef.current = null;
        return null;
      })}
        title={`Cast ${saveDamageCast?.definition?.name || 'Spell'}`} baseLevel={saveDamageCast?.definition?.level} slots={availableSlots} onSelect={chooseSaveDamageCastLevel}
        compact
        higherLevels="Choose casting level and the slot pool that will fund it."
        describeLevel={(level) => saveDamageCast?.definition?.id === 'spell:conjure-woodland-beings' ? `${level + 1}d8 force` : saveDamageCast?.definition?.id === 'spell:spirit-guardians' ? `${level}d8 ${saveDamageCast.damageType}` : saveDamageCast?.definition?.id === 'spell:call-lightning' ? `${level + (saveDamageCast.storm ? 1 : 0)}d10 lightning` : saveDamageCast?.definition?.id === 'spell:insect-plague' ? `${level - 1}d10 piercing` : saveDamageCast?.definition?.id === 'spell:cloudkill' ? `${level}d8 poison` : saveDamageCast?.definition?.id === 'spell:moonbeam' ? `${level}d10 radiant` : saveDamageCast?.definition?.id === 'spell:web' ? 'Web does not scale with higher slots.' : saveDamageCast?.definition?.level > 0 ? formatCastLevelDamage(saveDamageCast.definition, level) : ''}>
        {saveDamageCast?.status === 'choosing-level' && FOLLOWING_AURAS.includes(saveDamageCast.definition.id) && <div className="alert alert-info">
          <p>{saveDamageCast.definition.targeting.radiusFeet}-foot aura follows your token. Choose creatures to exclude; everyone else is affected. No save on casting.</p>
          {saveDamageCast.definition.id === 'spell:spirit-guardians' && <><label>Damage type <select aria-label="Spirit Guardians damage type" value={saveDamageCast.damageType} disabled={/good|neutral|evil/i.test(String(form.alignment || ''))} onChange={event => {
            const damageType = event.target.value; saveDamageCastIntentRef.current = { ...saveDamageCastIntentRef.current, damageType }; setSaveDamageCast(current => ({ ...current, damageType }));
          }}><option value="radiant">Radiant (good or neutral)</option><option value="necrotic">Necrotic (evil)</option></select></label>
          <small className="d-block">Damage follows your alignment; if it is unset, confirm it with the DM. Elevation and walls are tracked manually.</small></>}
          <fieldset><legend className="fs-6">Unaffected creatures</legend>
            {(combatState?.participants || []).filter(p => String(p.characterId || p.enemyId || '') !== String(characterId)).map(p => {
              const id = String(p.characterId || p.enemyId || '');
              const details = combatants.find(combatant => String(combatant.characterId || combatant.enemyId || '') === id);
              const name = [details?.characterName, details?.name, details?.displayName, p.characterName, p.name, p.displayName]
                .find(value => typeof value === 'string' && value.trim() && value.trim() !== id)?.trim() || id;
              return <label className="d-block" key={id}><input type="checkbox" checked={saveDamageCast.excludedCombatantIds.includes(id)} onChange={event => {
                const excludedCombatantIds = event.target.checked ? [...saveDamageCast.excludedCombatantIds, id] : saveDamageCast.excludedCombatantIds.filter(value => value !== id);
                saveDamageCastIntentRef.current = { ...saveDamageCastIntentRef.current, excludedCombatantIds }; setSaveDamageCast(current => ({ ...current, excludedCombatantIds }));
              }} /> {combatantName(id, name)}</label>;
            })}
          </fieldset>
        </div>}
        {saveDamageCast?.status === 'choosing-level' && saveDamageCast.definition.id === 'spell:call-lightning' && <div className="alert alert-info">
          <label><input type="checkbox" checked={saveDamageCast.storm === true} onChange={event => {
            const storm = event.target.checked; saveDamageCastIntentRef.current = { ...saveDamageCastIntentRef.current, storm };
            setSaveDamageCast(current => ({ ...current, storm }));
          }} /> Outdoors in an existing storm (+1d10; confirm weather with the DM).</label>
          <small className="d-block">Place the cloud, then choose the first strike. Visibility and cloud elevation are tracked manually.</small>
        </div>}
        {saveDamageCast?.status === 'choosing-level' && saveDamageCast.definition.id === 'spell:web' && <div className="alert alert-info" role="status">
        <label><input type="checkbox" checked={saveDamageCast.supported !== false} onChange={event => {
          const supported = event.target.checked;
          saveDamageCastIntentRef.current = { ...saveDamageCastIntentRef.current, supported };
          setSaveDamageCast(current => ({ ...current, supported }));
        }} /> Web is anchored or layered across a surface. Uncheck for unsupported webs that collapse on your next turn.</label>
      </div>}
      </UpcastModal>
      {saveDamageCast?.error && <div className="alert alert-danger" role="alert">{saveDamageCast.error}<Button onClick={() => resolveSaveDamageCast()}>Retry spell resolution</Button></div>}
    </div>
  );
});

export default PlayerTurnActions;


